import React, { useState, useEffect, useRef } from "react";
import SignatureCanvas from "react-signature-canvas";
import { FaPlus, FaTrash, FaEye } from "react-icons/fa";
import Swal from "sweetalert2";
import axios from "axios";
import { baseurl, baseurImage } from "../../Baseurl";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import pdfImg from "../../assests/form-bg.jpg";
import originalMedical from "../../assests/originalMedical.png";
import sleave from "../../assests/sleave.png";
import logo from "../../assests/Image.jpg";
import AMAForm from "./Forms/AMAForm";
import ReferralForm from "./Forms/ReferralForm";
import MedicalCertificateForm from "./Forms/MedicalCertificateForm";
import SickLeaveForm from "./Forms/SickLeaveForm";
import HouseMaidHealthCheckupForm from "./Forms/HouseMaidHealthCheckupForm";
import HealthFitnessCertificateForm from "./Forms/HealthFitnessCertificateForm";
import formRegistry from "./Forms/formRegistry";
// import pdfimg3 from "../../assests/pdfimg3.jpg";
import pdfimg3 from "../../assests/pdfimg3.png";
import logo1 from "../../assests/logo.png";
import pdfHealth from "../../assests/pdfHealth.jpg";
import pdfHouse from "../../assests/pdfHouse.jpg";
import axiosInstance from "../../api/axiosInstance";
import { setupDirectionSupport, setBlockDirection, getBlockDirection } from "../../utils/ckeditorDirection";
import { isAdmin } from "../../utils/permissions";
import { drawBidiParagraphs, drawBidiText, containsArabic, registerArabicFont, ARABIC_FONT_NAME } from "../../utils/pdfArabic";
import { tajawalFontBase64 } from "../../assests/font/tajawalFont";

const _ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
  "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
const _tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
function numberToWords(n) {
  const num = parseInt(n, 10);
  if (!n || isNaN(num) || num < 0) return "";
  if (num === 0) return "Zero";
  if (num < 20) return _ones[num];
  if (num < 100) return _tens[Math.floor(num / 10)] + (num % 10 ? " " + _ones[num % 10] : "");
  if (num < 1000) return _ones[Math.floor(num / 100)] + " Hundred" + (num % 100 ? " " + numberToWords(num % 100) : "");
  return num.toString();
}

export default function PatientForms({ patientId }) {
  // Helper function to extract date from datetime string (handles both 'T' and space separator)
  const extractDateFromDateTime = (dateTimeString) => {
    if (!dateTimeString) return "";
    // Handle both "2026-01-06T09:28:52" and "2026-01-06 09:28:52" formats
    return dateTimeString.split("T")[0].split(" ")[0];
  };
  const [showAddFormModal, setShowAddFormModal] = useState(false);
  const [selectedFormType, setSelectedFormType] = useState("");
  const [forms, setForms] = useState([]);
  const [showFormView, setShowFormView] = useState(false);
  const [patientData, setPatientData] = useState(null);
  const [medicalHistory, setMedicalHistory] = useState(null);
  const [allVitalsRecords, setAllVitalsRecords] = useState([]);
  const [allMedicalRecords, setAllMedicalRecords] = useState([]);
  const [businessLogo, setBusinessLogo] = useState(logo1);
  const DrData = JSON.parse(localStorage.getItem("userMedical"));
  // Get website from business settings
  const businessSetting = JSON.parse(localStorage.getItem("businessSetting"));
  const website = businessSetting?.website || "";
  const [businessOfficialName, setBusinessOfficialName] = useState(
    "Serenity Medical Center"
  );
  const [businessOfficialNameArabic, setBusinessOfficialNameArabic] = useState(
    "مركز سيرينيتي الطبي"
  );
  const [businessEmail, setBusinessEmail] = useState("");
  const [businessAddress, setBusinessAddress] = useState("");
  const [businessPhone, setBusinessPhone] = useState("");
  const [doctorName, setDoctorName] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [editingFormId, setEditingFormId] = useState(null);
  const [isViewOnly, setIsViewOnly] = useState(false);
  const [diagnosisOptions, setDiagnosisOptions] = useState([]);
  const [diagnosisSearch, setDiagnosisSearch] = useState("");
  const [showDiagnosisDropdown, setShowDiagnosisDropdown] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const formsPerPage = 10;
  const [currentDoctorSigStamp, setCurrentDoctorSigStamp] = useState({ signature: null, stamp: null });
  const [recordLockHours, setRecordLockHours] = useState(null);
  const [consentTemplates, setConsentTemplates] = useState([]);
  const [consentForm, setConsentForm] = useState({
    templateId: null, templateName: "", title: "", content: "",
    patientName: "", fileNo: "", cprNo: "", ageSex: "",
    createdBy: "", createdAt: "", patientSignature: "", userSignature: "",
  });
  const consentEditorRef = useRef(null);
  const consentEditorInstanceRef = useRef(null);
  const [consentEditorDir, setConsentEditorDir] = useState(null);
  const patientSigRef = useRef(null);
  const userSigRef = useRef(null);
  const [customFormTemplates, setCustomFormTemplates] = useState([]);
  const [customForm, setCustomForm] = useState({
    templateId: null, templateName: "", title: "", content: "",
    patientName: "", fileNo: "", cprNo: "", ageSex: "",
    createdBy: "", createdAt: "",
  });
  const customFormEditorRef = useRef(null);
  const customFormEditorInstanceRef = useRef(null);

  useEffect(() => {
    axiosInstance.get('getBusinessSettings')
      .then(res => {
        const h = res.data?.data?.record_lock_hours
        if (h != null) setRecordLockHours(Number(h))
      })
      .catch(() => {})
  }, [])

  useEffect(() => {
    const fetchDoctorSigStamp = async () => {
      try {
        const doctorId = DrData?.data?.id;
        if (!doctorId) return;
        const res = await axiosInstance.get("getAllDoctors");
        if (res.data?.success) {
          const found = (res.data.data || []).find((d) => d.id === doctorId);
          if (found) {
            setCurrentDoctorSigStamp({ signature: found.signature || null, stamp: found.stamp || null });
          }
        }
      } catch (_) {}
    };
    fetchDoctorSigStamp();
  }, []);

  const getLoggedInDoctorInfo = () => {
    try {
      const userMedical = localStorage.getItem("userMedical");
      if (!userMedical)
        return { name: "", license: "", specialty: "", phone: "" };
      const DrData = JSON.parse(userMedical);
      const name = (
        (DrData?.data?.prefix || "") +
        " " +
        (DrData?.data?.fullName || "") +
        " " +
        (DrData?.data?.shortName || "")
      ).trim();
      return {
        name: name,
        license: DrData?.data?.licenseId || "",
        specialty: DrData?.data?.specialty || "",
        phone: DrData?.data?.phoneNumber || DrData?.data?.mobileNumber || "",
      };
    } catch (error) {
      console.error("Error getting logged in doctor info:", error);
      return { name: "", license: "", specialty: "", phone: "" };
    }
  };

  /**
   * Identifies fields that come from patient master data and should never be editable
   */
  const isPatientInfoField = (formType, fieldName) => {
    const patientInfoFields = {
      AMA: ["patientName", "fileNo", "date", "cprNo", "physician", "ageSex"],
      referral: ["patientName", "cpr", "age", "sex", "nationality", "mobileNumber", "phoneNo"],
      houseMaidHealthCheckup: ["patientName", "mobileNumber", "civilId"],
      medicalCertificate: ["patientName", "cprNumber", "medicalRecordNumber"],
      accompanyingCertificate: ["patientName", "cprNumber", "medicalRecordNumber"],
      sickLeave: ["patientName", "cprNumber", "medicalRecordNumber"],
      healthFitnessCertificate: ["name", "cprNumber"],
    };

    // Normalize formType
    const type = formType === "ama" ? "AMA" : formType;
    return patientInfoFields[type]?.includes(fieldName) || false;
  };

  /**
   * Identifies fields that are auto-filled from vitals or medical records APIs
   */
  const isApiFilledField = (formType, fieldName) => {
    const apiFilledFields = {
      referral: [
        "chiefComplain",
        "generalExamination",
        "localExamination",
        "procedureInterventions",
        "prescriptionGiven",
        "notes",
        "advices",
        "vitalSigns.bp",
        "vitalSigns.temperature",
        "vitalSigns.pulse",
        "vitalSigns.weight",
        "vitalSigns.respiratoryRate",
        "vitalSigns.spo2",
        "vitalSigns.rbs",
      ],
      houseMaidHealthCheckup: [
        "bloodPressure",
        "pulse",
        "heightCm",
        "weight",
        "bmi",
      ],
    };

    return apiFilledFields[formType]?.includes(fieldName) || false;
  };

  /**
   * Determines if a field should be disabled based on its type and value
   */
  const shouldDisableField = (formType, fieldName, fieldValue) => {
    if (isViewOnly) return true;

    // Patient info fields are always disabled in both add and edit modes
    if (isPatientInfoField(formType, fieldName)) return true;

    // API filled fields are disabled in edit mode (or when they have value in add mode)
    // to ensure they only come from the intended API sources
    if (isApiFilledField(formType, fieldName)) {
      // If we are editing, these must not be changed
      if (editingFormId) return true;

      // If we are adding and they have been auto-filled, disable them
      if (fieldValue) return true;
    }

    return false;
  };

  /**
   * Returns styles for disabled auto-filled fields
   */
  const getFieldStyle = (formType, fieldName, fieldValue) => {
    if (shouldDisableField(formType, fieldName, fieldValue) && !isViewOnly) {
      return { backgroundColor: "#e9ecef", cursor: "not-allowed" };
    }
    return {};
  };






  // Load business logo and name from localStorage on component mount
  useEffect(() => {
    const loadFromLocalStorage = async () => {
      // Load official name
      const savedSetting = JSON.parse(localStorage.getItem("businessSetting"));
      const storedOfficialName = savedSetting?.official_name?.trim() || "";
      const storedOfficialNameArabic =
        savedSetting?.official_name_arabic?.trim() || "";
      const storedEmail = savedSetting?.email || "";
      const storedPhone = savedSetting?.telephone_1 || "";
      const storedAddress = savedSetting?.address || "";
      // const website = savedSetting?.website || "";

      const loggedInUser = JSON.parse(localStorage.getItem("userMedical"));

      const loggedInUserSpecialty = loggedInUser?.specialty || "";
      const loggedInUserName = loggedInUser?.name || "";


      const businessSetting = JSON.parse(localStorage.getItem("businessSetting"));

      const website = businessSetting?.website;

      if (storedOfficialName) {
        setBusinessOfficialName(storedOfficialName);
      }

      if (storedOfficialNameArabic) {
        setBusinessOfficialNameArabic(storedOfficialNameArabic);
      }
      if (storedEmail) setBusinessEmail(storedEmail);
      if (storedPhone) setBusinessPhone(storedPhone);
      if (storedAddress) setBusinessAddress(storedAddress);

      // Load logo
      const savedSettinglogo = JSON.parse(
        localStorage.getItem("businessSetting")
      );
      const bgImage = savedSettinglogo?.base64Image;
      const img = savedSettinglogo?.image;
      const storedLogo = bgImage || img;

      if (storedLogo) {
        // Check if it's already a Base64 DataURL and is actually an image (not HTML error)
        if (
          storedLogo.startsWith("data:image/") &&
          storedLogo.includes("base64")
        ) {
          setBusinessLogo(storedLogo);
        } else if (storedLogo.startsWith("data:text/html")) {
          // This is an HTML error page, not an image - clear it
          console.warn("Found HTML error page in localStorage, clearing it");
          localStorage.removeItem("businessSettingImage");
        } else {
          // It's a filename or URL, convert it to Base64
          try {
            const imageUrl = storedLogo.startsWith("http")
              ? storedLogo
              : bgImage === storedLogo
              ? `${baseurImage}business_setting/${storedLogo}`
              : `${baseurImage}${storedLogo}`;
            const response = await fetch(imageUrl);

            // Check if response is actually an image
            const contentType = response.headers.get("content-type");
            if (!contentType || !contentType.startsWith("image/")) {
              console.warn(
                "Response is not an image, content-type:",
                contentType
              );
              localStorage.removeItem("businessSettingImage");
              return;
            }

            const blob = await response.blob();
            const reader = new FileReader();
            reader.onloadend = () => {
              setBusinessLogo(reader.result);
              // Also save the Base64 version to localStorage for future use
              localStorage.setItem("businessSettingImage", reader.result);
            };
            reader.readAsDataURL(blob);
          } catch (err) {
            console.warn("Failed to load logo from localStorage:", err);
            localStorage.removeItem("businessSettingImage");
          }
        }
      }
    };

    loadFromLocalStorage();
  }, []);

  const [amaForm, setAmaForm] = useState({
    patientName: "",
    fileNo: "",
    date: "",
    cprNo: "",
    physician: "",
    ageSex: "",
    recommendation: "",
    patientSignature: "",
    patientSignatureDate: "",
    witnessName: "",
    witnessSignature: "",
    witnessSignatureDate: "",
  });

  const [referralForm, setReferralForm] = useState({
    patientName: "",
    cpr: "",
    age: "",
    sex: "",
    nationality: "",
    mobileNumber: "",
    referralType: "internal",
    referralCategory: "urgent",
    reasonOfReferral: "",
    chiefComplain: "",
    summaryOfPresentation: "",
    physicalExamination: "",
    vitalSigns: {
      bp: "",
      temperature: "",
      pulse: "",
      weight: "",
      rbs: "",
      respiratoryRate: "",
      spo2: "",
    },
    vitalsId: "", // ID from vitals API
    glasgowComaScale: {
      eye: "",
      motorResponse: "",
      verbalResponse: "",
      totalScore: "",
    },
    generalExamination: "",
    localExamination: "",
    investigationsDone: "",
    procedureInterventions: "",
    injectionsMedications: "",
    prescriptionGiven: "",
    notes: "",
    advices: "",
    referringDoctor: { name: "", date: "", time: "", phoneNumber: "" },
    receivingDoctor: { name: "", date: "", time: "", phoneNumber: "" },
  });
  const [medicalCertificateForm, setMedicalCertificateForm] = useState({
    patientName: "",
    cprNumber: "",
    medicalRecordNumber: "",
    reportedSick: false,
    accompanyingPatient: false,
    accompanyingPersonName: "",
    accompanyingPersonId: "",
    timeOfAttend: new Date().toTimeString().slice(0, 5),
    timeOfConsult: new Date().toTimeString().slice(0, 5),
    consultDate: "",
    patientFitForDuty: false,
    patientUnfitForDuty: false,
    advisedLightDuty: false,
    patientNeedsEmployeeCare: false,
    noOfDaysOffFigures: "",
    noOfDaysOffWords: "",
    commencingOn: "",
    admittedOn: "",
    dischargedOn: "",
    diagnosis: "",
    diagnosisId: "",
    doctorName: "",
    licenseNo: "",
    specialty: "",
    issueDate: "",
    certificateRegistrationNo: "",
    facilityContactAddress: "",
    doctorSignature: null,
    doctorStamp: null,
  });
  const [sickLeaveForm, setSickLeaveForm] = useState({
    patientName: "",
    cprNumber: "",
    medicalRecordNumber: "",
    reportedSick: false,
    accompanyingPatient: false,
    accompanyingPersonName: "",
    accompanyingPersonId: "",
    timeOfAttend: "",
    timeOfConsult: "",
    consultDate: "",
    patientFitForDuty: false,
    patientUnfitForDuty: false,
    advisedLightDuty: false,
    patientNeedsEmployeeCare: false,
    noOfDaysOffFigures: "",
    noOfDaysOffWords: "",
    commencingOn: "",
    admittedOn: "",
    dischargedOn: "",
    diagnosis: "",
    diagnosisId: "",
    doctorName: "",
    licenseNo: "",
    specialty: "",
    issueDate: "",
    certificateRegistrationNo: "",
    facilityContactAddress: "",
    doctorSignature: null,
    doctorStamp: null,
  });

  const [houseMaidHealthCheckupForm, setHouseMaidHealthCheckupForm] = useState({
    patientName: "",
    height: "",
    mobileNumber: "",
    civilId: "",
    doctorName: "",
    department: "",
    visitDate: "",
    refNumber: "",
    idNumber: "",

    // Vitals
    bloodPressure: "",
    pulse: "",
    heightCm: "",
    weight: "",
    bmi: "",
    vitalsId: "",

    // Eye / Vision
    rightEyeReadings: "",
    rightEyeStatus: "",
    leftEyeReadings: "",
    leftEyeStatus: "",
    colorVisionReadings: "",
    colorVisionStatus: "",
    eyeComment: "",

    // Clinical Examination - Cardiovascular
    generalAppearanceStatus: "",
    generalAppearanceRemarks: "",
    cardioAuscultationStatus: "",
    cardioAuscultationRemarks: "",

    // Clinical Examination - Respiratory
    respAuscultationStatus: "",
    respAuscultationRemarks: "",
    chestXrayStatus: "",
    chestXrayRemarks: "",

    // Serology
    hivResult: "",
    hivComments: "",
    hbsagResult: "",
    hbsagComments: "",
    hcvResult: "",
    hcvComments: "",
    vdrlResult: "",
    vdrlComments: "",

    // Stool
    ovaParasitesStatus: "",
    ovaParasitesComments: "",
    ovaParasitesTreatments: "",

    // Urine
    urineSugarStatus: "",
    urineSugarComments: "",
    urineAlbuminStatus: "",
    urineAlbuminComments: "",
    urineBloodStatus: "",
    urineBloodComments: "",

    // Footer
    notes: "",
    result: "",
    examinerName: "",
    examinerLicense: "",
    examinerCategory: "",
    examinerDateTime: "",
  });
  const [healthFitnessCertificateForm, setHealthFitnessCertificateForm] =
    useState({
      name: "",
      cprNumber: "",
      profession: "",
      facilityName: "",
      hiv1Hiv2: "",
      hiv1Hiv2Findings: "",
      hbsag: "",
      hbsagFindings: "",
      hcv: "",
      hcvExamination: "",
      hcvFindings: "",
      bloodPressure: "",
      randomBloodSugar: "",
      ppdReading: "",
      igra: "",
      chestXray: "",
      tbScreeningGuideline: "",
      physicalGeneral: "",
      physicalGeneralAbnormal: "",
      physicalChest: "",
      physicalChestAbnormal: "",
      physicalHeart: "",
      physicalHeartAbnormal: "",
      physicalAbdomen: "",
      physicalAbdomenAbnormal: "",
      physicalOthers: "",
      physicalOthersAbnormal: "",
      referral: "",
      vaccinationComments: "",
      vaccinationStatus: "",
      healthDeclaration: false,
      certificateDeclaration: false,
      performedByName: "",
      licenseNumber: "",
      category: "",
      examinationDate: "",
    });

  const fetchAllForms = async (patientDataRef = null) => {
    if (!patientId) return;

    const currentPatientData = patientDataRef || patientData;
    let allForms = [];

    try {
      try {
        const acknowledgementResponse = await axiosInstance.get(
          `getAcknowledgementByPatientId/${patientId}`
        );


        const responseData =
          acknowledgementResponse.data?.data || acknowledgementResponse.data;

        if (
          responseData &&
          Array.isArray(responseData) &&
          responseData.length > 0
        ) {
          const amaForms = responseData.map((ack, index) => {
            const uniqueId = ack.created_at
              ? new Date(ack.created_at).getTime()
              : Date.now() + index;

            const createdBy =
              ack.sent_by_doctor?.displayName ||
              ack.sent_by_doctor?.fullName ||
              ack.sent_by_fullName ||
              ack.sent_by ||
              "";

            return {
              id: uniqueId,
              type: "ama",
              createdBy: createdBy,
              data: {
                patientName:
                  ack.patientName ||
                  `${currentPatientData?.firstName || ""} ${currentPatientData?.lastName || ""
                    }`.trim(),
                fileNo:
                  ack.fileNumber ||
                  currentPatientData?.fileNumber ||
                  currentPatientData?.id ||
                  "",
                date: ack.created_at
                  ? extractDateFromDateTime(ack.created_at)
                  : "",
                cprNo:
                  ack.civilIdNumber ||
                  currentPatientData?.civilIdNumber ||
                  currentPatientData?.cpr ||
                  "",
                physician:
                  ack.sent_by_name ||
                  ack.sent_by_doctor?.displayName ||
                  ack.sent_by_doctor?.fullName ||
                  ack.doctorName ||
                  currentPatientData?.Primary_Doctor ||
                  "",
                ageSex: `${ack.age || currentPatientData?.age || ""}/${ack.gender || currentPatientData?.gender || ""
                  }`,
                recommendation: ack.physical_recommendation || "",
                patientSignature: ack.patient_signature || "",
                patientSignatureDate: ack.patient_date
                  ? ack.patient_date.split("T")[0]
                  : "",
                witnessName: ack.witness_name || "",
                witnessSignature: ack.witness_signature || "",
                witnessSignatureDate: ack.witness_date
                  ? ack.witness_date.split("T")[0]
                  : "",
              },
              createdAt: ack.created_at || new Date().toISOString(),
              apiId: uniqueId,
              dbId: ack.acknowledgement_form_id || ack.id,
            };
          });
          allForms = [...allForms, ...amaForms];
        }
      } catch (ackError) {
        if (ackError?.response?.status !== 404) {
          console.error("Error fetching acknowledgement forms:", ackError);
        }
      }

      // Fetch medical certificates
      try {
        const medicalCertResponse = await axiosInstance.get(
          `getMedicalCertificateDetailsByPatientId/${patientId}`
        );

        const responseData =
          medicalCertResponse.data?.data || medicalCertResponse.data;
        const certData = responseData?.medical_certificates || responseData;
        const patientInfo = responseData?.patient || currentPatientData;
        const diagnosisInfo = responseData?.diagnosis || [];

        if (certData && Array.isArray(certData) && certData.length > 0) {
          const medicalCertForms = certData.map((cert, index) => {
            const uniqueId = cert.created_at
              ? new Date(cert.created_at).getTime()
              : Date.now() + index + 10000;

            const doctorInfo = cert.sent_by_doctor || {};
            const doctorName = doctorInfo.displayName ||
              doctorInfo.fullName ||
              cert.doctor_name ||
              "";

            return {
              id: uniqueId,
              id: uniqueId,
              type: (cert.accompanying_patient === 1 || cert.accompanying_patient === true) ? "accompanyingCertificate" : "medicalCertificate",
              createdBy: doctorName,
              data: {
                patientName: `${patientInfo?.firstName || ""} ${patientInfo?.lastName || ""
                  }`.trim(),
                cprNumber: cert.cpr_number || patientInfo?.civilIdNumber || "",
                medicalRecordNumber:
                  cert.medical_record_number ||
                  patientInfo?.fileNumber ||
                  patientInfo?.id ||
                  "",
                reportedSick:
                  cert.reported_sick === 1 || cert.reported_sick === true,
                accompanyingPatient:
                  cert.accompanying_patient === 1 ||
                  cert.accompanying_patient === true,
                accompanyingPersonName: cert.accompany_name || "",
                accompanyingPersonId: cert.accompany_id || "",
                timeOfAttend: cert.time_of_attend || "",
                timeOfConsult: cert.time_of_consult || "",
                consultDate: cert.consult_date
                  ? cert.consult_date.split("T")[0]
                  : "",
                patientFitForDuty:
                  cert.patient_fit_for_duty === 1 ||
                  cert.patient_fit_for_duty === true,
                patientUnfitForDuty:
                  cert.patient_unfit_for_duty === 1 ||
                  cert.patient_unfit_for_duty === true,
                advisedLightDuty:
                  cert.advised_light_duty === 1 ||
                  cert.advised_light_duty === true,
                patientNeedsEmployeeCare:
                  cert.patient_needs_employee_care === 1 ||
                  cert.patient_needs_employee_care === true,
                noOfDaysOffFigures:
                  cert.no_of_days_off_figures?.toString() || "",
                noOfDaysOffWords: cert.no_of_days_off_words || "",
                commencingOn: cert.commencing_on
                  ? cert.commencing_on.split("T")[0]
                  : "",
                admittedOn: cert.admitted_on
                  ? cert.admitted_on.split("T")[0]
                  : "",
                dischargedOn: cert.discharged_on
                  ? cert.discharged_on.split("T")[0]
                  : "",
                diagnosis: (() => {
                  const matchingDiagnosis = Array.isArray(diagnosisInfo)
                    ? diagnosisInfo.find(
                      (d) =>
                        d.medical_certificate_id ===
                        (cert.certificate_id || cert.id)
                    )
                    : null;
                  return matchingDiagnosis
                    ? matchingDiagnosis.diagnosis_text
                    : cert.diagnosis || "";
                })(),
                diagnosisId: (() => {
                  const matchingDiagnosis = Array.isArray(diagnosisInfo)
                    ? diagnosisInfo.find(
                      (d) =>
                        d.medical_certificate_id ===
                        (cert.certificate_id || cert.id)
                    )
                    : null;
                  return matchingDiagnosis
                    ? matchingDiagnosis.id || matchingDiagnosis.code
                    : cert.diagnosis_id || "";
                })(),
                // const doctorInfo = cert.sent_by_doctor || {};



                doctorName:
                  cert.sent_by_doctor?.displayName ||
                  cert.sent_by_doctor?.fullName ||
                  cert.doctor_name ||
                  patientInfo?.doctorName ||
                  "",
                licenseNo:
                  cert.sent_by_doctor?.licenseId ||
                  cert.license_no ||
                  patientInfo?.licenseId ||
                  "",
                specialty:
                  cert.sent_by_doctor?.specialty ||
                  cert.specialty ||
                  patientInfo?.specialty ||
                  "",
                doctorSignature: cert.sent_by_doctor?.signature || null,
                doctorStamp: cert.sent_by_doctor?.stamp || null,
                issueDate: cert.issue_date
                  ? cert.issue_date.split("T")[0]
                  : cert.created_at
                    ? cert.created_at.split("T")[0]
                    : "",
                certificateRegistrationNo:
                  cert.certificate_registration_no || "",
                facilityContactAddress: cert.facility_contact_address || "",
              },
              createdAt: cert.created_at || new Date().toISOString(),
              apiId: uniqueId,
              dbId: cert.certificate_id || cert.id,
            };
          });
          allForms = [...allForms, ...medicalCertForms];
        }
      } catch (certError) {
        if (certError?.response?.status !== 404) {
          console.error("Error fetching medical certificates:", certError);
        }
      }

      // Fetch sick leave forms
      try {
        const sickLeaveResponse = await axiosInstance.get(`getSickLeaveByPatientId/${patientId}`);
        const slResponseData = sickLeaveResponse.data?.data || sickLeaveResponse.data;
        const slCertData = slResponseData?.sick_leave_certificates || slResponseData;
        const slPatientInfo = slResponseData?.patient || currentPatientData;

        if (slCertData && Array.isArray(slCertData) && slCertData.length > 0) {
          const sickLeaveForms = slCertData.map((cert, index) => {
            const uniqueId = cert.created_at
              ? new Date(cert.created_at).getTime() + 50000 + index
              : Date.now() + index + 50000;

            const doctorInfo = cert.sent_by_doctor || {};
            const drName = doctorInfo.displayName || doctorInfo.fullName || cert.doctor_name || "";

            return {
              id: uniqueId,
              type: "sickLeave",
              createdBy: drName,
              data: {
                patientName: `${slPatientInfo?.firstName || ""} ${slPatientInfo?.lastName || ""}`.trim(),
                cprNumber: cert.cpr_number || slPatientInfo?.civilIdNumber || "",
                medicalRecordNumber: cert.medical_record_number || slPatientInfo?.fileNumber || slPatientInfo?.id || "",
                reportedSick: cert.reported_sick === 1 || cert.reported_sick === true,
                accompanyingPatient: cert.accompanying_patient === 1 || cert.accompanying_patient === true,
                accompanyingPersonName: cert.accompany_name || "",
                accompanyingPersonId: cert.accompany_id || "",
                timeOfAttend: cert.time_of_attend || "",
                timeOfConsult: cert.time_of_consult || "",
                consultDate: cert.consult_date ? cert.consult_date.split("T")[0] : "",
                patientFitForDuty: cert.patient_fit_for_duty === 1 || cert.patient_fit_for_duty === true,
                patientUnfitForDuty: cert.patient_unfit_for_duty === 1 || cert.patient_unfit_for_duty === true,
                advisedLightDuty: cert.advised_light_duty === 1 || cert.advised_light_duty === true,
                patientNeedsEmployeeCare: cert.patient_needs_employee_care === 1 || cert.patient_needs_employee_care === true,
                noOfDaysOffFigures: cert.no_of_days_off_figures?.toString() || "",
                noOfDaysOffWords: cert.no_of_days_off_words || "",
                commencingOn: cert.commencing_on ? cert.commencing_on.split("T")[0] : "",
                admittedOn: cert.admitted_on ? cert.admitted_on.split("T")[0] : "",
                dischargedOn: cert.discharged_on ? cert.discharged_on.split("T")[0] : "",
                diagnosis: cert.diagnosis_text || cert.diagnosis || "",
                diagnosisId: cert.diagnosis_id || "",
                doctorName: cert.sent_by_doctor?.displayName || cert.sent_by_doctor?.fullName || cert.doctor_name || slPatientInfo?.doctorName || "",
                licenseNo: cert.sent_by_doctor?.licenseId || cert.license_no || slPatientInfo?.licenseId || "",
                specialty: cert.sent_by_doctor?.specialty || cert.specialty || slPatientInfo?.specialty || "",
                doctorSignature: cert.sent_by_doctor?.signature || null,
                doctorStamp: cert.sent_by_doctor?.stamp || null,
                issueDate: cert.issue_date ? cert.issue_date.split("T")[0] : cert.created_at ? cert.created_at.split("T")[0] : "",
                certificateRegistrationNo: cert.certificate_registration_no || "",
                facilityContactAddress: cert.facility_contact_address || "",
              },
              createdAt: cert.created_at || new Date().toISOString(),
              apiId: uniqueId,
              dbId: cert.certificate_id || cert.id,
            };
          });
          allForms = [...allForms, ...sickLeaveForms];
        }
      } catch (slError) {
        if (slError?.response?.status !== 404) {
          console.error("Error fetching sick leave forms:", slError);
        }
      }

      // Fetch referral forms
      try {
        const referralResponse = await axiosInstance.get(
          `getReferralDetailsByPatientId/${patientId}`
        );

        const referralData =
          referralResponse.data?.data || referralResponse.data;

        if (
          referralData &&
          Array.isArray(referralData) &&
          referralData.length > 0
        ) {
          const referralForms = referralData.map((ref, index) => {
            const uniqueId = ref.created_at
              ? new Date(ref.created_at).getTime()
              : Date.now() + index + 20000;

            const doctorInfo = ref.sent_by_doctor || {};
            const doctorName = doctorInfo.displayName ||
              doctorInfo.fullName ||
              ref.sent_by_name ||
              "";

            return {
              id: uniqueId,
              type: "referral",
              createdBy: doctorName,
              data: {
                patientName: `${ref.firstName || ""} ${ref.lastName || ""
                  }`.trim(),
                cpr: ref.cpr_number || ref.civilIdNumber || "",
                age: ref.age?.toString() || "",
                sex: ref.gender || "",
                nationality: ref.nationality || "",
                mobileNumber: ref.mobileNumber || "",
                referralType: ref.referral_type || "",
                referralCategory: ref.referral_category || "",
                reasonOfReferral: ref.reason_of_referral || "",
                chiefComplain: ref.chief_complaint || "",
                summaryOfPresentation: ref.summary_presentation || "",
                vitalSigns: {
                  bp: ref.blood_pressure || "",
                  respiratoryRate: ref.respiratory_rate || "",
                  pulse: ref.pulse || "",
                  spo2: ref.spo2 || "",
                  rbs: ref.rbs_mg || ref.rbs || ref.random_blood_sugar || "",
                  temperature: ref.temperature || ref.vitals?.toString() || "",
                  weight: ref.weight || "",
                },
                glasgowComaScale: {
                  eye: ref.gcs_eye || "",
                  motorResponse: ref.gcs_motor_response || "",
                  verbalResponse: ref.gcs_verbal_response || "",
                  totalScore: ref.gcs_total_score?.toString() || "",
                },
                generalExamination: ref.general_examination || "",
                localExamination: ref.local_examination || "",
                investigationsDone: ref.investigations_done || "",
                procedureInterventions: ref.procedures_and_interventions || "",
                injectionsMedications: ref.injections_and_medications || "",
                prescriptionGiven: ref.prescription_given || "",
                notes: ref.notes || ref.note || "",
                advices: ref.advices || "",
                referringDoctor: {
                  name:
                    ref.sent_by_doctor?.displayName ||
                    ref.sent_by_doctor?.fullName ||
                    ref.referring_doctor_name ||
                    "",
                  date:
                    ref.referring_doctor_date &&
                      ref.referring_doctor_date !== "0000-00-00"
                      ? ref.referring_doctor_date.split("T")[0]
                      : "",
                  time: ref.referring_doctor_time || "",
                  phoneNumber:
                    ref.sent_by_doctor?.phoneNumber ||
                    ref.referring_doctor_phone ||
                    "",
                },
                receivingDoctor: {
                  name: ref.receiving_doctor_name || "",
                  date:
                    ref.receiving_doctor_date &&
                      ref.receiving_doctor_date !== "0000-00-00"
                      ? ref.receiving_doctor_date.split("T")[0]
                      : "",
                  time:
                    ref.receiving_doctor_time &&
                      ref.receiving_doctor_time !== "00:00:00"
                      ? ref.receiving_doctor_time
                      : "",
                  phoneNumber: ref.receiving_doctor_phone || "",
                },
              },
              createdAt: ref.created_at || new Date().toISOString(),
              apiId: uniqueId,
              dbId: ref.referral_form_id || ref.id,
            };
          });
          allForms = [...allForms, ...referralForms];
        }
      } catch (refError) {
        if (refError?.response?.status !== 404) {
          console.error("Error fetching referral forms:", refError);
        }
      }

      // Fetch health fitness certificates
      try {
        const healthFitnessResponse = await axiosInstance.get(
          `getHealthCertificateByPatientId/${patientId}`
        );


        const healthFitnessData =
          healthFitnessResponse.data?.data || healthFitnessResponse.data;

        if (
          healthFitnessData &&
          Array.isArray(healthFitnessData) &&
          healthFitnessData.length > 0
        ) {
          const healthFitnessForms = healthFitnessData.map((cert, index) => {
            const uniqueId = cert.created_at
              ? new Date(cert.created_at).getTime()
              : Date.now() + index + 30000;

            const doctorInfo = cert.sent_by_doctor || {};
            const doctorName = doctorInfo.displayName ||
              doctorInfo.fullName ||
              cert.performed_by_name ||
              "";

            return {
              id: uniqueId,
              type: "healthFitnessCertificate",
              createdBy: doctorName,
              data: {
                patientName: `${currentPatientData?.firstName || ""} ${currentPatientData?.lastName || ""
                  }`.trim(),
                cprNumber:
                  cert.cpr_number || currentPatientData?.civilIdNumber || "",
                profession: cert.profession || "",
                facilityName: cert.facility_name || "",
                hiv1Hiv2: cert.hiv1_hiv2 || "",
                hiv1Hiv2Findings: cert.hiv1_hiv2_findings || "",
                hbsag: cert.hbsag || "",
                hbsagFindings: cert.hbsag_findings || "",
                hcv: cert.hcv || "",
                hcvExamination: cert.hcv_examination || "",
                hcvFindings: cert.hcv_findings || "",
                bloodPressure: cert.blood_pressure || "",
                randomBloodSugar: cert.random_blood_sugar || "",
                ppdReading: cert.ppd_reading || "",
                igra: cert.igra || "",
                chestXray: cert.chest_xray || "",
                chestXrayNegative: cert.tb_screening_guideline || "",
                tbScreeningGuideline: cert.tb_screening_guideline || "",
                physicalGeneral: cert.physical_general || "",
                physicalGeneralAbnormal: cert.physical_general_abnormal || "",
                physicalChest: cert.physical_chest || "",
                physicalChestAbnormal: cert.physical_chest_abnormal || "",
                physicalHeart: cert.physical_heart || "",
                physicalHeartAbnormal: cert.physical_heart_abnormal || "",
                physicalAbdomen: cert.physical_abdomen || "",
                physicalAbdomenAbnormal: cert.physical_abdomen_abnormal || "",
                physicalOthers: cert.physical_others || "",
                physicalOthersAbnormal: cert.physical_others_abnormal || "",
                referral: cert.referral || "",
                vaccinationComments: cert.vaccination_comments || "",
                vaccinationStatus: cert.vaccination_status || "",
                healthDeclaration:
                  cert.health_declaration === 1 ||
                  cert.health_declaration === true,
                certificateDeclaration:
                  cert.certificate_declaration === 1 ||
                  cert.certificate_declaration === true,
                performedByName:
                  cert.sent_by_doctor?.displayName ||
                  cert.sent_by_doctor?.fullName ||
                  cert.performed_by_name ||
                  "",
                licenseNumber:
                  cert.sent_by_doctor?.licenseId || cert.license_number || "",
                category: cert.category || "",
                examinationDate: cert.examination_date
                  ? cert.examination_date.split("T")[0]
                  : "",
              },
              createdAt: cert.created_at || new Date().toISOString(),
              apiId: uniqueId,
              dbId: cert.id || cert.certificate_id,
            };
          });
          allForms = [...allForms, ...healthFitnessForms];
        }
      } catch (healthFitnessError) {
        console.error(
          "Error fetching health fitness certificates:",
          healthFitnessError
        );
      }

      // Fetch housemaid health checkup certificates
      try {
        const housemaidResponse = await axiosInstance.get(
          `getHousemaidHealthCheckupByPatientId/${patientId}`
        );


        const housemaidData =
          housemaidResponse.data?.data || housemaidResponse.data;

        if (
          housemaidData &&
          Array.isArray(housemaidData) &&
          housemaidData.length > 0
        ) {
          const housemaidForms = housemaidData.map((cert, index) => {
            const uniqueId = cert.created_at
              ? new Date(cert.created_at).getTime()
              : Date.now() + index + 40000;

            const doctorInfo = cert.sent_by_doctor || {};
            const doctorName = doctorInfo.displayName ||
              doctorInfo.fullName ||
              cert.doctor_name ||
              "";

            return {
              id: uniqueId,
              type: "houseMaidHealthCheckup",
              createdBy: doctorName,
              data: {
                // Patient Info
                patientName: `${currentPatientData?.firstName || ""} ${currentPatientData?.lastName || ""
                  }`.trim(),
                visitDate: cert.visit_date
                  ? cert.visit_date.split("T")[0]
                  : cert.examination_date
                    ? cert.examination_date.split("T")[0]
                    : "",
                mobileNumber: cert.mobileNumber || cert.mobile_number || "",
                refNumber: cert.reg_number || "",
                civilId: cert.cvr_number || cert.civilIdNumber || "",
                doctorName:
                  cert.sent_by_doctor?.displayName ||
                  cert.sent_by_doctor?.fullName ||
                  cert.doctor_name ||
                  "",
                examinerLicense:
                  cert.sent_by_doctor?.licenseId ||
                  cert.doctor_licenseId ||
                  cert.examiner_license ||
                  "",

                // Vitals
                bloodPressure: cert.blood_pressure || "",
                pulse: cert.pulse || "",
                heightCm: cert.height || "",
                weight: cert.weight || "",
                bmi: cert.bmi || "",
                vitalsId: cert.vitals || "",

                // Vision
                rightEyeReadings: cert.right_eye_reading || "",
                rightEyeStatus: cert.right_eye_result || "",
                leftEyeReadings: cert.left_eye_reading || "",
                leftEyeStatus: cert.left_eye_result || "",
                colorVisionReadings: cert.color_vision_reading || "",
                colorVisionStatus: cert.color_vision_result || "",
                eyeComment: cert.vision_comments || "",

                // Clinical Examination - Cardiovascular
                generalAppearanceStatus: cert.cardio_general_appearance || "",
                generalAppearanceRemarks: cert.cardio_general_remarks || "",
                cardioAuscultationStatus: cert.cardio_auscultation || "",
                cardioAuscultationRemarks:
                  cert.cardio_auscultation_remarks || "",

                // Clinical Examination - Respiratory
                respAuscultationStatus: cert.respiratory_auscultation || "",
                respAuscultationRemarks:
                  cert.respiratory_auscultation_remarks || "",
                chestXrayStatus: cert.respiratory_chest_xray || "",
                chestXrayRemarks: cert.respiratory_chest_xray_remarks || "",

                // Serology
                hivResult: (cert.hiv_result || "").toLowerCase(),
                hivComments: cert.hiv_comments || "",
                hbsagResult: (cert.hbsag_result || "").toLowerCase(),
                hbsagComments: cert.hbsag_comments || "",
                hcvResult: (cert.hcv_result || "").toLowerCase(),
                hcvComments: cert.hcv_comments || "",
                vdrlResult: (cert.vdrl_result || "").toLowerCase(),
                vdrlComments: cert.vdrl_comments || "",

                // Stool
                ovaParasitesStatus: (
                  cert.stool_ova_parasites || ""
                ).toLowerCase(),
                ovaParasitesComments:
                  (cert.stool_comments || "").split(" ||| ")[0] || "",
                ovaParasitesTreatments:
                  (cert.stool_comments || "").split(" ||| ")[1] || "",

                // Urine
                urineSugarStatus: (cert.urine_sugar || "").toLowerCase(),
                urineSugarComments: cert.urine_sugar_comment || "",
                urineAlbuminStatus: (cert.urine_albumin || "").toLowerCase(),
                urineAlbuminComments: cert.urine_albumin_comment || "",
                urineBloodStatus: (cert.urine_blood || "").toLowerCase(),
                urineBloodComments: cert.urine_blood_comment || "",

                // Footer
                notes: cert.additional_notes || cert.notes || "",
                result: (cert.result_status || "").toLowerCase(),
                examinerName:
                  cert.sent_by_doctor?.displayName ||
                  cert.sent_by_doctor?.fullName ||
                  cert.examined_by_doctor ||
                  cert.doctor_name ||
                  "",
                examinerDateTime: cert.examination_date
                  ? cert.examination_date.replace(" ", "T").slice(0, 16)
                  : "",
              },
              createdAt: cert.created_at || new Date().toISOString(),
              apiId: uniqueId,
              dbId:
                cert.certificate_id || cert.housemaid_certificate_id || cert.id,
            };
          });

          allForms = [...allForms, ...housemaidForms];
        }
      } catch (housemaidError) {
        if (housemaidError?.response?.status !== 404) {
          console.error("Error fetching housemaid health checkup certificates:", housemaidError);
        }
        // 404 = no housemaid certificates for this patient — normal state
      }

      // Fetch patient consent forms
      try {
        const consentRes = await axiosInstance.get(`getPatientConsentForms/${patientId}`);
        const consentData = consentRes.data?.data || [];
        if (Array.isArray(consentData) && consentData.length > 0) {
          const consentForms = consentData.map((cf) => ({
            id: cf.id,
            type: "consent",
            createdBy: cf.created_by || "",
            data: {
              templateId: cf.template_id,
              templateName: cf.template_name || "",
              title: cf.title || "",
              content: cf.content || "",
              patientName: cf.patient_name || "",
              fileNo: cf.file_no || "",
              cprNo: cf.cpr_no || "",
              ageSex: cf.age_sex || "",
              createdBy: cf.created_by || "",
              createdAt: cf.created_at || "",
              patientSignature: cf.patient_signature || "",
              userSignature: cf.user_signature || "",
            },
            createdAt: cf.created_at || new Date().toISOString(),
            apiId: cf.id,
            dbId: cf.id,
          }));
          allForms = [...allForms, ...consentForms];
        }
      } catch (consentError) {
        if (consentError?.response?.status !== 404) {
          console.error("Error fetching consent forms:", consentError);
        }
      }

      // Fetch patient custom forms
      try {
        const customFormRes = await axiosInstance.get(`getPatientCustomForms/${patientId}`);
        const customFormData = customFormRes.data?.data || [];
        if (Array.isArray(customFormData) && customFormData.length > 0) {
          const customFormForms = customFormData.map((cf) => ({
            id: cf.id,
            type: "customform",
            createdBy: cf.created_by || "",
            data: {
              templateId: cf.template_id,
              templateName: cf.template_name || "",
              title: cf.title || "",
              content: cf.content || "",
              patientName: cf.patient_name || "",
              fileNo: cf.file_no || "",
              cprNo: cf.cpr_no || "",
              ageSex: cf.age_sex || "",
              createdBy: cf.created_by || "",
              createdAt: cf.created_at || "",
            },
            createdAt: cf.created_at || new Date().toISOString(),
            apiId: cf.id,
            dbId: cf.id,
          }));
          allForms = [...allForms, ...customFormForms];
        }
      } catch (customFormError) {
        if (customFormError?.response?.status !== 404) {
          console.error("Error fetching custom forms:", customFormError);
        }
      }

      // Set all forms at once
      setForms(allForms);
    } catch (error) {
      console.error("Error in fetchAllForms:", error);
    }
  };

  // Fetch patient data and medical history
  useEffect(() => {
    const fetchPatientData = async () => {
      if (patientId) {
        try {
          // Fetch basic patient info
          const patientResponse = await axiosInstance.get(
            `getPatientById/${patientId}`
          );

          if (patientResponse.data.success === true) {
            setPatientData(patientResponse.data.data);

            // Fetch all forms after patient data is loaded
            await fetchAllForms(patientResponse.data.data);
          }

          // Fetch all vitals records
          const vitalsResponse = await axiosInstance.get(
            `getPatientVitalsByPatientId/${patientId}`
          );
          if (
            vitalsResponse.data?.success === true &&
            vitalsResponse.data.vitals?.length > 0
          ) {
            const vitalsArray = vitalsResponse.data.vitals;
            setAllVitalsRecords(vitalsArray);

            // Set the most recent vital as default
            const latestVital = vitalsArray[vitalsArray.length - 1];
            if (latestVital?.recorded_at) {
              setSelectedDate(latestVital.recorded_at.split("T")[0]);
            }
          }

          // Fetch disease details for comprehensive data
          const diseaseResponse = await axiosInstance.get(
            `getPatientDiseaseDetails/${patientId}`
          );
          if (diseaseResponse.data.success === true) {
            setMedicalHistory(diseaseResponse.data.data);
          }

          // Fetch all medical records for date selection
          try {
            const medicalDataResponse = await axiosInstance.get(
              `getAllMedicalDataByPatient/${patientId}`
            );
            if (
              medicalDataResponse.data.success &&
              medicalDataResponse.data.data
            ) {
              setAllMedicalRecords(medicalDataResponse.data.data);

              // Set the most recent medical record date as default if no vitals date is set
              if (!selectedDate && medicalDataResponse.data.data.length > 0) {
                const latestRecord =
                  medicalDataResponse.data.data[
                  medicalDataResponse.data.data.length - 1
                  ];
                if (latestRecord?.created_at) {
                  setSelectedDate(latestRecord.created_at.split("T")[0]);
                }
              }
            }
          } catch (error) {
            console.error("Error fetching all medical records:", error);
          }
        } catch (error) {
          console.error("Error fetching patient data:", error);
        }
      }
    };
    fetchPatientData();
  }, [patientId]);

  // Load consent templates from API, filtered by enabled_consents in businessSetting
  useEffect(() => {
    axiosInstance.get("consentTemplates").then(res => {
      const all = res.data?.data || [];
      const enabledConsents = businessSetting?.enabled_consents;
      const filtered = (enabledConsents && Array.isArray(enabledConsents))
        ? all.filter(t => enabledConsents.includes(t.id))
        : all;
      setConsentTemplates(filtered);
    }).catch(() => setConsentTemplates([]));
  }, []);

  // Load custom form templates from API, filtered by enabled_custom_forms in businessSetting
  useEffect(() => {
    axiosInstance.get("customFormTemplates").then(res => {
      const all = res.data?.data || [];
      const enabledCustomForms = businessSetting?.enabled_custom_forms;
      const filtered = (enabledCustomForms && Array.isArray(enabledCustomForms))
        ? all.filter(t => enabledCustomForms.includes(t.id))
        : all;
      setCustomFormTemplates(filtered);
    }).catch(() => setCustomFormTemplates([]));
  }, []);

  // Load existing signatures into canvas when consent modal opens
  useEffect(() => {
    if (showFormView && selectedFormType === "consent") {
      const loadSig = (ref, dataUrl) => {
        if (ref.current && dataUrl && dataUrl.startsWith("data:")) {
          setTimeout(() => {
            try { ref.current.fromDataURL(dataUrl); } catch (_) {}
          }, 100);
        }
      };
      loadSig(patientSigRef, consentForm.patientSignature);
      loadSig(userSigRef, consentForm.userSignature);
    }
  }, [showFormView, selectedFormType]);

  // Initialize CKEditor for consent form when modal opens in edit mode
  useEffect(() => {
    if (showFormView && selectedFormType === "consent" && !isViewOnly) {
      const initEditor = () => {
        if (!consentEditorRef.current) return;
        if (consentEditorInstanceRef.current) {
          consentEditorInstanceRef.current.destroy().catch(() => {});
          consentEditorInstanceRef.current = null;
        }
        if (window.ClassicEditor) {
          window.ClassicEditor.create(consentEditorRef.current)
            .then(editor => {
              consentEditorInstanceRef.current = editor;
              setupDirectionSupport(editor);
              editor.setData(consentForm.content || "");
              setConsentEditorDir(getBlockDirection(editor));
              editor.model.document.selection.on("change:range", () => {
                setConsentEditorDir(getBlockDirection(editor));
              });
            })
            .catch(console.error);
        } else {
          const existing = document.getElementById("ckeditor5-cdn-consents");
          if (!existing) {
            const s = document.createElement("script");
            s.id = "ckeditor5-cdn-consents";
            s.src = "https://cdn.ckeditor.com/ckeditor5/41.4.2/classic/ckeditor.js";
            s.onload = initEditor;
            document.head.appendChild(s);
          }
        }
      };
      const timer = setTimeout(initEditor, 150);
      return () => clearTimeout(timer);
    } else if (!showFormView || selectedFormType !== "consent") {
      if (consentEditorInstanceRef.current) {
        consentEditorInstanceRef.current.destroy().catch(() => {});
        consentEditorInstanceRef.current = null;
      }
    }
  }, [showFormView, selectedFormType, isViewOnly]);

  // Initialize CKEditor for custom form when modal opens in edit mode
  useEffect(() => {
    if (showFormView && selectedFormType === "customform" && !isViewOnly) {
      const initEditor = () => {
        if (!customFormEditorRef.current) return;
        if (customFormEditorInstanceRef.current) {
          customFormEditorInstanceRef.current.destroy().catch(() => {});
          customFormEditorInstanceRef.current = null;
        }
        if (window.ClassicEditor) {
          window.ClassicEditor.create(customFormEditorRef.current)
            .then(editor => {
              customFormEditorInstanceRef.current = editor;
              editor.setData(customForm.content || "");
            })
            .catch(console.error);
        } else {
          const existing = document.getElementById("ckeditor5-cdn-consents");
          if (!existing) {
            const s = document.createElement("script");
            s.id = "ckeditor5-cdn-consents";
            s.src = "https://cdn.ckeditor.com/ckeditor5/41.4.2/classic/ckeditor.js";
            s.onload = initEditor;
            document.head.appendChild(s);
          }
        }
      };
      const timer = setTimeout(initEditor, 150);
      return () => clearTimeout(timer);
    } else if (!showFormView || selectedFormType !== "customform") {
      if (customFormEditorInstanceRef.current) {
        customFormEditorInstanceRef.current.destroy().catch(() => {});
        customFormEditorInstanceRef.current = null;
      }
    }
  }, [showFormView, selectedFormType, isViewOnly]);


  // Function to handle closing the form view modal
  const handleCloseFormView = () => {
    setShowFormView(false);
    setSelectedFormType(""); // Reset selected form type so it can be selected again
    setIsViewOnly(false); // Reset view-only mode
    setEditingFormId(null); // Reset editing form ID
    if (consentEditorInstanceRef.current) {
      consentEditorInstanceRef.current.destroy().catch(() => {});
      consentEditorInstanceRef.current = null;
    }
    if (customFormEditorInstanceRef.current) {
      customFormEditorInstanceRef.current.destroy().catch(() => {});
      customFormEditorInstanceRef.current = null;
    }
  };

  const handleFormTypeSelect = (type) => {
    setSelectedFormType(type);
    setShowAddFormModal(false);
    setEditingFormId(null); // Reset editing state when creating new form
    setIsViewOnly(false); // Ensure new forms are editable

    // Get logged-in user details from localStorage
    let loggedInUser = null;
    let doctor = "";
    let doctorLicense = "";
    let doctorSpecialty = "";
    let doctorPhone = "";

    try {
      const userMedical = localStorage.getItem("userMedical");
      if (userMedical) {
        loggedInUser = JSON.parse(userMedical);
        // Extract details based on user instructions
        // data.fullName, data.licenseId, data.specialty, data.phoneNumber
        const data = loggedInUser.data || loggedInUser;
        doctor = data.displayName || data.fullName || data.name || "";
        if (doctor) setDoctorName(doctor);
        doctorLicense = data.licenseId || data.license_no || data.licenseNo || "";
        doctorSpecialty = data.specialty || data.Specialty || "";
        doctorPhone = data.phoneNumber || data.mobileNumber || "";
      }
    } catch (error) {
      console.error("Error parsing userMedical:", error);
    }

    if (patientData) {
      if (type === "ama") {
        setAmaForm({
          patientName: `${patientData.firstName || ""} ${patientData.lastName || ""
            }`.trim(),
          fileNo: patientData.fileNumber || patientData.id || "",
          date: new Date().toISOString().split("T")[0],
          cprNo: patientData.civilIdNumber || patientData.cpr || "",
          physician: doctor || "",
          ageSex: `${patientData.age || ""}/${patientData.gender || ""}`,
          recommendation: "",
          patientSignature: "",
          patientSignatureDate: new Date().toISOString().split("T")[0],
          witnessName: "",
          witnessSignature: "",
          witnessSignatureDate: new Date().toISOString().split("T")[0],
        });
      } else if (type === "referral") {
        // Initialize with default patient data
        // Uses doctorName and doctorPhone extracted above

        setReferralForm({
          patientName: `${patientData.firstName || ""} ${patientData.lastName || ""
            }`.trim(),
          cpr: patientData.cpr || patientData.civilIdNumber || "",
          age: patientData.age || "",
          sex: patientData.gender || "",
          nationality: patientData.nationality || "",
          mobileNumber:
            patientData.mobileNumber || patientData.phoneNumber || "",
          referralType: "internal",
          referralCategory: "urgent",
          reasonOfReferral: "",
          chiefComplain: "",
          summaryOfPresentation: "",
          physicalExamination: "",
          vitalSigns: {
            bp: "",
            temperature: "",
            pulse: "",
            weight: "",
            respiratoryRate: "",
            spo2: "",
            rbs: "",
            height: "",
            bmi: "",
          },
          vitalsId: "",
          glasgowComaScale: {
            eye: "",
            motorResponse: "",
            verbalResponse: "",
            totalScore: "",
          },
          generalExamination: "",
          localExamination: "",
          investigationsDone: "",
          procedureInterventions: "",
          injectionsMedications: "",
          prescriptionGiven: "",
          notes: "",
          advices: "",
          referringDoctor: {
            name: doctor || "",
            date: new Date().toISOString().split("T")[0],
            time: new Date().toTimeString().slice(0, 5),
            phoneNumber: doctorPhone || "",
          },
          receivingDoctor: { name: "", date: "", time: "", phoneNumber: "" },
        });

        // Auto-fill with default selected date data
        fillReferralFormWithDate(selectedDate);
      } else if (type === "medicalCertificate" || type === "accompanyingCertificate") {
        // Fetch diagnosis options
        fetchDiagnosisOptions();

        setMedicalCertificateForm({
          patientName: `${patientData.firstName || ""} ${patientData.lastName || ""
            }`.trim(),
          cprNumber: patientData.civilIdNumber || patientData.cpr || "",
          medicalRecordNumber: patientData.fileNumber || patientData.id || "",
          reportedSick: false,
          accompanyingPatient: type === "accompanyingCertificate",
          timeOfAttend: new Date().toTimeString().slice(0, 5),
          timeOfConsult: new Date().toTimeString().slice(0, 5),
          consultDate: new Date().toISOString().split("T")[0],
          patientFitForDuty: false,
          patientUnfitForDuty: false,
          advisedLightDuty: false,
          patientNeedsEmployeeCare: false,
          noOfDaysOffFigures: "",
          noOfDaysOffWords: "",
          commencingOn: "",
          admittedOn: "",
          dischargedOn: "",
          diagnosis: "",
          diagnosisId: "",
          doctorName: doctor || "",
          licenseNo: doctorLicense || "",
          specialty: doctorSpecialty || "",
          issueDate: new Date().toISOString().split("T")[0],
          certificateRegistrationNo: "",
          facilityContactAddress: "",
          doctorSignature: currentDoctorSigStamp.signature,
          doctorStamp: currentDoctorSigStamp.stamp,
        });
        setDiagnosisSearch(""); // Reset search
      } else if (type === "sickLeave") {
        fetchDiagnosisOptions();
        setSickLeaveForm({
          patientName: `${patientData.firstName || ""} ${patientData.lastName || ""}`.trim(),
          cprNumber: patientData.civilIdNumber || patientData.cpr || "",
          medicalRecordNumber: patientData.fileNumber || patientData.id || "",
          reportedSick: false,
          accompanyingPatient: false,
          accompanyingPersonName: "",
          accompanyingPersonId: "",
          timeOfAttend: "",
          timeOfConsult: "",
          consultDate: new Date().toISOString().split("T")[0],
          patientFitForDuty: false,
          patientUnfitForDuty: false,
          advisedLightDuty: false,
          patientNeedsEmployeeCare: false,
          noOfDaysOffFigures: "",
          noOfDaysOffWords: "",
          commencingOn: new Date().toISOString().split("T")[0],
          admittedOn: "",
          dischargedOn: "",
          diagnosis: "",
          diagnosisId: "",
          doctorName: doctor || "",
          licenseNo: doctorLicense || "",
          specialty: doctorSpecialty || "",
          issueDate: new Date().toISOString().split("T")[0],
          certificateRegistrationNo: "",
          facilityContactAddress: "",
          doctorSignature: currentDoctorSigStamp.signature,
          doctorStamp: currentDoctorSigStamp.stamp,
        });
        setDiagnosisSearch("");
      } else if (type === "houseMaidHealthCheckup") {
        const now = new Date();
        const timezoneOffset = now.getTimezoneOffset() * 60000; // offset in milliseconds
        const localDate = new Date(now.getTime() - timezoneOffset);
        const currentDateTime = localDate.toISOString().slice(0, 16); // Format: YYYY-MM-DDTHH:mm

        // Auto-generate Ref Number
        const lastRef = localStorage.getItem("lastRefNumber") || "RF0000";
        let nextRef = "RF0001";
        try {
          const numberPart = parseInt(lastRef.replace("RF", "")) + 1;
          nextRef = `RF${numberPart.toString().padStart(4, "0")}`;
        } catch (e) {
          console.error("Error generating ref number", e);
        }
        localStorage.setItem("lastRefNumber", nextRef);

        const department = DrData?.data?.role || "";

        setHouseMaidHealthCheckupForm({
          patientName: `${patientData.firstName || ""} ${patientData.lastName || ""
            }`.trim(),
          mobileNumber:
            patientData.mobileNumber || patientData.phoneNumber || "",
          civilId: patientData.civilIdNumber || patientData.cpr || "",
          doctorName: doctor || "",
          department: department,
          visitDate: currentDateTime.split("T")[0],
          refNumber: nextRef,
          idNumber: patientData.fileNumber || "",

          // Vitals
          bloodPressure: "",
          pulse: "",
          heightCm: "",
          weight: "",
          bmi: "",
          vitalsId: "",

          // Eye / Vision
          rightEyeReadings: "",
          rightEyeStatus: "",
          leftEyeReadings: "",
          leftEyeStatus: "",
          colorVisionReadings: "",
          colorVisionStatus: "",
          eyeComment: "",

          // Clinical Examination - Cardiovascular
          generalAppearanceStatus: "",
          generalAppearanceRemarks: "",
          cardioAuscultationStatus: "",
          cardioAuscultationRemarks: "",

          // Clinical Examination - Respiratory
          respAuscultationStatus: "",
          respAuscultationRemarks: "",
          chestXrayStatus: "",
          chestXrayRemarks: "",

          // Serology
          hivResult: "",
          hivComments: "",
          hbsagResult: "",
          hbsagComments: "",
          hcvResult: "",
          hcvComments: "",
          vdrlResult: "",
          vdrlComments: "",

          // Stool
          ovaParasitesStatus: "",
          ovaParasitesComments: "",
          ovaParasitesTreatments: "",

          // Urine
          urineSugarStatus: "",
          urineSugarComments: "",
          urineAlbuminStatus: "",
          urineAlbuminComments: "",
          urineBloodStatus: "",
          urineBloodComments: "",

          // Footer
          notes: "",
          result: "",
          examinerName: doctor || "",
          examinerLicense: doctorLicense || patientData.doctor_licenseId || "",
          examinerCategory: "",
          examinerDateTime: currentDateTime, // Set current date/time
        });
        // Auto-fill with default selected date data if available
        if (selectedDate) {
          fillHouseMaidFormWithDate(selectedDate);
        }
      } else if (type === "healthFitnessCertificate") {
        const now = new Date();
        const timezoneOffset = now.getTimezoneOffset() * 60000; // offset in milliseconds
        const localDate = new Date(now.getTime() - timezoneOffset);
        const currentDateTime = localDate.toISOString().slice(0, 16); // Format: YYYY-MM-DDTHH:mm
        setHealthFitnessCertificateForm({
          patientName: `${patientData.firstName || ""} ${patientData.lastName || ""
            }`.trim(),
          cprNumber: patientData.civilIdNumber || patientData.cpr || "",
          profession: DrData?.data?.role || "",
          facilityName: "",
          hiv1Hiv2: "",
          hbsag: "",
          hcv: "",
          hcvExamination: "",
          hcvFindings: "",
          bloodPressure: "",
          randomBloodSugar: "",
          ppdReading: "",
          igra: "",
          chestXray: "",
          chestXrayNegative: "",
          tbScreeningGuideline: "",
          physicalGeneral: "Normal",
          physicalGeneralAbnormal: "",
          physicalChest: "Normal",
          physicalChestAbnormal: "",
          physicalHeart: "Normal",
          physicalHeartAbnormal: "",
          physicalAbdomen: "Normal",
          physicalAbdomenAbnormal: "",
          physicalOthers: "Normal",
          physicalOthersAbnormal: "",
          referral: "",
          vaccinationComments: "",
          vaccinationStatus: "",
          healthDeclaration: false,
          certificateDeclaration: false,
          performedByName: doctor || "",
          licenseNumber: doctorLicense || "",
          category: "",
          examinationDate: currentDateTime,
        });
      } else if (type.startsWith("consent_")) {
        const templateId = parseInt(type.replace("consent_", ""), 10);
        const template = consentTemplates.find(t => t.id === templateId);
        if (template) {
          setConsentForm({
            templateId: template.id,
            templateName: template.name,
            title: template.name,
            content: template.content || "",
            patientName: patientData ? `${patientData.firstName || ""} ${patientData.lastName || ""}`.trim() : "",
            fileNo: patientData?.fileNumber || patientData?.id || "",
            cprNo: patientData?.civilIdNumber || patientData?.cpr || "",
            ageSex: `${patientData?.age || ""}/${patientData?.gender || ""}`,
            createdBy: doctor || "",
            createdAt: new Date().toLocaleString(),
            patientSignature: "",
            userSignature: "",
          });
          setSelectedFormType("consent");
        }
        setShowFormView(true);
        return;
      } else if (type.startsWith("customform_")) {
        const templateId = parseInt(type.replace("customform_", ""), 10);
        const template = customFormTemplates.find(t => t.id === templateId);
        if (template) {
          setCustomForm({
            templateId: template.id,
            templateName: template.name,
            title: template.name,
            content: template.content || "",
            patientName: patientData ? `${patientData.firstName || ""} ${patientData.lastName || ""}`.trim() : "",
            fileNo: patientData?.fileNumber || patientData?.id || "",
            cprNo: patientData?.civilIdNumber || patientData?.cpr || "",
            ageSex: `${patientData?.age || ""}/${patientData?.gender || ""}`,
            createdBy: doctor || "",
            createdAt: new Date().toLocaleString(),
          });
          setSelectedFormType("customform");
        }
        setShowFormView(true);
        return;
      }
    }

    setShowFormView(true);
  };

  const fetchDiagnosisOptions = async () => {
    if (!patientId) return;

    try {
      const response = await axiosInstance.get(
        `diagnosis_by_patient/${patientId}`
      );

      if (response.data && Array.isArray(response.data)) {
        setDiagnosisOptions(response.data);
      } else if (response.data?.data && Array.isArray(response.data.data)) {
        setDiagnosisOptions(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching diagnosis options:", error);
      setDiagnosisOptions([]);
    }
  };

  const handleDiagnosisSelect = (diagnosis) => {
    const selectedText = diagnosis.diagnosis_text || diagnosis.name || diagnosis.diagnosis || "";
    const selectedId = String(diagnosis.id || diagnosis.diagnosis_id || "");
    setMedicalCertificateForm((prev) => {
      const existing = prev.diagnosis ? prev.diagnosis.trim() : "";
      const existingIds = prev.diagnosisId ? prev.diagnosisId.trim() : "";
      return {
        ...prev,
        diagnosis: existing ? `${existing}, ${selectedText}` : selectedText,
        diagnosisId: existingIds ? `${existingIds}, ${selectedId}` : selectedId,
      };
    });
    setDiagnosisSearch("");
    setShowDiagnosisDropdown(false);
  };

  const filteredDiagnosisOptions = diagnosisOptions.filter((option) => {
    const searchText = diagnosisSearch.toLowerCase();
    const diagnosisText = (
      option.diagnosis_text ||
      option.name ||
      option.diagnosis ||
      ""
    ).toLowerCase();
    return diagnosisText.includes(searchText);
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showDiagnosisDropdown &&
        !event.target.closest(".position-relative")
      ) {
        setShowDiagnosisDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showDiagnosisDropdown]);

  const fillReferralFormWithDate = async (dateToFill) => {
    if (!patientData || !patientId) return;

    try {
      // Fetch vitals from vitals API
      const vitalsResponse = await axiosInstance.get(
        `getPatientVitalsByPatientId/${patientId}`
      );

      // Fetch medical data for other fields
      const medicalResponse = await axiosInstance.get(
        `getAllMedicalDataByPatient/${patientId}`
      );

      let selectedVitals = null;
      let vitalsId = "";

      // Find vitals matching the selected date
      if (
        vitalsResponse.data.success &&
        vitalsResponse.data.vitals &&
        vitalsResponse.data.vitals.length > 0
      ) {
        selectedVitals = vitalsResponse.data.vitals.find((vital) => {
          const vitalDate = vital.recorded_at
            ? vital.recorded_at.split("T")[0]
            : "";
          return vitalDate === dateToFill;
        });

        if (selectedVitals) {
          vitalsId = selectedVitals.id;
        }
      }

      // Find medical record matching the selected date
      let selectedRecord = null;
      if (
        medicalResponse.data.success &&
        medicalResponse.data.data &&
        medicalResponse.data.data.length > 0
      ) {
        selectedRecord = medicalResponse.data.data.find((record) => {
          const recordDate = record.created_at
            ? record.created_at.split("T")[0]
            : "";
          return recordDate === dateToFill;
        });
      }

      if (selectedVitals || selectedRecord) {
        // Prepare vital signs from vitals API
        const vitalSigns = selectedVitals
          ? {
            bp: `${selectedVitals.blood_pressure_systolic || ""}/${selectedVitals.blood_pressure_diastolic || ""
              }`,
            temperature: selectedVitals.temperature || "",
            pulse: selectedVitals.pulse || "",
            weight: selectedVitals.weight || "",
            respiratoryRate: selectedVitals.respiratory_rate || "",
            spo2: selectedVitals.spo2 || "",
            rbs: selectedVitals.rbs_mg || "",
            height: selectedVitals.height || "",
            bmi: selectedVitals.bmi || "",
          }
          : {
            bp: "",
            temperature: "",
            pulse: "",
            weight: "",
            respiratoryRate: "",
            spo2: "",
            rbs: "",
            height: "",
            bmi: "",
          };

        const medicationsText =
          selectedRecord?.prescriptions?.length > 0
            ? selectedRecord.prescriptions
              .map((p) => {
                const medicines = p.medicines || [];
                return medicines
                  .map(
                    (m) => `${m.medicine_name || m.name} ${m.dosage || ""}`
                  )
                  .join(", ");
              })
              .join("; ")
            : "";

        // Get logged-in user details
        let loggedInUser = null;
        try {
          const userMedical = localStorage.getItem("userMedical");
          if (userMedical) {
            loggedInUser = JSON.parse(userMedical);
          }
        } catch (error) {
          console.error("Error parsing userMedical:", error);
        }

        const doctorName =
          loggedInUser?.DisplayName ||
          loggedInUser?.name ||
          loggedInUser?.data?.name ||
          "";
        const doctorPhone =
          loggedInUser?.phoneNumber ||
          loggedInUser?.mobileNumber ||
          loggedInUser?.data?.phoneNumber ||
          "";

        setReferralForm({
          patientName: `${patientData.firstName || ""} ${patientData.lastName || ""
            }`.trim(),
          cpr: patientData.cpr || patientData.civilIdNumber || "",
          age: selectedVitals?.age || patientData.age || "",
          sex: selectedVitals?.gender || patientData.gender || "",
          nationality: patientData.nationality || "",
          mobileNumber:
            patientData.mobileNumber || patientData.phoneNumber || "",
          referralType: referralForm.referralType || "internal",
          referralCategory: referralForm.referralCategory || "urgent",
          // User-editable fields - keep empty for user to fill
          reasonOfReferral: referralForm.reasonOfReferral || "",
          summaryOfPresentation: referralForm.summaryOfPresentation || "",
          // Auto-filled fields from medical data
          chiefComplain: selectedRecord?.chief_complaint || "",

          physicalExamination: selectedRecord
            ? `${selectedRecord.examination_general || ""}\n${selectedRecord.examination_systemic || ""
              }\n${selectedRecord.examination_local || ""}`.trim()
            : "",
          vitalSigns: vitalSigns,
          vitalsId: vitalsId, // Store vitals ID
          glasgowComaScale: {
            eye: referralForm.glasgowComaScale?.eye || "",
            motorResponse: referralForm.glasgowComaScale?.motorResponse || "",
            verbalResponse: referralForm.glasgowComaScale?.verbalResponse || "",
            totalScore: referralForm.glasgowComaScale?.totalScore || "",
          },
          generalExamination: selectedRecord?.examination_general || "",
          localExamination: selectedRecord?.examination_local || "",
          investigationsDone: referralForm.investigationsDone || "",
          procedureInterventions: selectedRecord?.treatment_plan || "",
          injectionsMedications: referralForm.injectionsMedications || "", // Preserve user-entered value
          prescriptionGiven: medicationsText, // Only from selected date
          notes: selectedRecord?.extra_notes || selectedVitals?.notes || "",
          advices: selectedRecord?.advises || "",
          referringDoctor: {
            name: referralForm.referringDoctor?.name || doctorName, // Auto-fill if empty
            date:
              referralForm.referringDoctor?.date ||
              new Date().toISOString().split("T")[0],
            time:
              referralForm.referringDoctor?.time ||
              new Date().toTimeString().slice(0, 5),
            phoneNumber:
              referralForm.referringDoctor?.phoneNumber || doctorPhone, // Auto-fill if empty
          },
          receivingDoctor: {
            name: referralForm.receivingDoctor?.name || "",
            date: referralForm.receivingDoctor?.date || "",
            time: referralForm.receivingDoctor?.time || "",
            phoneNumber: referralForm.receivingDoctor?.phoneNumber || "",
          },
        });
      } else {
        // Get logged-in user details
        let loggedInUser = null;
        try {
          const userMedical = localStorage.getItem("userMedical");
          if (userMedical) {
            loggedInUser = JSON.parse(userMedical);
          }
        } catch (error) {
          console.error("Error parsing userMedical:", error);
        }

        const doctorName =
          loggedInUser?.DisplayName ||
          loggedInUser?.name ||
          loggedInUser?.data?.name ||
          "";
        const doctorPhone =
          loggedInUser?.phoneNumber ||
          loggedInUser?.mobileNumber ||
          loggedInUser?.data?.phoneNumber ||
          "";

        // Reset form if no data found for date
        setReferralForm({
          patientName: `${patientData.firstName || ""} ${patientData.lastName || ""
            }`.trim(),
          cpr: patientData.cpr || patientData.civilIdNumber || "",
          age: patientData.age || "",
          sex: patientData.gender || "",
          nationality: patientData.nationality || "",
          mobileNumber:
            patientData.mobileNumber || patientData.phoneNumber || "",
          referralType: "internal",
          referralCategory: "urgent",
          reasonOfReferral: "",
          chiefComplain: "",
          summaryOfPresentation: "",
          physicalExamination: "",
          vitalSigns: {
            bp: "",
            temperature: "",
            pulse: "",
            weight: "",
            respiratoryRate: "",
            spo2: "",
            rbs: "",
            height: "",
            bmi: "",
          },
          vitalsId: "",
          glasgowComaScale: {
            eye: "",
            motorResponse: "",
            verbalResponse: "",
            totalScore: "",
          },
          generalExamination: "",
          localExamination: "",
          investigationsDone: "",
          procedureInterventions: "",
          injectionsMedications: "", // Keep empty - user will manually enter
          prescriptionGiven: "", // No prescription for this date
          notes: "",
          advices: "",
          referringDoctor: {
            name: doctorName, // Auto-fill
            date: new Date().toISOString().split("T")[0],
            time: new Date().toTimeString().slice(0, 5),
            phoneNumber: doctorPhone, // Auto-fill
          },
          receivingDoctor: { name: "", date: "", time: "", phoneNumber: "" },
        });
      }
    } catch (error) {
      console.error("Error fetching medical data for referral form:", error);
    }
  };
  const handleAmaFormChange = (field, value) => {
    setAmaForm({ ...amaForm, [field]: value });
  };

  const handleReferralFormChange = (field, value) => {
    if (field.includes(".")) {
      const [parent, child] = field.split(".");

      // Create a copy of the parent object with the new value
      const updatedParent = { ...referralForm[parent], [child]: value };

      // Auto-calculate GCS Total Score
      if (parent === "glasgowComaScale" && child !== "totalScore") {
        const eye = parseInt(updatedParent.eye) || 0;
        const motor = parseInt(updatedParent.motorResponse) || 0;
        const verbal = parseInt(updatedParent.verbalResponse) || 0;

        // Update total score
        updatedParent.totalScore = (eye + motor + verbal).toString();
      }

      setReferralForm({
        ...referralForm,
        [parent]: updatedParent,
      });
    } else {
      setReferralForm({ ...referralForm, [field]: value });
    }
  };

  const applyMedicalCertificateQuickDays = (days) => {
    const todayStr = new Date().toISOString().split("T")[0];
    const todayDiagnoses = diagnosisOptions.filter((option) => {
      if (!option.created_at) return false;
      const optionDate = new Date(option.created_at).toISOString().split("T")[0];
      return optionDate === todayStr;
    });
    const diagnosisText = todayDiagnoses
      .map((d) => d.diagnosis_text)
      .filter(Boolean)
      .join(", ");
    const diagnosisIds = todayDiagnoses
      .map((d) => (d.id !== undefined && d.id !== null ? String(d.id) : ""))
      .filter(Boolean)
      .join(", ");

    const isAccompanying = selectedFormType === "accompanyingCertificate";

    setMedicalCertificateForm((prev) => ({
      ...prev,
      reportedSick: isAccompanying ? false : true,
      patientUnfitForDuty: isAccompanying ? false : true,
      patientNeedsEmployeeCare: isAccompanying ? true : prev.patientNeedsEmployeeCare,
      noOfDaysOffFigures: days,
      noOfDaysOffWords: numberToWords(days),
      timeOfAttend: "",
      timeOfConsult: "",
      consultDate: todayStr,
      commencingOn: todayStr,
      admittedOn: "",
      dischargedOn: "",
      diagnosis: diagnosisText,
      diagnosisId: diagnosisIds,
    }));
  };

  const handleMedicalCertificateFormChange = (field, value) => {
    if (field === "noOfDaysOffFigures") {
      setMedicalCertificateForm((prev) => ({
        ...prev,
        noOfDaysOffFigures: value,
        noOfDaysOffWords: numberToWords(value),
      }));
    } else if (field.includes(".")) {
      const [parent, child] = field.split(".");
      setMedicalCertificateForm({
        ...medicalCertificateForm,
        [parent]: { ...medicalCertificateForm[parent], [child]: value },
      });
    } else {
      setMedicalCertificateForm({ ...medicalCertificateForm, [field]: value });
    }
  };

  const applySickLeaveQuickDays = (days) => {
    const todayStr = new Date().toISOString().split("T")[0];
    const commencingDate = new Date();
    commencingDate.setDate(commencingDate.getDate() + Number(days));
    const commencingStr = commencingDate.toISOString().split("T")[0];
    const todayDiagnoses = diagnosisOptions.filter((option) => {
      if (!option.created_at) return false;
      const optionDate = new Date(option.created_at).toISOString().split("T")[0];
      return optionDate === todayStr;
    });
    const diagnosisText = todayDiagnoses
      .map((d) => d.diagnosis_text)
      .filter(Boolean)
      .join(", ");
    const diagnosisIds = todayDiagnoses
      .map((d) => (d.id !== undefined && d.id !== null ? String(d.id) : ""))
      .filter(Boolean)
      .join(", ");

    setSickLeaveForm((prev) => ({
      ...prev,
      reportedSick: true,
      patientUnfitForDuty: true,
      noOfDaysOffFigures: days,
      noOfDaysOffWords: numberToWords(days),
      commencingOn: commencingStr,
      admittedOn: todayStr,
      dischargedOn: todayStr,
      diagnosis: diagnosisText,
      diagnosisId: diagnosisIds,
    }));
  };

  const handleSickLeaveFormChange = (field, value) => {
    if (field === "noOfDaysOffFigures") {
      setSickLeaveForm((prev) => ({
        ...prev,
        noOfDaysOffFigures: value,
        noOfDaysOffWords: numberToWords(value),
      }));
    } else {
      setSickLeaveForm((prev) => ({ ...prev, [field]: value }));
    }
  };

  const handleHouseMaidHealthCheckupFormChange = (field, value) => {
    setHouseMaidHealthCheckupForm({
      ...houseMaidHealthCheckupForm,
      [field]: value,
    });
  };

  const handleHealthFitnessCertificateFormChange = (field, value) => {
    let updatedForm = { ...healthFitnessCertificateForm, [field]: value };

    // Validation for TB Screening - Mutual Exclusivity
    if (field === "ppdReading" && value !== "") {
      updatedForm.igra = "";
    } else if (field === "igra" && value !== "") {
      updatedForm.ppdReading = "";
    } else if (field === "chestXray" && value !== "") {
      updatedForm.chestXrayNegative = "";
    } else if (field === "chestXrayNegative" && value !== "") {
      updatedForm.chestXray = "";
    }

    // Validation for Physical Examination - Clear Abnormal if Normal is selected
    if (field === "physicalGeneral" && value === "Normal")
      updatedForm.physicalGeneralAbnormal = "";
    if (field === "physicalChest" && value === "Normal")
      updatedForm.physicalChestAbnormal = "";
    if (field === "physicalHeart" && value === "Normal")
      updatedForm.physicalHeartAbnormal = "";
    if (field === "physicalAbdomen" && value === "Normal")
      updatedForm.physicalAbdomenAbnormal = "";
    if (field === "physicalOthers" && value === "Normal")
      updatedForm.physicalOthersAbnormal = "";

    setHealthFitnessCertificateForm(updatedForm);
  };

  // Handle date selection and auto-fill form with selected date's data
  const handleDateChange = (newDate) => {
    setSelectedDate(newDate);
    fillReferralFormWithDate(newDate);
  };

  const fillHouseMaidFormWithDate = async (dateToFill) => {
    if (!patientData || !patientId) return;

    try {
      const vitalsResponse = await axiosInstance.get(
        `getPatientVitalsByPatientId/${patientId}`
      );

      if (
        vitalsResponse.data.success &&
        vitalsResponse.data.vitals &&
        vitalsResponse.data.vitals.length > 0
      ) {
        const selectedVitals = vitalsResponse.data.vitals.find((vital) => {
          const vitalDate = vital.recorded_at
            ? vital.recorded_at.split("T")[0]
            : "";
          return vitalDate === dateToFill;
        });

        if (selectedVitals) {
          setHouseMaidHealthCheckupForm((prev) => ({
            ...prev,
            bloodPressure: `${selectedVitals.blood_pressure_systolic || ""}/${selectedVitals.blood_pressure_diastolic || ""
              }`,
            pulse: selectedVitals.pulse || "",
            heightCm: selectedVitals.height || "",
            weight: selectedVitals.weight || "",
            bmi: selectedVitals.bmi || "",
            vitalsId: selectedVitals.id || "",
          }));
        }
      }
    } catch (error) {
      console.error("Error fetching vitals for house maid form:", error);
    }
  };

  const handleHouseMaidDateChange = (newDate) => {
    setSelectedDate(newDate);
    fillHouseMaidFormWithDate(newDate);
  };

  const handleSaveForm = async () => {
    try {
      if (selectedFormType === "ama") {
        if (!amaForm.recommendation || amaForm.recommendation.trim() === "") {
          Swal.fire({
            icon: "warning",
            title: "Validation Error",
            text: "Physical recommendation is required",
          });
          return;
        }
        // Prepare API payload for Against Medical Advice form
        const payload = {
          cpr_no: amaForm.cprNo || patientData?.cpr || "",
          physical_recommendation: amaForm.recommendation,
          patient_signature: amaForm.patientSignature || "",
          patient_date:
            amaForm.patientSignatureDate ||
            (!editingFormId ? new Date().toISOString().split("T")[0] : ""),
          witness_name: amaForm.witnessName,
          witness_signature: amaForm.witnessSignature || "",
          witness_date:
            amaForm.witnessSignatureDate ||
            (!editingFormId ? new Date().toISOString().split("T")[0] : ""),
          created_at: amaForm.date,
        };

        let response;

        // Check if we're editing an existing form or creating a new one
        if (editingFormId) {
          // Update existing form
          response = await axiosInstance.put(
            `udpateAcknowledgementByFormId/${editingFormId}`,
            payload
          );
        } else {
          // Create new form (include patient_id only for creation)
          response = await axiosInstance.post(`addAcknowledgement/`, {
            ...payload,
            patient_id: patientId,
          });
        }

        if (
          response.data.success ||
          response.status === 200 ||
          response.status === 201
        ) {

          // Refresh all forms after successful save
          await fetchAllForms();

          setShowFormView(false);
          setSelectedFormType("");
          setEditingFormId(null);
          Swal.fire({
            icon: "success",
            title: editingFormId
              ? "Form Updated Successfully"
              : "Form Saved Successfully",
            text: editingFormId
              ? "Against Medical Advice form has been updated."
              : "Against Medical Advice form has been submitted.",
            timer: 2000,
          });
        } else {
          throw new Error("Failed to save form");
        }
      } else if (selectedFormType === "medicalCertificate" || selectedFormType === "accompanyingCertificate") {
        const data = {
          cpr_number:
            medicalCertificateForm.cprNumber || patientData?.cpr || "",
          medical_record_number:
            medicalCertificateForm.medicalRecordNumber || patientData?.id || "",
          reported_sick: medicalCertificateForm.reportedSick ? 1 : 0,
          accompanying_patient: medicalCertificateForm.accompanyingPatient
            ? 1
            : 0,
          accompany_name: medicalCertificateForm.accompanyingPersonName || "",
          accompany_id: medicalCertificateForm.accompanyingPersonId || "",
          time_of_attend: medicalCertificateForm.timeOfAttend,
          time_of_consult: medicalCertificateForm.timeOfConsult,
          consult_date: medicalCertificateForm.consultDate,
          patient_fit_for_duty: medicalCertificateForm.patientFitForDuty
            ? 1
            : 0,
          patient_unfit_for_duty: medicalCertificateForm.patientUnfitForDuty
            ? 1
            : 0,
          advised_light_duty: medicalCertificateForm.advisedLightDuty ? 1 : 0,
          patient_needs_employee_care:
            medicalCertificateForm.patientNeedsEmployeeCare ? 1 : 0,
          no_of_days_off_figures: medicalCertificateForm.noOfDaysOffFigures,
          no_of_days_off_words: medicalCertificateForm.noOfDaysOffWords,
          commencing_on: medicalCertificateForm.commencingOn,
          admitted_on: medicalCertificateForm.admittedOn,
          discharged_on: medicalCertificateForm.dischargedOn,
          diagnosis: medicalCertificateForm.diagnosisId || "",
          diagnosis_text: medicalCertificateForm.diagnosis || "",
          doctor_name: medicalCertificateForm.doctorName,
          license_no: medicalCertificateForm.licenseNo,
          specialty: medicalCertificateForm.specialty,
          issue_date: medicalCertificateForm.issueDate,
          certificate_registration_no:
            medicalCertificateForm.certificateRegistrationNo,
          facility_contact_address:
            medicalCertificateForm.facilityContactAddress,
        };

        let payload = data;

        // Add patient_id for new forms
        if (!editingFormId) {
          payload.patient_id = patientId;
          payload.branch_id = parseInt(localStorage.getItem('activeBranchId')) || null;
        }

        let response;

        // Check if we're editing an existing form or creating a new one
        if (editingFormId) {
          // Update existing certificate
          response = await axiosInstance.put(
            `updateMedicalCertificateById/${editingFormId}`,
            payload
          );
        } else {
          // Create new certificate
          response = await axiosInstance.post(`addMedicalCertificate`, payload);
        }

        if (
          response.data.success ||
          response.status === 200 ||
          response.status === 201
        ) {

          // Refresh all forms after successful save
          await fetchAllForms();

          setShowFormView(false);
          setSelectedFormType("");
          setEditingFormId(null);
          Swal.fire({
            icon: "success",
            title: editingFormId
              ? (selectedFormType === "accompanyingCertificate" ? "Accompanying Certificate Updated Successfully" : "Medical Certificate Updated Successfully")
              : (selectedFormType === "accompanyingCertificate" ? "Accompanying Certificate Saved Successfully" : "Medical Certificate Saved Successfully"),
            text: editingFormId
              ? (selectedFormType === "accompanyingCertificate" ? "Accompanying certificate has been updated." : "Medical certificate has been updated.")
              : (selectedFormType === "accompanyingCertificate" ? "Accompanying certificate has been submitted." : "Medical certificate has been submitted."),
            timer: 2000,
          });
        } else {
          throw new Error("Failed to save medical certificate");
        }
      } else if (selectedFormType === "sickLeave") {
        const data = {
          cpr_number: sickLeaveForm.cprNumber || patientData?.cpr || "",
          medical_record_number: sickLeaveForm.medicalRecordNumber || patientData?.id || "",
          reported_sick: sickLeaveForm.reportedSick ? 1 : 0,
          accompanying_patient: sickLeaveForm.accompanyingPatient ? 1 : 0,
          accompany_name: sickLeaveForm.accompanyingPersonName || "",
          accompany_id: sickLeaveForm.accompanyingPersonId || "",
          time_of_attend: sickLeaveForm.timeOfAttend,
          time_of_consult: sickLeaveForm.timeOfConsult,
          consult_date: sickLeaveForm.consultDate,
          patient_fit_for_duty: sickLeaveForm.patientFitForDuty ? 1 : 0,
          patient_unfit_for_duty: sickLeaveForm.patientUnfitForDuty ? 1 : 0,
          advised_light_duty: sickLeaveForm.advisedLightDuty ? 1 : 0,
          patient_needs_employee_care: sickLeaveForm.patientNeedsEmployeeCare ? 1 : 0,
          no_of_days_off_figures: sickLeaveForm.noOfDaysOffFigures,
          no_of_days_off_words: sickLeaveForm.noOfDaysOffWords,
          commencing_on: sickLeaveForm.commencingOn,
          admitted_on: sickLeaveForm.admittedOn,
          discharged_on: sickLeaveForm.dischargedOn,
          diagnosis: sickLeaveForm.diagnosisId || "",
          diagnosis_text: sickLeaveForm.diagnosis || "",
          doctor_name: sickLeaveForm.doctorName,
          license_no: sickLeaveForm.licenseNo,
          specialty: sickLeaveForm.specialty,
          issue_date: sickLeaveForm.issueDate,
          certificate_registration_no: sickLeaveForm.certificateRegistrationNo,
          facility_contact_address: sickLeaveForm.facilityContactAddress,
        };

        let slPayload = data;
        if (!editingFormId) slPayload.patient_id = patientId;

        let response;
        if (editingFormId) {
          response = await axiosInstance.put(`updateSickLeaveById/${editingFormId}`, slPayload);
        } else {
          response = await axiosInstance.post(`addSickLeave`, slPayload);
        }

        if (response.data.success || response.status === 200 || response.status === 201) {
          await fetchAllForms();
          setShowFormView(false);
          setSelectedFormType("");
          setEditingFormId(null);
          Swal.fire({
            icon: "success",
            title: editingFormId ? "Sick Leave Updated Successfully" : "Sick Leave Saved Successfully",
            text: editingFormId ? "Sick leave has been updated." : "Sick leave has been submitted.",
            timer: 2000,
          });
        } else {
          throw new Error("Failed to save sick leave");
        }
      } else if (selectedFormType === "referral") {
        // Prepare API payload for Referral Form
        const payload = {
          cpr_number: referralForm.cpr || patientData?.cpr || "",
          referral_type: referralForm.referralType || "internal",
          referral_category: referralForm.referralCategory || "routine",
          reason_of_referral: referralForm.reasonOfReferral || "",
          chief_complaint: referralForm.chiefComplain || "",
          summary_presentation: referralForm.summaryOfPresentation || "",
          vitals: referralForm.vitalsId || "",
          gcs_eye: referralForm.glasgowComaScale?.eye || "",
          gcs_motor_response:
            referralForm.glasgowComaScale?.motorResponse || "",
          gcs_verbal_response:
            referralForm.glasgowComaScale?.verbalResponse || "",
          gcs_total_score: referralForm.glasgowComaScale?.totalScore || "",
          general_examination: referralForm.generalExamination || "",
          local_examination: referralForm.localExamination || "",
          investigations_done: referralForm.investigationsDone || "",
          procedures_and_interventions:
            referralForm.procedureInterventions || "",
          injections_and_medications: referralForm.injectionsMedications || "",
          prescription_given: referralForm.prescriptionGiven || "",
          notes: referralForm.notes || "",
          advices: referralForm.advices || "",
          referring_doctor_name: referralForm.referringDoctor?.name || "",
          referring_doctor_date: referralForm.referringDoctor?.date || "",
          referring_doctor_time: referralForm.referringDoctor?.time || "",
          referring_doctor_phone:
            referralForm.referringDoctor?.phoneNumber || "",
          receiving_doctor_name: referralForm.receivingDoctor?.name || "",
          receiving_doctor_date: referralForm.receivingDoctor?.date || "",
          receiving_doctor_time: referralForm.receivingDoctor?.time || "",
          receiving_doctor_phone:
            referralForm.receivingDoctor?.phoneNumber || "",

          // Add Vital Signs explicitly
          blood_pressure: referralForm.vitalSigns?.bp || "",
          temperature: referralForm.vitalSigns?.temperature || "",
          pulse: referralForm.vitalSigns?.pulse || "",
          weight: referralForm.vitalSigns?.weight || "",
          rbs: referralForm.vitalSigns?.rbs || "",
          random_blood_sugar: referralForm.vitalSigns?.rbs || "",
          respiratory_rate: referralForm.vitalSigns?.respiratoryRate || "",
          spo2: referralForm.vitalSigns?.spo2 || "",
        };

        let response;

        if (editingFormId) {
          response = await axiosInstance.put(
            `updateReferralFormById/${editingFormId}`,
            payload
          );
        } else {
          response = await axiosInstance.post(`addReferalForm`, {
            ...payload,
            patient_id: patientId,
          });
        }

        if (
          response.data.success ||
          response.status === 200 ||
          response.status === 201
        ) {

          // Refresh all forms after successful save
          await fetchAllForms();

          setShowFormView(false);
          setSelectedFormType("");
          setEditingFormId(null);
          Swal.fire({
            icon: "success",
            title: editingFormId
              ? "Referral Form Updated Successfully"
              : "Referral Form Saved Successfully",
            timer: 2000,
          });
        } else {
          throw new Error("Failed to save referral form");
        }
      } else if (selectedFormType === "healthFitnessCertificate") {
        const payload = {
          patient_id: patientId,
          cpr_number:
            healthFitnessCertificateForm.cprNumber ||
            patientData?.civilIdNumber ||
            patientData?.cpr ||
            "",
          profession: healthFitnessCertificateForm.profession || "",
          facility_name: healthFitnessCertificateForm.facilityName || "",
          hiv1_hiv2: healthFitnessCertificateForm.hiv1Hiv2 || "Negative",
          // hiv1_hiv2_findings:
          //   healthFitnessCertificateForm.hiv1Hiv2Findings || "",
          hbsag: healthFitnessCertificateForm.hbsag || "Negative",
          // hbsag_findings: healthFitnessCertificateForm.hbsagFindings || "",
          hcv: healthFitnessCertificateForm.hcv || "Negative",
          // hcv_examination: healthFitnessCertificateForm.hcvExamination || "",
          // hcv_findings: healthFitnessCertificateForm.hcvFindings || "",
          blood_pressure: healthFitnessCertificateForm.bloodPressure || "",
          random_blood_sugar:
            healthFitnessCertificateForm.randomBloodSugar || "",
          ppd_reading: healthFitnessCertificateForm.ppdReading || "",
          igra: healthFitnessCertificateForm.igra || "",
          chest_xray: healthFitnessCertificateForm.chestXray || "",

          tb_screening_guideline:
            healthFitnessCertificateForm.chestXrayNegative ||
            healthFitnessCertificateForm.tbScreeningGuideline ||
            "",
          physical_general:
            healthFitnessCertificateForm.physicalGeneral || "Normal",
          // physical_general_abnormal:
          //   healthFitnessCertificateForm.physicalGeneralAbnormal || "",
          physical_chest:
            healthFitnessCertificateForm.physicalChest || "Normal",
          // physical_chest_abnormal:
          // healthFitnessCertificateForm.physicalChestAbnormal || "",
          physical_heart:
            healthFitnessCertificateForm.physicalHeart || "Normal",
          // physical_heart_abnormal:
          // healthFitnessCertificateForm.physicalHeartAbnormal || "",
          physical_abdomen:
            healthFitnessCertificateForm.physicalAbdomen || "Normal",
          // physical_abdomen_abnormal:
          // healthFitnessCertificateForm.physicalAbdomenAbnormal || "",
          physical_others: healthFitnessCertificateForm.physicalOthers || "",
          // physical_others_abnormal:
          // healthFitnessCertificateForm.physicalOthersAbnormal || "",
          referral: healthFitnessCertificateForm.referral || "",
          vaccination_comments:
            healthFitnessCertificateForm.vaccinationComments || "",
          vaccination_status:
            healthFitnessCertificateForm.vaccinationStatus || "Completed",
          health_declaration: healthFitnessCertificateForm.healthDeclaration
            ? 1
            : 0,
          certificate_declaration:
            healthFitnessCertificateForm.certificateDeclaration ? 1 : 0,
          performed_by_name: healthFitnessCertificateForm.performedByName || "",
          license_number: healthFitnessCertificateForm.licenseNumber || "",
          category: healthFitnessCertificateForm.category || "",
          examination_date:
            healthFitnessCertificateForm.examinationDate ||
            new Date().toISOString(),
        };

        let response;

        if (editingFormId) {

          response = await axiosInstance.put(
            `updateHealthCertificateById/${editingFormId}`,
            payload
          );
        } else {
          response = await axiosInstance.post(
            `addHealthFitnessCertificate`,
            payload
          );
        }

        if (
          response.data.success ||
          response.status === 200 ||
          response.status === 201
        ) {

          // Refresh all forms after successful save
          await fetchAllForms();

          setShowFormView(false);
          setSelectedFormType("");
          setEditingFormId(null);
          Swal.fire({
            icon: "success",
            title: editingFormId
              ? "Health Fitness Certificate Updated Successfully"
              : "Health Fitness Certificate Saved Successfully",
            timer: 2000,
          });
        } else {
          throw new Error("Failed to save health fitness certificate");
        }
      } else if (selectedFormType === "houseMaidHealthCheckup") {
        const payload = {
          patient_id: patientId,
          reg_number: houseMaidHealthCheckupForm.refNumber || "REG-00123",
          visit_date:
            houseMaidHealthCheckupForm.visitDate ||
            new Date().toISOString().split("T")[0],
          doctor_name: houseMaidHealthCheckupForm.doctorName || "",
          mobile_number: houseMaidHealthCheckupForm.mobileNumber || "",
          cvr_number: houseMaidHealthCheckupForm.civilId || "",

          // Vitals (stored as ID)
          vitals: houseMaidHealthCheckupForm.vitalsId || null,

          // Vision
          right_eye_reading: houseMaidHealthCheckupForm.rightEyeReadings || "",
          right_eye_result: houseMaidHealthCheckupForm.rightEyeStatus || "",
          left_eye_reading: houseMaidHealthCheckupForm.leftEyeReadings || "",
          left_eye_result: houseMaidHealthCheckupForm.leftEyeStatus || "",
          color_vision_reading:
            houseMaidHealthCheckupForm.colorVisionReadings || "",
          color_vision_result:
            houseMaidHealthCheckupForm.colorVisionStatus || "",
          vision_comments: houseMaidHealthCheckupForm.eyeComment || "",

          // Clinical Examination
          cardio_general_appearance:
            houseMaidHealthCheckupForm.generalAppearanceStatus || "",
          cardio_general_remarks:
            houseMaidHealthCheckupForm.generalAppearanceRemarks || "",
          cardio_auscultation:
            houseMaidHealthCheckupForm.cardioAuscultationStatus || "",
          cardio_auscultation_remarks:
            houseMaidHealthCheckupForm.cardioAuscultationRemarks || "",
          respiratory_auscultation:
            houseMaidHealthCheckupForm.respAuscultationStatus || "",
          respiratory_auscultation_remarks:
            houseMaidHealthCheckupForm.respAuscultationRemarks || "",
          respiratory_chest_xray:
            houseMaidHealthCheckupForm.chestXrayStatus || "",
          respiratory_chest_xray_remarks:
            houseMaidHealthCheckupForm.chestXrayRemarks || "",

          // Serology
          hiv_result:
            (houseMaidHealthCheckupForm.hivResult || "")
              .charAt(0)
              .toUpperCase() +
            (houseMaidHealthCheckupForm.hivResult || "").slice(1) || "",
          hiv_comments: houseMaidHealthCheckupForm.hivComments || "",
          hbsag_result:
            (houseMaidHealthCheckupForm.hbsagResult || "")
              .charAt(0)
              .toUpperCase() +
            (houseMaidHealthCheckupForm.hbsagResult || "").slice(1) || "",
          hbsag_comments: houseMaidHealthCheckupForm.hbsagComments || "",
          hcv_result:
            (houseMaidHealthCheckupForm.hcvResult || "")
              .charAt(0)
              .toUpperCase() +
            (houseMaidHealthCheckupForm.hcvResult || "").slice(1) || "",
          hcv_comments: houseMaidHealthCheckupForm.hcvComments || "",
          vdrl_result:
            (houseMaidHealthCheckupForm.vdrlResult || "")
              .charAt(0)
              .toUpperCase() +
            (houseMaidHealthCheckupForm.vdrlResult || "").slice(1) || "",
          vdrl_comments: houseMaidHealthCheckupForm.vdrlComments || "",

          // Stool
          stool_ova_parasites:
            (houseMaidHealthCheckupForm.ovaParasitesStatus || "")
              .charAt(0)
              .toUpperCase() +
            (houseMaidHealthCheckupForm.ovaParasitesStatus || "").slice(1) ||
            "",
          stool_comments: `${houseMaidHealthCheckupForm.ovaParasitesComments || ""
            } ||| ${houseMaidHealthCheckupForm.ovaParasitesTreatments || ""}`,

          // Urine
          urine_sugar:
            (houseMaidHealthCheckupForm.urineSugarStatus || "")
              .charAt(0)
              .toUpperCase() +
            (houseMaidHealthCheckupForm.urineSugarStatus || "").slice(1) ||
            "",
          urine_albumin:
            (houseMaidHealthCheckupForm.urineAlbuminStatus || "")
              .charAt(0)
              .toUpperCase() +
            (houseMaidHealthCheckupForm.urineAlbuminStatus || "").slice(1) ||
            "",
          urine_blood:
            (houseMaidHealthCheckupForm.urineBloodStatus || "")
              .charAt(0)
              .toUpperCase() +
            (houseMaidHealthCheckupForm.urineBloodStatus || "").slice(1) ||
            "",
          urine_sugar_comment:
            houseMaidHealthCheckupForm.urineSugarComments || "",
          urine_albumin_comment:
            houseMaidHealthCheckupForm.urineAlbuminComments || "",
          urine_blood_comment:
            houseMaidHealthCheckupForm.urineBloodComments || "",

          // Footer
          additional_notes: houseMaidHealthCheckupForm.notes || "",
          result_status:
            houseMaidHealthCheckupForm.result?.charAt(0).toUpperCase() +
            houseMaidHealthCheckupForm.result?.slice(1) || "",
          examined_by_doctor: houseMaidHealthCheckupForm.examinerName || "",
          examination_date: houseMaidHealthCheckupForm.examinerDateTime
            ? houseMaidHealthCheckupForm.examinerDateTime.replace("T", " ") +
            ":00"
            : new Date().toISOString().slice(0, 19).replace("T", " "),
        };

        let response;
        if (editingFormId) {

          response = await axiosInstance.put(
            `updateHousemaidCertificateById/${editingFormId}`,
            payload
          );
        } else {
          response = await axiosInstance.post(
            `addHousemaidHealthCheckupCertificate`,
            payload
          );
        }

        if (
          response.data.success ||
          response.status === 200 ||
          response.status === 201
        ) {

          // Refresh all forms after successful save
          await fetchAllForms();

          setShowFormView(false);
          setSelectedFormType("");
          setEditingFormId(null);
          Swal.fire({
            icon: "success",
            title: "Form Saved Successfully",
            text: "House Maid Health Checkup form has been submitted.",
            timer: 2000,
          });
        } else {
          throw new Error("Failed to save form");
        }
      } else if (selectedFormType === "consent") {
        const content = consentEditorInstanceRef.current
          ? consentEditorInstanceRef.current.getData()
          : consentForm.content;
        const payload = {
          template_id: consentForm.templateId,
          template_name: consentForm.templateName,
          title: consentForm.title,
          content,
          patient_name: consentForm.patientName,
          file_no: consentForm.fileNo,
          cpr_no: consentForm.cprNo,
          age_sex: consentForm.ageSex,
          created_by: consentForm.createdBy,
          patient_signature: patientSigRef.current && !patientSigRef.current.isEmpty()
            ? patientSigRef.current.toDataURL("image/png")
            : consentForm.patientSignature || "",
          user_signature: userSigRef.current && !userSigRef.current.isEmpty()
            ? userSigRef.current.toDataURL("image/png")
            : consentForm.userSignature || "",
        };
        let response;
        if (editingFormId) {
          response = await axiosInstance.put(`updatePatientConsentForm/${editingFormId}`, payload);
        } else {
          response = await axiosInstance.post(`addPatientConsentForm`, { ...payload, patient_id: patientId });
        }
        if (response.data.success || response.status === 200 || response.status === 201) {
          await fetchAllForms();
          setShowFormView(false);
          setSelectedFormType("");
          setEditingFormId(null);
          Swal.fire({ icon: "success", title: editingFormId ? "Updated Successfully" : "Saved Successfully", timer: 2000 });
        } else {
          throw new Error("Failed to save consent form");
        }
      } else if (selectedFormType === "customform") {
        const content = customFormEditorInstanceRef.current
          ? customFormEditorInstanceRef.current.getData()
          : customForm.content;
        const payload = {
          template_id: customForm.templateId,
          template_name: customForm.templateName,
          title: customForm.title,
          content,
          patient_name: customForm.patientName,
          file_no: customForm.fileNo,
          cpr_no: customForm.cprNo,
          age_sex: customForm.ageSex,
          created_by: customForm.createdBy,
        };
        let response;
        if (editingFormId) {
          response = await axiosInstance.put(`updatePatientCustomForm/${editingFormId}`, payload);
        } else {
          response = await axiosInstance.post(`addPatientCustomForm`, { ...payload, patient_id: patientId });
        }
        if (response.data.success || response.status === 200 || response.status === 201) {
          await fetchAllForms();
          setShowFormView(false);
          setSelectedFormType("");
          setEditingFormId(null);
          Swal.fire({ icon: "success", title: editingFormId ? "Updated Successfully" : "Saved Successfully", timer: 2000 });
        } else {
          throw new Error("Failed to save custom form");
        }
      } else {
        // For other form types, save locally
        const newForm = {
          id: Date.now(),
          type: selectedFormType,
          data: referralForm,
          createdAt: new Date().toISOString(),
        };
        setForms([...forms, newForm]);
        setShowFormView(false);
        setSelectedFormType("");
        Swal.fire({ icon: "success", title: "Form Saved", timer: 2000 });
      }
    } catch (error) {
      console.error("Error saving form:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.message ||
          "Failed to save form. Please try again.",
      });
    }
  };

  const handleViewForm = (form) => {
    setSelectedFormType(form.type);
    setIsViewOnly(true); // Set view-only mode
    const doctorInfo = getLoggedInDoctorInfo();
    let formData = { ...form.data };

    if (form.type === "ama") {
      setAmaForm(form.data);
    } else if (form.type === "medicalCertificate" || form.type === "accompanyingCertificate") {
      setMedicalCertificateForm(formData);
      // Fetch diagnosis options and set search text
      fetchDiagnosisOptions();
      setDiagnosisSearch(formData.diagnosis || "");
    } else if (form.type === "sickLeave") {
      setSickLeaveForm(formData);
      fetchDiagnosisOptions();
      setDiagnosisSearch(formData.diagnosis || "");
    } else if (form.type === "referral") {
      setReferralForm(formData);
    } else if (form.type === "healthFitnessCertificate") {
      setHealthFitnessCertificateForm(formData);

    } else if (form.type === "houseMaidHealthCheckup") {
      setHouseMaidHealthCheckupForm(formData);

    } else if (form.type === "consent") {
      setConsentForm(form.data);
    } else if (form.type === "customform") {
      setCustomForm(form.data);
    } else {
      setReferralForm(form.data);
    }
    setShowFormView(true);
  };

  const handleEditForm = (form) => {
    setSelectedFormType(form.type);
    setIsViewOnly(false); // Enable editing
    const doctorInfo = getLoggedInDoctorInfo();
    let formData = { ...form.data };

    if (form.type === "ama") {
      setAmaForm(form.data);
      // Use dbId (actual database ID) for editing, not the timestamp-based apiId
      setEditingFormId(form.dbId || null);
    } else if (form.type === "medicalCertificate" || form.type === "accompanyingCertificate") {
      setMedicalCertificateForm(formData);
      setEditingFormId(form.dbId || null);
      // Fetch diagnosis options and set search text
      fetchDiagnosisOptions();
      setDiagnosisSearch(formData.diagnosis || "");
    } else if (form.type === "sickLeave") {
      setSickLeaveForm(formData);
      setEditingFormId(form.dbId || null);
      fetchDiagnosisOptions();
      setDiagnosisSearch(formData.diagnosis || "");
    } else if (form.type === "referral") {
      setReferralForm(formData);
      setEditingFormId(form.dbId || null);
    } else if (form.type === "healthFitnessCertificate") {
      setHealthFitnessCertificateForm(formData);
      setEditingFormId(form.dbId || null);

    } else if (form.type === "houseMaidHealthCheckup") {
      setHouseMaidHealthCheckupForm(formData);
      setEditingFormId(form.dbId || null);

    } else if (form.type === "consent") {
      setConsentForm(form.data);
      setEditingFormId(form.dbId || null);
    } else if (form.type === "customform") {
      setCustomForm(form.data);
      setEditingFormId(form.dbId || null);
    } else {
      setReferralForm(form.data);
    }
    setShowFormView(true);
  };

  const handleDeleteForm = async (id) => {
    const formToDelete = forms.find((form) => form.id === id);

    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          if (formToDelete?.type === "ama" && formToDelete?.dbId) {
            const response = await axiosInstance.delete(
              `deleteAcknowledgementByFormId/${formToDelete.dbId}`
            );

            if (
              response.data.success ||
              response.status === 200 ||
              response.status === 204
            ) {
              try {
                const acknowledgementResponse = await axiosInstance.get(
                  `getAcknowledgementByPatientId/${patientId}`
                );
                const responseData =
                  acknowledgementResponse.data?.data ||
                  acknowledgementResponse.data;

                if (
                  responseData &&
                  Array.isArray(responseData) &&
                  responseData.length > 0
                ) {
                  const amaForms = responseData.map((ack, index) => ({
                    id: ack.created_at
                      ? new Date(ack.created_at).getTime()
                      : Date.now() + index,


                    type: "ama",
                    data: {
                      patientName:
                        ack.patientName ||
                        `${patientData?.firstName || ""} ${patientData?.lastName || ""
                          }`.trim(),
                      fileNo: ack.fileNumber || patientData?.id || "",
                      date: ack.created_at ? ack.created_at.split("T")[0] : "",
                      cprNo:
                        ack.cpr_no ||
                        ack.civilIdNumber ||
                        patientData?.cpr ||
                        "",
                      physician:
                        ack.sent_by_doctor?.displayName ||
                        ack.sent_by_doctor?.fullName ||
                        ack.sent_by_name ||
                        ack.doctorName ||
                        patientData?.Primary_Doctor ||
                        "",
                      ageSex: `${ack.age || patientData?.age || ""}/${ack.gender || patientData?.gender || ""
                        }`,
                      recommendation: ack.physical_recommendation || "",
                      patientSignature: ack.patient_signature || "",
                      patientSignatureDate: ack.patient_date
                        ? ack.patient_date.split("T")[0]
                        : "",
                      witnessName: ack.witness_name || "",
                      witnessSignature: ack.witness_signature || "",
                      witnessSignatureDate: ack.witness_date
                        ? ack.witness_date.split("T")[0]
                        : "",
                    },
                    createdAt: ack.created_at || new Date().toISOString(),
                    apiId: ack.created_at
                      ? new Date(ack.created_at).getTime()
                      : Date.now() + index,
                    dbId: ack.id,
                  }));
                  setForms((prevForms) => {
                    const otherForms = prevForms.filter(
                      (f) => f.type !== "ama"
                    );
                    return [...otherForms, ...amaForms];
                  });
                } else {
                  // If no forms left, remove all AMA forms but keep others
                  setForms((prevForms) =>
                    prevForms.filter((f) => f.type !== "ama")
                  );
                }
              } catch (fetchError) {
                console.error("Error fetching updated forms:", fetchError);
                // Still remove from local state even if fetch fails
                setForms(forms.filter((form) => form.id !== id));
              }

              Swal.fire(
                "Deleted!",
                "Form has been deleted successfully.",
                "success"
              );
            } else {
              throw new Error("Failed to delete form");
            }
          } else if (
            (formToDelete?.type === "medicalCertificate" || formToDelete?.type === "accompanyingCertificate") &&
            formToDelete?.dbId
          ) {

            const response = await axiosInstance.delete(
              `deleteMedicalCertificateDetailsById/${formToDelete.dbId}`
            );

            if (
              response.data.success ||
              response.status === 200 ||
              response.status === 204
            ) {
              try {
                const medicalCertResponse = await axiosInstance.get(
                  `getMedicalCertificateDetailsByPatientId/${patientId}`
                );

                // Handle nested response structure
                const responseData =
                  medicalCertResponse.data?.data || medicalCertResponse.data;
                const certData =
                  responseData?.medical_certificates || responseData;
                const patientInfo = responseData?.patient || patientData;
                const diagnosisInfo = responseData?.diagnosis || [];

                if (
                  certData &&
                  Array.isArray(certData) &&
                  certData.length > 0
                ) {
                  const medicalCertForms = certData.map((cert, index) => {
                    const diagnosisText =
                      diagnosisInfo.length > 0
                        ? diagnosisInfo.map((d) => d.diagnosis_text).join(", ")
                        : "";

                    return {
                      id: cert.created_at
                        ? new Date(cert.created_at).getTime()
                        : Date.now() + index + 10000,
                      type: (cert.accompanying_patient === 1 || cert.accompanying_patient === true) ? "accompanyingCertificate" : "medicalCertificate",
                      data: {
                        patientName: `${patientInfo?.firstName || ""} ${patientInfo?.lastName || ""
                          }`.trim(),
                        cprNumber:
                          cert.cpr_number || patientInfo?.civilIdNumber || "",
                        medicalRecordNumber:
                          cert.medical_record_number || patientInfo?.id || "",
                        reportedSick:
                          cert.reported_sick === 1 ||
                          cert.reported_sick === true,
                        accompanyingPatient:
                          cert.accompanying_patient === 1 ||
                          cert.accompanying_patient === true,
                        timeOfAttend: cert.time_of_attend || "",
                        timeOfConsult: cert.time_of_consult || "",
                        consultDate: cert.consult_date
                          ? cert.consult_date.split("T")[0]
                          : "",
                        patientFitForDuty:
                          cert.patient_fit_for_duty === 1 ||
                          cert.patient_fit_for_duty === true,
                        patientUnfitForDuty:
                          cert.patient_unfit_for_duty === 1 ||
                          cert.patient_unfit_for_duty === true,
                        advisedLightDuty:
                          cert.advised_light_duty === 1 ||
                          cert.advised_light_duty === true,
                        patientNeedsEmployeeCare:
                          cert.patient_needs_employee_care === 1 ||
                          cert.patient_needs_employee_care === true,
                        noOfDaysOffFigures:
                          cert.no_of_days_off_figures?.toString() || "",
                        noOfDaysOffWords: cert.no_of_days_off_words || "",
                        commencingOn: cert.commencing_on
                          ? cert.commencing_on.split("T")[0]
                          : "",
                        admittedOn: cert.admitted_on
                          ? cert.admitted_on.split("T")[0]
                          : "",
                        dischargedOn: cert.discharged_on
                          ? cert.discharged_on.split("T")[0]
                          : "",
                        diagnosis: diagnosisText || cert.diagnosis || "",
                        doctorName:
                          cert.sent_by_doctor?.displayName ||
                          cert.sent_by_doctor?.fullName ||
                          cert.doctor_name ||
                          "",
                        licenseNo:
                          cert.sent_by_doctor?.licenseId ||
                          patientInfo?.licenseId ||
                          cert.license_no ||
                          "",
                        specialty:
                          cert.sent_by_doctor?.specialty ||
                          patientInfo?.specialty ||
                          cert.specialty ||
                          "",
                        issueDate: cert.issue_date
                          ? cert.issue_date.split("T")[0]
                          : cert.created_at
                            ? cert.created_at.split("T")[0]
                            : "",
                        certificateRegistrationNo:
                          cert.certificate_registration_no || "",
                        facilityContactAddress:
                          cert.facility_contact_address || "",
                      },
                      createdAt: cert.created_at || new Date().toISOString(),
                      apiId: cert.created_at
                        ? new Date(cert.created_at).getTime()
                        : Date.now() + index + 10000,
                      dbId: cert.certificate_id || cert.id,
                    };
                  });

                  setForms((prevForms) => {
                    const otherForms = prevForms.filter(
                      (f) =>
                        f.type !== "medicalCertificate" &&
                        f.type !== "accompanyingCertificate"
                    );
                    return [...otherForms, ...medicalCertForms];
                  });
                } else {
                  setForms((prevForms) =>
                    prevForms.filter(
                      (f) =>
                        f.type !== "medicalCertificate" &&
                        f.type !== "accompanyingCertificate"
                    )
                  );
                }
              } catch (fetchError) {
                console.error(
                  "Error fetching updated medical certificates:",
                  fetchError
                );
                // Still remove from local state even if fetch fails
                setForms(forms.filter((form) => form.id !== id));
              }

              Swal.fire(
                "Deleted!",
                "Medical certificate has been deleted successfully.",
                "success"
              );
            } else {
              throw new Error("Failed to delete medical certificate");
            }
          } else if (formToDelete?.type === "sickLeave" && formToDelete?.dbId) {
            const response = await axiosInstance.delete(`deleteSickLeaveById/${formToDelete.dbId}`);
            if (response.data.success || response.status === 200 || response.status === 204) {
              try {
                const slResponse = await axiosInstance.get(`getSickLeaveByPatientId/${patientId}`);
                const slData = slResponse.data?.data || slResponse.data;
                const slCerts = slData?.sick_leave_certificates || slData;
                const slPatientInfo = slData?.patient || patientData;

                if (slCerts && Array.isArray(slCerts) && slCerts.length > 0) {
                  const updatedForms = slCerts.map((cert, index) => ({
                    id: cert.created_at ? new Date(cert.created_at).getTime() + 50000 + index : Date.now() + index + 50000,
                    type: "sickLeave",
                    createdBy: cert.sent_by_doctor?.displayName || cert.sent_by_doctor?.fullName || cert.doctor_name || "",
                    data: {
                      patientName: `${slPatientInfo?.firstName || ""} ${slPatientInfo?.lastName || ""}`.trim(),
                      cprNumber: cert.cpr_number || slPatientInfo?.civilIdNumber || "",
                      medicalRecordNumber: cert.medical_record_number || slPatientInfo?.fileNumber || "",
                      reportedSick: cert.reported_sick === 1 || cert.reported_sick === true,
                      accompanyingPatient: cert.accompanying_patient === 1 || cert.accompanying_patient === true,
                      accompanyingPersonName: cert.accompany_name || "",
                      accompanyingPersonId: cert.accompany_id || "",
                      timeOfAttend: cert.time_of_attend || "",
                      timeOfConsult: cert.time_of_consult || "",
                      consultDate: cert.consult_date ? cert.consult_date.split("T")[0] : "",
                      patientFitForDuty: cert.patient_fit_for_duty === 1 || cert.patient_fit_for_duty === true,
                      patientUnfitForDuty: cert.patient_unfit_for_duty === 1 || cert.patient_unfit_for_duty === true,
                      advisedLightDuty: cert.advised_light_duty === 1 || cert.advised_light_duty === true,
                      patientNeedsEmployeeCare: cert.patient_needs_employee_care === 1 || cert.patient_needs_employee_care === true,
                      noOfDaysOffFigures: cert.no_of_days_off_figures?.toString() || "",
                      noOfDaysOffWords: cert.no_of_days_off_words || "",
                      commencingOn: cert.commencing_on ? cert.commencing_on.split("T")[0] : "",
                      admittedOn: cert.admitted_on ? cert.admitted_on.split("T")[0] : "",
                      dischargedOn: cert.discharged_on ? cert.discharged_on.split("T")[0] : "",
                      diagnosis: cert.diagnosis_text || cert.diagnosis || "",
                      diagnosisId: cert.diagnosis_id || "",
                      doctorName: cert.sent_by_doctor?.displayName || cert.sent_by_doctor?.fullName || cert.doctor_name || "",
                      licenseNo: cert.sent_by_doctor?.licenseId || cert.license_no || "",
                      specialty: cert.sent_by_doctor?.specialty || cert.specialty || "",
                      doctorSignature: cert.sent_by_doctor?.signature || null,
                      doctorStamp: cert.sent_by_doctor?.stamp || null,
                      issueDate: cert.issue_date ? cert.issue_date.split("T")[0] : cert.created_at ? cert.created_at.split("T")[0] : "",
                      certificateRegistrationNo: cert.certificate_registration_no || "",
                      facilityContactAddress: cert.facility_contact_address || "",
                    },
                    createdAt: cert.created_at || new Date().toISOString(),
                    apiId: cert.created_at ? new Date(cert.created_at).getTime() + 50000 + index : Date.now() + index + 50000,
                    dbId: cert.certificate_id || cert.id,
                  }));
                  setForms((prevForms) => {
                    const otherForms = prevForms.filter((f) => f.type !== "sickLeave");
                    return [...otherForms, ...updatedForms];
                  });
                } else {
                  setForms((prevForms) => prevForms.filter((f) => f.type !== "sickLeave"));
                }
              } catch (fetchError) {
                console.error("Error fetching updated sick leave forms:", fetchError);
                setForms(forms.filter((form) => form.id !== id));
              }
              Swal.fire("Deleted!", "Sick leave has been deleted successfully.", "success");
            } else {
              throw new Error("Failed to delete sick leave");
            }
          } else if (formToDelete?.type === "referral" && formToDelete?.dbId) {
            const response = await axiosInstance.delete(
              `deleteReferralFormById/${formToDelete.dbId}`
            );

            if (
              response.data.success ||
              response.status === 200 ||
              response.status === 204
            ) {
              try {
                const referralResponse = await axiosInstance.get(
                  `getReferralDetailsByPatientId/${patientId}`
                );
                const referralData =
                  referralResponse.data?.data || referralResponse.data;

                if (
                  referralData &&
                  Array.isArray(referralData) &&
                  referralData.length > 0
                ) {
                  const referralForms = referralData.map((ref, index) => {
                    const uniqueId = ref.created_at
                      ? new Date(ref.created_at).getTime()
                      : Date.now() + index + 20000;

                    return {
                      id: uniqueId,
                      type: "referral",
                      data: {
                        patientName: `${ref.firstName || ""} ${ref.lastName || ""
                          }`.trim(),
                        cpr: ref.cpr_number || ref.civilIdNumber || "",
                        age: ref.age?.toString() || "",
                        sex: ref.gender || "",
                        nationality: ref.nationality || "",
                        mobileNumber: ref.mobileNumber || "",
                        referralType: ref.referral_type || "",
                        referralCategory: ref.referral_category || "",
                        reasonOfReferral: ref.reason_of_referral || "",
                        chiefComplaint: ref.chief_complaint || "",
                        summaryPresentation: ref.summary_presentation || "",
                        vitalSigns: {
                          bloodPressure: ref.blood_pressure || "",
                          respiratoryRate: ref.respiratory_rate || "",
                          pulse: ref.pulse || "",
                          spo2: ref.spo2 || "",
                          temperature:
                            ref.temperature || ref.vitals?.toString() || "",
                          weight: ref.weight || "",
                        },
                        glasgowComaScale: {
                          eye: ref.gcs_eye || "",
                          motorResponse: ref.gcs_motor_response || "",
                          verbalResponse: ref.gcs_verbal_response || "",
                          totalScore: ref.gcs_total_score?.toString() || "",
                        },
                        generalExamination: ref.general_examination || "",
                        localExamination: ref.local_examination || "",
                        investigationsDone: ref.investigations_done || "",
                        procedureInterventions:
                          ref.procedures_and_interventions || "",
                        injectionsMedications:
                          ref.injections_and_medications || "",
                        prescriptionGiven: ref.prescription_given || "",
                        notes: ref.notes || "",
                        advices: ref.advices || "",
                        referringDoctor: {
                          name:
                            ref.sent_by_doctor?.displayName ||
                            ref.sent_by_doctor?.fullName ||
                            ref.sent_by_doctor.displayName ||
                            "",
                          date:
                            ref.referring_doctor_date &&
                              ref.referring_doctor_date !== "0000-00-00"
                              ? ref.referring_doctor_date.split("T")[0]
                              : "",
                          time: ref.referring_doctor_time || "",
                          phoneNumber:
                            ref.sent_by_doctor?.phoneNumber ||
                            ref.referring_doctor_phone ||
                            "",
                        },
                        receivingDoctor: {
                          name: ref.receiving_doctor_name || "",
                          date:
                            ref.receiving_doctor_date &&
                              ref.receiving_doctor_date !== "0000-00-00"
                              ? ref.receiving_doctor_date.split("T")[0]
                              : "",
                          time: ref.receiving_doctor_time || "",
                          phoneNumber: ref.receiving_doctor_phone || "",
                        },
                      },
                      createdAt: ref.created_at || new Date().toISOString(),
                      apiId: uniqueId,
                      dbId: ref.referral_form_id || ref.id,
                    };
                  });
                  // Update forms list, keeping other forms and replacing referral forms
                  setForms((prevForms) => {
                    const otherForms = prevForms.filter(
                      (f) => f.type !== "referral"
                    );
                    return [...otherForms, ...referralForms];
                  });
                } else {
                  // If no forms left, remove all referral forms
                  setForms((prevForms) =>
                    prevForms.filter((f) => f.type !== "referral")
                  );
                }
              } catch (fetchError) {
                console.error(
                  "Error fetching updated referral forms:",
                  fetchError
                );
                // Still remove from local state even if fetch fails
                setForms(forms.filter((form) => form.id !== id));
              }

              Swal.fire(
                "Deleted!",
                "Referral form has been deleted successfully.",
                "success"
              );
            } else {
              throw new Error("Failed to delete referral form");
            }
          } else if (
            formToDelete?.type === "healthFitnessCertificate" &&
            formToDelete?.dbId
          ) {
            const response = await axiosInstance.delete(
              `deleteHealthCertificateById/${formToDelete.dbId}`
            );

            if (
              response.data.success ||
              response.status === 200 ||
              response.status === 204
            ) {
              try {
                const healthFitnessResponse = await axiosInstance.get(
                  `getHealthCertificateByPatientId/${patientId}`
                );
                const healthFitnessData =
                  healthFitnessResponse.data?.data ||
                  healthFitnessResponse.data;

                if (
                  healthFitnessData &&
                  Array.isArray(healthFitnessData) &&
                  healthFitnessData.length > 0
                ) {
                  const healthFitnessForms = healthFitnessData.map(
                    (cert, index) => {
                      const uniqueId = cert.created_at
                        ? new Date(cert.created_at).getTime()
                        : Date.now() + index + 30000;

                      return {
                        id: uniqueId,
                        type: "healthFitnessCertificate",
                        data: {
                          name: `${patientData?.firstName || ""} ${patientData?.lastName || ""
                            }`.trim(),
                          cprNumber:
                            cert.cpr_number || patientData?.civilIdNumber || "",
                          profession: cert.profession || "",
                          facilityName: cert.facility_name || "",
                          hiv1Hiv2: cert.hiv1_hiv2 || "",
                          // hiv1Hiv2Findings: cert.hiv1_hiv2_findings || "",
                          hbsag: cert.hbsag || "",
                          // hbsagFindings: cert.hbsag_findings || "",
                          hcv: cert.hcv || "",
                          // hcvExamination: cert.hcv_examination || "",
                          // hcvFindings: cert.hcv_findings || "",
                          bloodPressure: cert.blood_pressure || "",
                          randomBloodSugar: cert.random_blood_sugar || "",
                          ppdReading: cert.ppd_reading || "",
                          igra: cert.igra || "",
                          chestXray: cert.chest_xray || "",
                          chestXrayNegative: cert.tb_screening_guideline || "",
                          tbScreeningGuideline:
                            cert.tb_screening_guideline || "",
                          physicalGeneral: cert.physical_general || "",
                          // physicalGeneralAbnormal:
                          // cert.physical_general_abnormal || "",
                          physicalChest: cert.physical_chest || "",
                          // physicalChestAbnormal:
                          //   cert.physical_chest_abnormal || "",
                          physicalHeart: cert.physical_heart || "",
                          // physicalHeartAbnormal:
                          // cert.physical_heart_abnormal || "",
                          physicalAbdomen: cert.physical_abdomen || "",
                          // physicalAbdomenAbnormal:
                          // cert.physical_abdomen_abnormal || "",
                          physicalOthers: cert.physical_others || "",
                          // physicalOthersAbnormal:
                          // cert.physical_others_abnormal || "",
                          referral: cert.referral || "",
                          vaccinationComments: cert.vaccination_comments || "",
                          vaccinationStatus: cert.vaccination_status || "",
                          healthDeclaration:
                            cert.health_declaration === 1 ||
                            cert.health_declaration === true,
                          certificateDeclaration:
                            cert.certificate_declaration === 1 ||
                            cert.certificate_declaration === true,
                          performedByName:
                            cert.sent_by_doctor?.displayName ||
                            cert.sent_by_doctor?.fullName ||
                            cert.performed_by_name ||
                            "",
                          licenseNumber:
                            cert.sent_by_doctor?.licenseId ||
                            cert.license_number ||
                            "",
                          category: cert.category || "",
                          examinationDate: cert.examination_date
                            ? cert.examination_date.split("T")[0]
                            : "",
                        },
                        createdAt: cert.created_at || new Date().toISOString(),
                        apiId: uniqueId,
                        dbId: cert.id || cert.certificate_id,
                      };
                    }
                  );
                  // Update forms list, keeping other forms and replacing health fitness forms
                  setForms((prevForms) => {
                    const otherForms = prevForms.filter(
                      (f) => f.type !== "healthFitnessCertificate"
                    );
                    return [...otherForms, ...healthFitnessForms];
                  });
                } else {
                  // If no forms left, remove all health fitness forms
                  setForms((prevForms) =>
                    prevForms.filter(
                      (f) => f.type !== "healthFitnessCertificate"
                    )
                  );
                }
              } catch (fetchError) {
                console.error(
                  "Error fetching updated health fitness certificates:",
                  fetchError
                );
                // Still remove from local state even if fetch fails
                setForms(forms.filter((form) => form.id !== id));
              }

              Swal.fire(
                "Deleted!",
                "Health fitness certificate has been deleted successfully.",
                "success"
              );
            } else {
              throw new Error("Failed to delete health fitness certificate");
            }
          } else if (
            formToDelete?.type === "houseMaidHealthCheckup" &&
            formToDelete?.dbId
          ) {

            const response = await axiosInstance.delete(
              `deleteHousemaidCertificateById/${formToDelete.dbId}`
            );

            if (
              response.data.success ||
              response.status === 200 ||
              response.status === 204
            ) {
              try {
                const housemaidResponse = await axiosInstance.get(
                  `getHousemaidHealthCheckupByPatientId/${patientId}`
                );
                const housemaidData =
                  housemaidResponse.data?.data || housemaidResponse.data;

                if (
                  housemaidData &&
                  Array.isArray(housemaidData) &&
                  housemaidData.length > 0
                ) {
                  const housemaidForms = housemaidData.map((cert, index) => {
                    const uniqueId = cert.created_at
                      ? new Date(cert.created_at).getTime()
                      : Date.now() + index + 40000;

                    return {
                      id: uniqueId,
                      type: "houseMaidHealthCheckup",
                      data: {
                        // Patient Info
                        patientName: `${patientData?.firstName || ""} ${patientData?.lastName || ""
                          }`.trim(),
                        visitDate: cert.visit_date
                          ? cert.visit_date.split("T")[0]
                          : "",
                        mobileNumber: cert.mobile_number || "",
                        refNumber: cert.reg_number || "",
                        civilId: cert.cvr_number || "",
                        doctorName:
                          cert.sent_by_doctor?.displayName ||
                          cert.sent_by_doctor?.fullName ||
                          cert.doctor_name ||
                          "",
                        examinerLicense:
                          cert.sent_by_doctor?.licenseId ||
                          cert.doctor_licenseId ||
                          cert.examiner_license ||
                          "",
                        rightEyeReadings: cert.right_eye_reading || "",
                        rightEyeStatus: cert.right_eye_result || "",
                        leftEyeReadings: cert.left_eye_reading || "",
                        leftEyeStatus: cert.left_eye_result || "",
                        colorVisionReadings: cert.color_vision_reading || "",
                        colorVisionStatus: cert.color_vision_result || "",
                        eyeComment: cert.vision_comments || "",

                        // Clinical Examination
                        generalAppearanceStatus:
                          cert.cardio_general_appearance || "",
                        generalAppearanceRemarks:
                          cert.cardio_general_remarks || "",
                        cardioAuscultationStatus:
                          cert.cardio_auscultation || "",
                        cardioAuscultationRemarks:
                          cert.cardio_auscultation_remarks || "",
                        respAuscultationStatus:
                          cert.respiratory_auscultation || "",
                        respAuscultationRemarks:
                          cert.respiratory_auscultation_remarks || "",
                        chestXrayStatus: cert.respiratory_chest_xray || "",
                        chestXrayRemarks:
                          cert.respiratory_chest_xray_remarks || "",

                        // Serology
                        hivResult: cert.hiv_result || "",
                        hivComments: cert.hiv_comments || "",
                        hbsagResult: cert.hbsag_result || "",
                        hbsagComments: cert.hbsag_comments || "",
                        hcvResult: cert.hcv_result || "",
                        hcvComments: cert.hcv_comments || "",
                        vdrlResult: cert.vdrl_result || "",
                        vdrlComments: cert.vdrl_comments || "",

                        // Stool
                        ovaParasitesStatus: cert.stool_ova_parasites || "",
                        ovaParasitesDetails: cert.stool_comments || "",

                        // Urine
                        urineSugarStatus: cert.urine_sugar || "",
                        urineSugarComments: cert.urine_sugar_comment || "",
                        urineAlbuminStatus: cert.urine_albumin || "",
                        urineAlbuminComments: cert.urine_albumin_comment || "",
                        urineBloodStatus: cert.urine_blood || "",
                        urineBloodComments: cert.urine_blood_comment || "",

                        // Footer
                        notes: cert.additional_notes || "",
                        resultStatus: cert.result_status || "",
                        examinerName:
                          cert.sent_by_doctor?.displayName ||
                          cert.sent_by_doctor?.fullName ||
                          cert.examined_by_doctor ||
                          "",
                        examinerDateTime:
                          cert.examination_date?.split("T")[0] || "",
                      },
                      createdAt: cert.created_at || new Date().toISOString(),
                      apiId: uniqueId,
                      dbId: cert.id || cert.certificate_id,
                    };
                  });
                  // Update forms list, keeping other forms and replacing housemaid forms
                  setForms((prevForms) => {
                    const otherForms = prevForms.filter(
                      (f) => f.type !== "houseMaidHealthCheckup"
                    );
                    return [...otherForms, ...housemaidForms];
                  });
                } else {
                  // If no forms left, remove all housemaid forms
                  setForms((prevForms) =>
                    prevForms.filter((f) => f.type !== "houseMaidHealthCheckup")
                  );
                }
              } catch (fetchError) {
                console.error(
                  "Error fetching updated house maid health checkup certificates:",
                  fetchError
                );
                // Still remove from local state even if fetch fails
                setForms(forms.filter((form) => form.id !== id));
              }

              Swal.fire(
                "Deleted!",
                "House maid health checkup has been deleted successfully.",
                "success"
              );
            } else {
              throw new Error("Failed to delete house maid health checkup");
            }
          } else if (formToDelete?.type === "consent" && formToDelete?.dbId) {
            await axiosInstance.delete(`deletePatientConsentForm/${formToDelete.dbId}`);
            setForms(forms.filter((form) => form.id !== id));
            Swal.fire("Deleted!", "Consent form has been deleted.", "success");
          } else if (formToDelete?.type === "customform" && formToDelete?.dbId) {
            await axiosInstance.delete(`deletePatientCustomForm/${formToDelete.dbId}`);
            setForms(forms.filter((form) => form.id !== id));
            Swal.fire("Deleted!", "Custom form has been deleted.", "success");
          } else {
            // For local forms, just remove from state
            setForms(forms.filter((form) => form.id !== id));
            Swal.fire("Deleted!", "Form has been deleted.", "success");
          }
        } catch (error) {
          console.error("Error deleting form:", error);
          Swal.fire({
            icon: "error",
            title: "Error",
            text:
              error.response?.data?.message ||
              "Failed to delete form. Please try again.",
          });
        }
      }
    });
  };

  const generateHealthFitnessPDF = (originalFormData) => {
    // Override doctor info with logged in user
    let formData = { ...originalFormData };
    const doctorInfo = getLoggedInDoctorInfo();
    if (doctorInfo.name && !formData.performedByName) {
      formData.performedByName = doctorInfo.name;
    }
    if (doctorInfo.license && !formData.licenseNumber) {
      formData.licenseNumber = doctorInfo.license;
    }

    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    // Add background image (full page)
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    doc.addImage(pdfHealth, "JPEG", 0, 0, pageWidth, pageHeight);
    doc.setFillColor(255, 255, 255);
    // Rectangle
    doc.rect(80, 20, 60, 10, "F");

    // logo part
    const PX_TO_MM = 0.264583;

    const addLogo = (imgData, yMm) => {
      const imgProps = doc.getImageProperties(imgData);

      // Page width in mm
      const pageWidth = doc.internal.pageSize.getWidth();

      // Convert image size from px → mm
      let imgWidthMm = imgProps.width * PX_TO_MM;
      let imgHeightMm = imgProps.height * PX_TO_MM;

      // Max dimensions in mm
      const maxWidth = pageWidth - 40;
      const maxHeight = 15;

      // Scale ratio
      const widthRatio = maxWidth / imgWidthMm;
      const heightRatio = maxHeight / imgHeightMm;
      const ratio = Math.min(widthRatio, heightRatio, 1);

      // Final scaled size (mm)
      const finalWidth = imgWidthMm * ratio;
      const finalHeight = imgHeightMm * ratio;

      // Center horizontally (mm)
      const centeredX = (pageWidth - finalWidth) / 2;

      doc.addImage(
        imgData,
        (imgProps.fileType || "PNG").toUpperCase(),
        centeredX,
        5,
        finalWidth,
        finalHeight
      );
    };
    try {
      if (
        businessLogo &&
        typeof businessLogo === "string" &&
        businessLogo.startsWith("data:image/") &&
        businessLogo.includes("base64")
      ) {
        addLogo(businessLogo, 20);
      } else {
        throw new Error("Invalid logo format");
      }
    } catch (err) {
      console.warn(err.message);
      addLogo(logo1, 10);
    }

    // logo part end

    doc.setTextColor(0, 0, 0);
    doc.setFontSize(11);
    let x = 50.7;
    let y = 56;
    const lineGap = 6.2;

    // Dynamic patient information
    const patientName =
      formData.name ||
      patientData?.firstName + " " + patientData?.lastName ||
      "";
    const cprNumber =
      formData.cprNumber ||
      patientData?.civilIdNumber ||
      patientData?.cpr ||
      "";
    const profession = formData.profession || "";
    const doctorName = formData.performedByName || "";

    // Text lines to print with dynamic data
    const lines = [patientName, cprNumber, profession, doctorName];

    // Draw each line
    lines.forEach((text, index) => {
      doc.text(text, x, y + index * lineGap);
    });

    // HIV/AIDS, HBsAg, HCV test results (dynamic)
    const hiv1Hiv2 = formData.hiv1Hiv2 || "Negative";
    const hbsag = formData.hbsag || "Negative";
    const hcv = formData.hcv || "Negative";

    // Positive column
    doc.text(hiv1Hiv2 === "Positive" ? "Yes" : "No", 50.5, 92);
    doc.text(hbsag === "Positive" ? "Yes" : "No", 50.5, 101);
    doc.text(hcv === "Positive" ? "Yes" : "No", 50.5, 110);

    // Negative column
    doc.text(hiv1Hiv2 === "Negative" ? "Yes" : "No", 85, 92);
    doc.text(hbsag === "Negative" ? "Yes" : "No", 85, 101);
    doc.text(hcv === "Negative" ? "Yes" : "No", 85, 110);

    // Blood pressure (dynamic)
    const bloodPressure = formData.bloodPressure || "";
    if (bloodPressure) {
      doc.text(bloodPressure, 170, 92);
    }

    // Random blood sugar (dynamic)
    const randomBloodSugar = formData.randomBloodSugar || "";
    if (randomBloodSugar) {
      doc.text(randomBloodSugar, 170, 101);
    }

    // TB screening results (dynamic)
    const ppdReading = formData.ppdReading || "";
    const igra = formData.igra || "";
    const chestXray = formData.chestXray || "";
    // Use tbScreeningGuideline as fallback if chestXrayNegative is not explicitly set (for compatibility)
    const chestXrayNegative =
      formData.chestXrayNegative || formData.tbScreeningGuideline || "";

    // TB screening positive column
    // Row 1: PPD Reading
    if (ppdReading) {
      doc.text(ppdReading, 62, 130.3);
    }
    // Row 2: Chest X-ray
    if (chestXray) {
      doc.text(chestXray, 62, 139.3);
    }

    // TB screening negative column
    // Row 1: IGRA
    if (igra) {
      doc.text(igra, 131, 130.3);
    }
    // Row 2: Chest X-ray Negative
    if (chestXrayNegative) {
      doc.text(chestXrayNegative, 131, 139.3);
    }

    // Physical examination results (dynamic)
    const physicalGeneral = formData.physicalGeneral || "Normal";
    const physicalChest = formData.physicalChest || "Normal";
    const physicalHeart = formData.physicalHeart || "Normal";
    const physicalAbdomen = formData.physicalAbdomen || "Normal";
    const physicalOthers = formData.physicalOthers || "Normal";

    // Physical examine left column (Normal column)
    const x1 = 62;
    let y1 = 160;
    const gap = 6.3;

    const physicalResults = [
      physicalGeneral === "Normal" ? "Yes" : "No",
      physicalChest === "Normal" ? "Yes" : "No",
      physicalHeart === "Normal" ? "Yes" : "No",
      physicalAbdomen === "Normal" ? "Yes" : "No",
      physicalOthers === "Normal" ? "Yes" : "No",
    ];

    physicalResults.forEach((text, i) => {
      doc.text(text, x1, y1 + i * gap);
    });

    // Right column (Abnormal column)
    const x12 = 131;
    let y12 = 160;
    const gap2 = 6.3;

    const physicalResultsOpposite = [
      physicalGeneral === "Normal" ? "No" : "Yes",
      physicalChest === "Normal" ? "No" : "Yes",
      physicalHeart === "Normal" ? "No" : "Yes",
      physicalAbdomen === "Normal" ? "No" : "Yes",
      physicalOthers === "Normal" ? "No" : "Yes",
    ];

    physicalResultsOpposite.forEach((text, i) => {
      doc.text(text, x12, y12 + i * gap2);
    });
    doc.setFillColor(255, 255, 255);
    doc.rect(100, 187, 100, 5, "F");
    doc.text(formData.referral, 62, 191);
    // Health declaration checkbox (dynamic)
    doc.setFillColor(255, 255, 255);
    doc.rect(5.5, 202.7, 10, 5, "F");

    if (formData.healthDeclaration) {
      // Checkbox position and size
      const checkboxX1 = 12;
      const checkboxY1 = 202.7;
      const checkboxSize1 = 3;

      // Draw rectangle for checkbox
      doc.setLineWidth(0.5);
      doc.rect(checkboxX1, checkboxY1, checkboxSize1, checkboxSize1);

      // Draw checkmark inside the rectangle
      doc.setLineWidth(0.5);
      doc.line(
        checkboxX1 + 0.6,
        checkboxY1 + 1.5,
        checkboxX1 + 1.2,
        checkboxY1 + 2.2
      );
      doc.line(
        checkboxX1 + 1.2,
        checkboxY1 + 2.2,
        checkboxX1 + 3,
        checkboxY1 + 0.3
      );
    }

    // Vaccination comments (dynamic)
    const vaccinationComments = formData.vaccinationComments || "";
    if (vaccinationComments) {
      doc.text(vaccinationComments, 87, 225.5);
    }

    // Certificate declaration checkbox (dynamic)
    doc.setFillColor(255, 255, 255);
    doc.rect(5.5, 237, 10, 5, "F");

    if (formData.certificateDeclaration) {
      // Adjusted checkbox position and size
      const checkboxX = 12;
      const checkboxY = 238.5;
      const checkboxSize = 3;

      // Draw rectangle for checkbox
      doc.setLineWidth(0.5);
      doc.rect(checkboxX, checkboxY, checkboxSize, checkboxSize);

      // Draw checkmark inside the rectangle
      doc.setLineWidth(0.5);
      doc.line(
        checkboxX + 0.6,
        checkboxY + 1.5,
        checkboxX + 1.2,
        checkboxY + 2.2
      );
      doc.line(
        checkboxX + 1.2,
        checkboxY + 2.2,
        checkboxX + 3,
        checkboxY + 0.3
      );
    }

    // Examination performed by details (dynamic)
    const licenseNumber = formData.licenseNumber || "";
    const category = formData.category || "";
    const examinationDate =
      formData.examinationDate || new Date().toLocaleDateString();

    const x13 = 86.5;
    let y13 = 257.2;
    const gap3 = 6.3;

    const examinerDetails = [
      doctorName,
      licenseNumber,
      category,
      examinationDate,
    ];

    examinerDetails.forEach((text, i) => {
      if (text) {
        doc.text(text, x13, y13 + i * gap3);
      }
    });

    const pdfBlob = doc.output("bloburl");
    window.open(pdfBlob, "_blank");
  };

  // const generatehealth = () => {
  //   const doc = new jsPDF({
  //     orientation: "portrait",
  //     unit: "mm",
  //     format: "a4",
  //   });

  //   // Add background image (full page)
  //   const pageWidth = doc.internal.pageSize.getWidth();
  //   const pageHeight = doc.internal.pageSize.getHeight();

  //   doc.addImage(pdfHealth, "JPEG", 0, 0, pageWidth, pageHeight);
  //   doc.setFillColor(255, 255, 255);
  //   // Rectangle
  //   doc.rect(80, 20, 60, 10, "F");

  //   // Logo section
  //   const logoWidth = 25;
  //   const logoHeight = 20;
  //   doc.addImage(logo1, "jpeg", 90, 15, logoWidth, logoHeight);
  //   doc.setTextColor(0, 0, 0);
  //   doc.setFontSize(11);
  //   let x = 50.7;
  //   let y = 56;
  //   const lineGap = 6.2;

  //   // Dynamic patient information
  //   const patientName = healthFitnessCertificateForm.name || patientData?.firstName + " " + patientData?.lastName || "";
  //   const cprNumber = healthFitnessCertificateForm.cprNumber || patientData?.civilIdNumber || patientData?.cpr || "";
  //   const profession = healthFitnessCertificateForm.profession || "";
  //   const doctorName = healthFitnessCertificateForm.performedByName || "";

  //   // Text lines to print with dynamic data
  //   const lines = [patientName, cprNumber, profession, doctorName];

  //   // Draw each line
  //   lines.forEach((text, index) => {
  //     doc.text(text, x, y + index * lineGap);
  //   });

  //   // HIV/AIDS, HBsAg, HCV test results (dynamic)
  //   const hiv1Hiv2 = healthFitnessCertificateForm.hiv1Hiv2 || "Negative";
  //   const hbsag = healthFitnessCertificateForm.hbsag || "Negative";
  //   const hcv = healthFitnessCertificateForm.hcv || "Negative";

  //   // Positive column
  //   doc.text(hiv1Hiv2 === "Positive" ? "Yes" : "No", 50.5, 92);
  //   doc.text(hbsag === "Positive" ? "Yes" : "No", 50.5, 101);
  //   doc.text(hcv === "Positive" ? "Yes" : "No", 50.5, 110);

  //   // Negative column
  //   doc.text(hiv1Hiv2 === "Negative" ? "Yes" : "No", 85, 92);
  //   doc.text(hbsag === "Negative" ? "Yes" : "No", 85, 101);
  //   doc.text(hcv === "Negative" ? "Yes" : "No", 85, 110);

  //   // Blood pressure (dynamic)
  //   const bloodPressure = healthFitnessCertificateForm.bloodPressure || "";
  //   if (bloodPressure) {
  //     doc.text(bloodPressure, 170, 92);
  //   }

  //   // Random blood sugar (dynamic)
  //   const randomBloodSugar = healthFitnessCertificateForm.randomBloodSugar || "";
  //   if (randomBloodSugar) {
  //     doc.text(randomBloodSugar, 170, 101);
  //   }

  //   // TB screening results (dynamic)
  //   const ppdReading = healthFitnessCertificateForm.ppdReading || "";
  //   const igra = healthFitnessCertificateForm.igra || "";
  //   const chestXray = healthFitnessCertificateForm.chestXray || "";
  //   const tbScreeningGuideline = healthFitnessCertificateForm.tbScreeningGuideline || "";

  //   // TB screening positive column
  //   doc.text(ppdReading.toLowerCase().includes("positive") ? "Yes" : "No", 62, 130.3);
  //   doc.text(igra.toLowerCase().includes("positive") ? "Yes" : "No", 62, 139.3);

  //   // TB screening negative column
  //   doc.text(ppdReading.toLowerCase().includes("negative") ? "Yes" : "No", 131, 130.3);
  //   doc.text(igra.toLowerCase().includes("negative") ? "Yes" : "No", 131, 139.3);

  //   // Physical examination results (dynamic)
  //   const physicalGeneral = healthFitnessCertificateForm.physicalGeneral || "Normal";
  //   const physicalChest = healthFitnessCertificateForm.physicalChest || "Normal";
  //   const physicalHeart = healthFitnessCertificateForm.physicalHeart || "Normal";
  //   const physicalAbdomen = healthFitnessCertificateForm.physicalAbdomen || "Normal";
  //   const physicalOthers = healthFitnessCertificateForm.physicalOthers || "Normal";

  //   // Physical examine left column
  //   const x1 = 62;
  //   let y1 = 160;
  //   const gap = 6.3;

  //   const physicalResults = [
  //     physicalGeneral === "Normal" ? "No" : "Yes",
  //     physicalChest === "Normal" ? "No" : "Yes",
  //     physicalHeart === "Normal" ? "No" : "Yes",
  //     physicalAbdomen === "Normal" ? "No" : "Yes",
  //     physicalOthers === "Normal" ? "No" : "Yes"
  //   ];

  //   physicalResults.forEach((text, i) => {
  //     doc.text(text, x1, y1 + i * gap);
  //   });

  //   // Right column (opposite results)
  //   const x12 = 131;
  //   let y12 = 160;
  //   const gap2 = 6.3;

  //   const physicalResultsOpposite = [
  //     physicalGeneral === "Normal" ? "Yes" : "No",
  //     physicalChest === "Normal" ? "Yes" : "No",
  //     physicalHeart === "Normal" ? "Yes" : "No",
  //     physicalAbdomen === "Normal" ? "Yes" : "No",
  //     physicalOthers === "Normal" ? "Yes" : "No"
  //   ];

  //   physicalResultsOpposite.forEach((text, i) => {
  //     doc.text(text, x12, y12 + i * gap2);
  //   });

  //   // Health declaration checkbox (dynamic)
  //   doc.setFillColor(255, 255, 255);
  //   doc.rect(5.5, 202.7, 10, 5, "F");

  //   if (healthFitnessCertificateForm.healthDeclaration) {
  //     // Checkbox position and size
  //     const checkboxX1 = 12;
  //     const checkboxY1 = 202.7;
  //     const checkboxSize1 = 3;

  //     // Draw rectangle for checkbox
  //     doc.setLineWidth(0.5);
  //     doc.rect(checkboxX1, checkboxY1, checkboxSize1, checkboxSize1);

  //     // Draw checkmark inside the rectangle
  //     doc.setLineWidth(0.5);
  //     doc.line(checkboxX1 + 0.6, checkboxY1 + 1.5, checkboxX1 + 1.2, checkboxY1 + 2.2);
  //     doc.line(checkboxX1 + 1.2, checkboxY1 + 2.2, checkboxX1 + 3, checkboxY1 + 0.3);
  //   }

  //   // Vaccination comments (dynamic)
  //   const vaccinationComments = healthFitnessCertificateForm.vaccinationComments || "";
  //   if (vaccinationComments) {
  //     doc.text(vaccinationComments, 87, 225.5);
  //   }

  //   // Certificate declaration checkbox (dynamic)
  //   doc.setFillColor(255, 255, 255);
  //   doc.rect(5.5, 237, 10, 5, "F");

  //   if (healthFitnessCertificateForm.certificateDeclaration) {
  //     // Adjusted checkbox position and size
  //     const checkboxX = 12;
  //     const checkboxY = 238.5;
  //     const checkboxSize = 3;

  //     // Draw rectangle for checkbox
  //     doc.setLineWidth(0.5);
  //     doc.rect(checkboxX, checkboxY, checkboxSize, checkboxSize);

  //     // Draw checkmark inside the rectangle
  //     doc.setLineWidth(0.5);
  //     doc.line(checkboxX + 0.6, checkboxY + 1.5, checkboxX + 1.2, checkboxY + 2.2);
  //     doc.line(checkboxX + 1.2, checkboxY + 2.2, checkboxX + 3, checkboxY + 0.3);
  //   }

  //   // Examination performed by details (dynamic)
  //   const licenseNumber = healthFitnessCertificateForm.licenseNumber || "";
  //   const category = healthFitnessCertificateForm.category || "";
  //   const examinationDate = healthFitnessCertificateForm.examinationDate || new Date().toLocaleDateString();

  //   const x13 = 86.5;
  //   let y13 = 257.2;
  //   const gap3 = 6.3;

  //   const examinerDetails = [
  //     doctorName,
  //     licenseNumber,
  //     category,
  //     examinationDate
  //   ];

  //   examinerDetails.forEach((text, i) => {
  //     if (text) {
  //       doc.text(text, x13, y13 + i * gap3);
  //     }
  //   });

  //   const pdfBlob = doc.output("bloburl");
  //   window.open(pdfBlob, "_blank");
  // };

  const generateReferralPDF = (originalFormData) => {
    // Override doctor info with logged in user
    let formData = { ...originalFormData };
    const doctorInfo = getLoggedInDoctorInfo();
    if (doctorInfo.name) {
      if (!formData.referringDoctor) formData.referringDoctor = {};
      if (!formData.referringDoctor.name) {
        formData.referringDoctor.name = doctorInfo.name;
      }
      if (!formData.referringDoctor.phoneNumber) {
        formData.referringDoctor.phoneNumber =
          doctorInfo.phone || formData.referringDoctor.phoneNumber;
      }
    }

    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });
    // Add background image (full page)
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // logo part
    const PX_TO_MM = 0.264583;

    const addLogo = (imgData, yMm) => {
      const imgProps = doc.getImageProperties(imgData);

      // Page width in mm
      const pageWidth = doc.internal.pageSize.getWidth();

      // Convert image size from px → mm
      let imgWidthMm = imgProps.width * PX_TO_MM;
      let imgHeightMm = imgProps.height * PX_TO_MM;

      // Max dimensions in mm
      const maxWidth = pageWidth - 40;
      const maxHeight = 15;

      // Scale ratio
      const widthRatio = maxWidth / imgWidthMm;
      const heightRatio = maxHeight / imgHeightMm;
      const ratio = Math.min(widthRatio, heightRatio, 1);

      // Final scaled size (mm)
      const finalWidth = imgWidthMm * ratio;
      const finalHeight = imgHeightMm * ratio;

      // Center horizontally (mm)
      const centeredX = (pageWidth - finalWidth) / 2;

      doc.addImage(
        imgData,
        (imgProps.fileType || "PNG").toUpperCase(),
        centeredX,
        5,
        finalWidth,
        finalHeight
      );
    };
    try {
      if (
        businessLogo &&
        typeof businessLogo === "string" &&
        businessLogo.startsWith("data:image/") &&
        businessLogo.includes("base64")
      ) {
        addLogo(businessLogo, 20);
      } else {
        throw new Error("Invalid logo format");
      }
    } catch (err) {
      console.warn(err.message);
      addLogo(logo1, 10);
    }

    // logo part end
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(10);

    autoTable(doc, {
      startY: 28,
      theme: "grid",
      head: [],

      body: [
        [
          {
            content: "Name of the patient:",
            styles: {
              cellPadding: { top: 4, bottom: 4, left: 2, right: 2 },
              fontStyle: "bold",
            },
          },
          {
            content:
              formData.patientName ||
              patientData?.firstName + " " + patientData?.lastName ||
              "",
            styles: { cellPadding: { top: 4, bottom: 4, left: 2, right: 2 } },
          },
          {
            content: "CPR:",
            styles: {
              cellPadding: { top: 4, bottom: 4, left: 2, right: 2 },
              fontStyle: "bold",
            },
          },
          {
            content: formData.cpr || patientData?.cpr || "",
            styles: { cellPadding: { top: 4, bottom: 4, left: 2, right: 2 } },
          },
        ],
        [
          { content: "Age:", styles: { fontStyle: "bold" } },
          { content: formData.age || patientData?.age || "" },
          { content: "Nationality:", styles: { fontStyle: "bold" } },
          { content: formData.nationality || patientData?.nationality || "" },
        ],
        [
          { content: "Sex:", styles: { fontStyle: "bold" } },
          { content: formData.sex || patientData?.gender || "" },
          { content: "Phone No:", styles: { fontStyle: "bold" } },
          {
            content:
              formData.mobileNumber ||
              formData.phoneNo ||
              patientData?.mobileNumber ||
              "",
          },
        ],
      ],

      styles: {
        fontSize: 10,
        cellPadding: { top: 1, bottom: 1, left: 2, right: 2 },
        lineColor: [0, 0, 0],
        textColor: [0, 0, 0],
        lineWidth: 0.1,
      },
      columnStyles: {
        0: {
          minCellWidth: 30,
        },
        1: {
          minCellWidth: 35,
        },
        2: {
          minCellWidth: 20,
        },
        3: {
          minCellWidth: 35,
        },
      },
      tableWidth: "auto",
      margin: { left: 10, right: 10 },
    });
    const tableY = doc.lastAutoTable.finalY;
    doc.setFont("helvetica", "bold");

    doc.text("Referral Type:", 9, tableY + 7);
    doc.setFont("helvetica", "normal");

    const gap = 3.5; // vertical spacing between checkboxes

    function drawCheckboxWithLabel(doc, x, y, label, isChecked) {
      const boxSize = 3.5;

      // Final adjusted Y
      const newY = y + 4;

      // Draw box
      doc.setLineWidth(0.4);
      doc.rect(x, newY, boxSize, boxSize);

      // Draw checkmark if checked
      if (isChecked) {
        doc.line(x + 0.5, newY + 2.0, x + 1.4, newY + 3.0);
        doc.line(x + 1.4, newY + 3.0, x + 2.8, newY + 1.0);
      }

      // Text aligned vertically with box
      doc.text(label, x + boxSize + 3, newY + 2.8);
    }

    // Usage with equal gap
    drawCheckboxWithLabel(
      doc,
      10,
      tableY + 6,
      "Internal",
      formData.referralType === "internal"
    );
    drawCheckboxWithLabel(
      doc,
      10,
      tableY + 6 + gap + 3.5,
      "External",
      formData.referralType === "external"
    );
    doc.setFont("helvetica", "bold");

    doc.text("Referral Category:", 45, tableY + 7);
    doc.setFont("helvetica", "normal");

    const rightGap = 3.5;
    const rightBoxSize = 3.5;

    function drawRightCheckbox(doc, posX, posY, labelText, isChecked) {
      const newY = posY + 4;

      // Draw box
      doc.setLineWidth(0.4);
      doc.rect(posX, newY, rightBoxSize, rightBoxSize);

      // Checkmark if checked
      if (isChecked) {
        doc.line(posX + 0.5, newY + 2.0, posX + 1.4, newY + 3.0);
        doc.line(posX + 1.4, newY + 3.0, posX + 2.8, newY + 1.0);
      }

      // Text
      doc.text(labelText, posX + rightBoxSize + 3, newY + 2.8);
    }

    // RIGHT SIDE (x = 60)
    drawRightCheckbox(
      doc,
      50,
      tableY + 6,
      "Urgent",
      formData.referralCategory === "urgent"
    );
    drawRightCheckbox(
      doc,
      50,
      tableY + 6 + rightGap + 3.5,
      "Routine",
      formData.referralCategory === "routine"
    );
    doc.setFont("helvetica", "bold");

    doc.text("Reason of referral:", 88, tableY + 7);
    doc.setFont("helvetica", "normal");

    const reasonContent = formData.reasonOfReferral || "";

    const x = 88;
    const y = tableY + 10;
    const width = 111.8;
    const lineHeight = 6;

    // Convert 8 mm → pt for jsPDF
    const minHeight = 8;

    // Auto-wrap content
    const wrapped = doc.splitTextToSize(reasonContent, width - 4);

    // Calculate text height
    const textHeight = wrapped.length * lineHeight;

    // Final rectangle height
    const rectHeight = Math.max(minHeight, textHeight);

    // Set border thickness
    doc.setLineWidth(0.1);

    // Draw rectangle
    doc.rect(x, y, width, rectHeight);

    // Draw text inside with padding
    doc.text(wrapped, x + 4, y + 4);
    doc.setFont("helvetica", "bold");
    doc.text("History:", 10, tableY + 28);
    doc.setFont("helvetica", "normal");

    autoTable(doc, {
      startY: tableY + 32,
      theme: "grid",
      head: [],

      body: [
        [
          { content: "chief complain:", styles: { fontStyle: "bold" } },
          {
            content: formData.chiefComplain || "",
          },
        ],
        [
          {
            content: "Summary of presentation:",
            styles: { fontStyle: "bold" },
          },
          {
            content: formData.summaryOfPresentation || "",
          },
        ],
      ],

      styles: {
        fontSize: 10,
        cellPadding: { top: 1, bottom: 1, left: 2, right: 2 },
        lineColor: [0, 0, 0],
        textColor: [0, 0, 0],
        lineWidth: 0.1,
      },

      columnStyles: {
        0: { minCellWidth: 65 },
      },
      tableWidth: "auto",
      margin: { left: 10, right: 10 },
    });
    const tableY1 = doc.lastAutoTable.finalY;

    doc.setFont("helvetica", "bold");
    doc.text("Physical examination:", 10, tableY1 + 6);
    doc.setFont("helvetica", "normal");

    doc.text("Vital signs :", 10, tableY1 + 12);
    autoTable(doc, {
      startY: tableY1 + 16,
      theme: "grid",
      head: [],

      body: [
        [
          { content: "BP", styles: { fontStyle: "bold" } },
          { content: formData.vitalSigns?.bp || "" },
          { content: "RR", styles: { fontStyle: "bold" } },
          { content: formData.vitalSigns?.respiratoryRate || "" },
        ],
        [
          { content: "Temperature", styles: { fontStyle: "bold" } },
          { content: formData.vitalSigns?.temperature || "" },
          { content: "Spo2", styles: { fontStyle: "bold" } },
          { content: formData.vitalSigns?.spo2 || "" },
        ],
        [
          { content: "RBS", styles: { fontStyle: "bold" } },
          { content: formData.vitalSigns?.rbs || "" },
          { content: "Weight", styles: { fontStyle: "bold" } },
          { content: formData.vitalSigns?.weight || "" },
        ],
        [
          { content: "Pulse", styles: { fontStyle: "bold" } },
          { content: formData.vitalSigns?.pulse || "", colSpan: 3 },
        ],
      ],

      styles: {
        fontSize: 10,
        cellPadding: { top: 1, bottom: 1, left: 2, right: 2 },
        lineColor: [0, 0, 0],
        textColor: [0, 0, 0],
        lineWidth: 0.1,
      },
      columnStyles: {
        0: { cellWidth: 47.5 },
        1: { cellWidth: 47.5 },
        2: { cellWidth: 47.5 },
        3: { cellWidth: 47.5 },
      },
      tableWidth: "auto",
      margin: { left: 10, right: 10 },
    });
    const tableY2 = doc.lastAutoTable.finalY;
    doc.text("Glascow coma scale", 10, tableY2 + 6);
    autoTable(doc, {
      startY: tableY2 + 10,
      theme: "grid",
      head: [],

      body: [
        [
          { content: "Eye", styles: { fontStyle: "bold" } },
          { content: formData.glasgowComaScale?.eye || "" },
          { content: "Motor response", styles: { fontStyle: "bold" } },
          { content: formData.glasgowComaScale?.motorResponse || "" },
        ],
        [
          { content: "Verbal response", styles: { fontStyle: "bold" } },
          { content: formData.glasgowComaScale?.verbalResponse || "" },
          { content: "Total score (out of 15)", styles: { fontStyle: "bold" } },
          { content: formData.glasgowComaScale?.totalScore || "" },
        ],
      ],

      styles: {
        fontSize: 10,
        cellPadding: { top: 1, bottom: 1, left: 2, right: 2 },
        lineColor: [0, 0, 0],
        textColor: [0, 0, 0],
        lineWidth: 0.1,
      },

      columnStyles: {
        0: { cellWidth: 47.5 },
        1: { cellWidth: 47.5 },
        2: { cellWidth: 47.5 },
        3: { cellWidth: 47.5 },
      },

      tableWidth: "auto",
      margin: { left: 10, right: 10 },
    });
    const tableY3 = doc.lastAutoTable.finalY;
    autoTable(doc, {
      startY: tableY3 + 6,
      theme: "grid",
      head: [],

      body: [
        [
          { content: "General examination :", styles: { fontStyle: "bold" } },
          {
            content: formData.generalExamination || "",
          },
        ],
        [
          { content: "Local examination :", styles: { fontStyle: "bold" } },
          {
            content: formData.localExamination || "",
          },
        ],
        [
          { content: "Investigations done :", styles: { fontStyle: "bold" } },
          {
            content: formData.investigationsDone || "",
          },
        ],
        [
          {
            content: "Procedure & interventions provided :",
            styles: { fontStyle: "bold" },
          },
          { content: formData.procedureInterventions || "" },
        ],
        [
          {
            content: "Injections & medications given :",
            styles: { fontStyle: "bold" },
          },
          {
            content: formData.injectionsMedications || "",
          },
        ],
        [
          {
            content: "Prescription given to the patient :",
            styles: { fontStyle: "bold" },
          },
          {
            content: formData.prescriptionGiven || "",
          },
        ],
        [
          { content: "Notes :", styles: { fontStyle: "bold" } },
          {
            content: formData.notes || "",
          },
        ],
        [
          { content: "Advices :", styles: { fontStyle: "bold" } },
          {
            content: formData.advices || "",
          },
        ],
      ],

      styles: {
        fontSize: 10,
        cellPadding: { top: 1, bottom: 1, left: 2, right: 2 },
        lineColor: [0, 0, 0],
        textColor: [0, 0, 0],
        lineWidth: 0.1,
      },

      tableWidth: "auto",
      margin: { left: 10, right: 10 },
    });
    const tableY4 = doc.lastAutoTable.finalY;
    doc.text("Referring doctor", 10, tableY4 + 6);

    autoTable(doc, {
      startY: tableY4 + 10,
      theme: "grid",
      head: [],

      body: [
        [
          { content: "Name ", styles: { fontStyle: "bold" } },
          { content: "date", styles: { fontStyle: "bold" } },
          { content: "time", styles: { fontStyle: "bold" } },
          { content: "Phone number ", styles: { fontStyle: "bold" } },
        ],
        [
          { content: formData.referringDoctor?.name || "" },
          {
            content: formData.referringDoctor?.date || "",
          },
          {
            content: formData.referringDoctor?.time || "",
          },
          { content: formData.referringDoctor?.phoneNumber || "" },
        ],
        [
          {
            content: "Sign & seal",
            colSpan: 4,
            styles: {
              fontStyle: "bold",
              minCellHeight: 25,
            },
          },
        ],
      ],

      styles: {
        fontSize: 10,
        cellPadding: { top: 1, bottom: 1, left: 2, right: 2 },
        lineColor: [0, 0, 0],
        textColor: [0, 0, 0],
        lineWidth: 0.1,
      },

      columnStyles: {
        0: { cellWidth: 47.5 },
        1: { cellWidth: 47.5 },
        2: { cellWidth: 47.5 },
        3: { cellWidth: 47.5 },
      },
      tableWidth: "auto",
      margin: { left: 10, right: 10 },
    });

    const tableY5 = doc.lastAutoTable.finalY;
    doc.text("Receiving doctor", 10, tableY5 + 10);

    autoTable(doc, {
      startY: tableY5 + 35,
      theme: "grid",
      head: [],

      body: [
        [
          { content: "Name ", styles: { fontStyle: "bold" } },
          { content: "date", styles: { fontStyle: "bold" } },
          { content: "time", styles: { fontStyle: "bold" } },
          { content: "Phone number ", styles: { fontStyle: "bold" } },
        ],
        [
          { content: formData.receivingDoctor?.name || "" },
          {
            content: formData.receivingDoctor?.date || "",
          },
          {
            content: formData.receivingDoctor?.time || "",
          },
          { content: formData.receivingDoctor?.phoneNumber || "" },
        ],
        [
          {
            content: "Sign & seal",
            colSpan: 4,
            styles: { fontStyle: "bold", minCellHeight: 25 },
          },
        ],
      ],

      styles: {
        fontSize: 10,
        cellPadding: { top: 1, bottom: 1, left: 2, right: 2 },
        lineColor: [0, 0, 0],
        textColor: [0, 0, 0],
        lineWidth: 0.1,
      },

      columnStyles: {
        0: { cellWidth: 47.5 },
        1: { cellWidth: 47.5 },
        2: { cellWidth: 47.5 },
        3: { cellWidth: 47.5 },
      },
      margin: { left: 10, right: 10 },
      tableWidth: "auto",
      didDrawCell: function (data) {
        if (data.section === "body" && data.row.index === 1) {
          data.cell.styles.lineBottomWidth = 0;
        }
      },
    });
    const pdfBlob = doc.output("bloburl");
    window.open(pdfBlob, "_blank");
  };

  const generateMedicalCertificatePDF = (originalFormData) => {
    // Override doctor info with logged in user
    let formData = { ...originalFormData };
    const doctorInfo = getLoggedInDoctorInfo();
    if (doctorInfo.name && !formData.doctorName) {
      formData.doctorName = doctorInfo.name;
    }
    if (doctorInfo.license && !formData.licenseNo) {
      formData.licenseNo = doctorInfo.license;
    }
    if (doctorInfo.specialty && !formData.specialty) {
      formData.specialty = doctorInfo.specialty;
    }

    const doc = new jsPDF({
      orientation: "portrait",
      unit: "px",
      format: "a4",
    });
    doc.addFileToVFS("Tajawal-Bold.ttf", tajawalFontBase64);
    doc.addFont("Tajawal-Bold.ttf", "Tajawal", "bold");

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    doc.addImage(pdfimg3, "JPEG", 0, 0, pageWidth, pageHeight);

    const addLogo = (imgData, y) => {
      const imgProps = doc.getImageProperties(imgData);
      const pageWidth = doc.internal.pageSize.getWidth();
      let imgWidth = imgProps.width;
      let imgHeight = imgProps.height;

      // Maximum dimensions
      const maxWidth = pageWidth - 40; // 20px margin each side
      const maxHeight = 30; // fixed max height

      // Calculate ratios
      const widthRatio = maxWidth / imgWidth;
      const heightRatio = maxHeight / imgHeight;
      const ratio = Math.min(widthRatio, heightRatio);

      // Scale image
      const finalWidth = imgWidth * ratio;
      const finalHeight = imgHeight * ratio;

      // Center horizontally
      const centeredX = (pageWidth - finalWidth) / 2;

      doc.addImage(
        imgData,
        (imgProps.fileType || "PNG").toUpperCase(),
        centeredX,
        y,
        finalWidth,
        finalHeight,
        undefined,
        "NONE"
      );
    };

    try {
      if (
        businessLogo &&
        typeof businessLogo === "string" &&
        businessLogo.startsWith("data:image/") &&
        businessLogo.includes("base64")
      ) {
        addLogo(businessLogo, 20);
      } else {
        throw new Error("Invalid logo format");
      }
    } catch (err) {
      console.warn(err.message);
      addLogo(logo1, 20);
    }

    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(43, 43, 46);

    // Dynamic Patient Information
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");

    if (formData.accompanyingPatient) {
      doc.text(
        formData.accompanyingPersonName || "",
        155,
        137,
        { maxWidth: 150 }
      );
      doc.text(formData.accompanyingPersonId || "", 155, 160);

      doc.text(formData.patientName || "", 155, 202, { maxWidth: 150 });
      doc.text(formData.cprNumber || "", 155, 224);
    } else {
      doc.text(
        formData.patientName || "",
        155,
        137,
        { maxWidth: 150 }
      );
      doc.text(formData.cprNumber || "", 155, 160);
    }
    doc.text(formData.medicalRecordNumber?.toString() || "", 155, 240);

    // Add consultation details (time of attend, time of consult, consult date)
    if (formData.timeOfAttend) {
      doc.setFontSize(10);
      doc.text(formData.timeOfAttend, 142, 305);
    }
    if (formData.timeOfConsult) {
      doc.setFontSize(10);
      doc.text(formData.timeOfConsult, 142, 330);
    }
    if (formData.consultDate) {
      doc.setFontSize(10);
      doc.text(formData.consultDate, 142, 350);
    }

    doc.setDrawColor(156, 194, 229);
    doc.setLineWidth(1);
    // base tick coordinates for checkboxes
    const checkX = 147.5;
    const checkStartY = 263;
    const checkGapY = 20;
    doc.setFontSize(10);
    const checkboxValues = [
      formData.reportedSick,
      formData.accompanyingPatient,
    ];

    for (let index = 0; index < checkboxValues.length; index++) {
      if (checkboxValues[index]) {
        const currentY = checkStartY + index * checkGapY;

        doc.line(checkX - 3, currentY, checkX, currentY + 3);
        doc.line(checkX, currentY + 3, checkX + 5, currentY - 3);
      }
    }

    // Draw checkboxes for Fit/Unfit/Light Duty/Employee Care (right side)
    function drawVerticalTicks() {
      const checkboxStates = [
        formData.patientFitForDuty,
        formData.patientUnfitForDuty,
        formData.advisedLightDuty,
        formData.patientNeedsEmployeeCare,
      ];

      const tickX = 310; // checkbox X position
      const startY = 267; // first checkbox Y position
      const rowGaps = [20, 24, 26]; // vertical gap between checkboxes

      doc.setFontSize(10);

      let currentY = startY;

      for (let index = 0; index < checkboxStates.length; index++) {
        if (checkboxStates[index]) {
          // ✔ tick
          doc.line(tickX - 3, currentY, tickX, currentY + 3);
          doc.line(tickX, currentY + 3, tickX + 5, currentY - 3);
        }

        // move Y for next checkbox
        if (rowGaps[index]) {
          currentY += rowGaps[index];
        }
      }
    }

    drawVerticalTicks();

    // Days off section (dynamic)
    const daysOffTexts = [
      formData.noOfDaysOffFigures || "",
      formData.noOfDaysOffWords || "",
      formData.commencingOn || "",
    ];
    const baseX = 170;
    let baseY = 381;
    const yGap = 15;
    doc.setFontSize(10);
    daysOffTexts.forEach((text, i) => {
      doc.text(text, baseX, baseY + i * yGap);
    });
    // doc.setFont("helvetica", "bold");
    // doc.text("Accompanying Patient", 19, 494);
    // doc.setFont("helvetica", "normal");
    // Conditionally add accompanying person details table if accompanyingPatient is checked
    // if (formData.accompanyingPatient) {
    //   const bodyRows = [
    //     [
    //       "Name",
    //       formData.accompanyingPersonName || "",
    //       "Civil ID",
    //       formData.accompanyingPersonId || "",
    //     ],
    //   ];

    //   autoTable(doc, {
    //     startY: 502,
    //     margin: { left: 19, right: 37 },
    //     body: bodyRows,
    //     head: [],
    //     showHead: "never",
    //     theme: "grid",

    //     styles: {
    //       textColor: [0, 0, 0],
    //       lineColor: [0, 0, 0],
    //       lineWidth: 0.2,
    //       fontSize: 10,
    //       cellPadding: 3,
    //     },
    //     didParseCell: (data) => {
    //       if (
    //         data.row.index === 0 &&
    //         (data.column.index === 0 || data.column.index === 2)
    //       ) {
    //         data.cell.styles.fontStyle = "bold";
    //         data.cell.styles.color = "#2c2c2c";
    //       }
    //     },
    //   });

    //   doc.setDrawColor(161, 163, 162);
    //   doc.setLineWidth(2);
    //   doc.rect(19, 502, 390, 15);
    // }


    // Admission dates (dynamic)
    const admissionTexts = [
      formData.admittedOn || "",
      formData.dischargedOn || "",
    ];
    const baseX1 = 183;
    let baseY11 = 460;
    const yGap1 = 12;
    doc.setFontSize(10);
    admissionTexts.forEach((text, i) => {
      doc.text(text, baseX1, baseY11 + i * yGap1);
    });

    // Doctor information and diagnosis (dynamic)
    const doctorTexts = [
      formData.doctorName || "",
      formData.licenseNo || "",
      formData.specialty || "",
      formData.issueDate || "",
    ];
    const baseX2 = 183;
    let baseY12 = 492;
    const yGap2 = 12;
    doc.setFontSize(10);
    doctorTexts.forEach((text, i) => {
      doc.text(text, baseX2, baseY12 + i * yGap2);
    });

    // Certificate Registration Number (dynamic)
    // doc.text(formData.certificateRegistrationNo || "", 147, 547);

    // Add diagnosis text if available
    if (formData.diagnosis) {
      doc.setFontSize(10);
      const diagnosisLines = doc.splitTextToSize(formData.diagnosis, 250);
      let diagY = 436;
      diagnosisLines.slice(0, 2).forEach((line) => {
        doc.text(line, 105, diagY);
        diagY += 12;
      });
    }

    doc.text("", 108, 564);

    doc.text("", 370, 564);

    // Signature & Stamp – bottom right
    const resolveImg = (val) => {
      if (!val) return null;
      if (val.startsWith("data:")) return val;
      return `${baseurImage}${val}`;
    };
    const sigSrc = resolveImg(formData.doctorSignature || currentDoctorSigStamp.signature);
    const stampSrc = resolveImg(formData.doctorStamp || currentDoctorSigStamp.stamp);

    const sigStampY = 540;
    const rightMargin = 60;

    // Calculate widths first so we can right-align both images together
    let sigW = 0, sigH = 0, stampW = 0, stampH = 0;
    if (sigSrc) {
      try {
        const props = doc.getImageProperties(sigSrc);
        const ratio = Math.min(40 / props.height, 120 / props.width);
        sigW = props.width * ratio;
        sigH = props.height * ratio;
      } catch (_) {}
    }
    if (stampSrc) {
      try {
        const props = doc.getImageProperties(stampSrc);
        const ratio = Math.min(50 / props.height, 100 / props.width);
        stampW = props.width * ratio;
        stampH = props.height * ratio;
      } catch (_) {}
    }

    const gap = sigW && stampW ? 10 : 0;
    const totalW = sigW + gap + stampW;
    let drawX = pageWidth - rightMargin - totalW;

    if (sigSrc && sigW) {
      try {
        const props = doc.getImageProperties(sigSrc);
        doc.addImage(sigSrc, (props.fileType || "PNG").toUpperCase(), drawX, sigStampY, sigW, sigH);
        drawX += sigW + gap;
      } catch (_) {}
    }
    if (stampSrc && stampW) {
      try {
        const props = doc.getImageProperties(stampSrc);
        doc.addImage(stampSrc, (props.fileType || "PNG").toUpperCase(), drawX, sigStampY, stampW, stampH);
      } catch (_) {}
    }

    // Footer - Dynamic Section
    const footerY = 590;

    // Parts for the first line
    const p1 = `Hospital Name: ${businessOfficialName} | Email: `;
    const p2 = businessEmail || "admin@gmail.com";
    const p3 = ` | Phone: ${businessPhone || "123434"} | `;
    const p4 = website;

    doc.setFillColor(255, 255, 255);
    doc.rect(41, 582, 40, 14, "F");

    doc.setFont("helvetica", "bold"); // set font and weight
    doc.setFontSize(12);
    doc.text(p4, 42, 582);

    doc.text(businessPhone, 163, 591);

    doc.text(businessEmail, 221, 591);

    doc.text(businessAddress, 143, 604);

    const pdfBlob = doc.output("bloburl");
    window.open(pdfBlob, "_blank");
  };





  // original form
  const generateMedicalOriginal = (originalFormData, bgImage = originalMedical) => {
    // Override doctor info with logged in user
    let formData = { ...originalFormData };
    const doctorInfo = getLoggedInDoctorInfo();
    if (doctorInfo.name && !formData.doctorName) {
      formData.doctorName = doctorInfo.name;
    }
    if (doctorInfo.license && !formData.licenseNo) {
      formData.licenseNo = doctorInfo.license;
    }
    if (doctorInfo.specialty && !formData.specialty) {
      formData.specialty = doctorInfo.specialty;
    }

    const doc = new jsPDF({
      orientation: "portrait",
      unit: "px",
      format: "a4",
    });
    doc.addFileToVFS("Tajawal-Bold.ttf", tajawalFontBase64);
    doc.addFont("Tajawal-Bold.ttf", "Tajawal", "bold");

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    doc.addImage(bgImage, "png", 0, 0, pageWidth, pageHeight);

    const addLogo = (imgData, y) => {
      const imgProps = doc.getImageProperties(imgData);
      const pageWidth = doc.internal.pageSize.getWidth();
      let imgWidth = imgProps.width;
      let imgHeight = imgProps.height;

      const maxWidth = pageWidth - 40;
      const maxHeight = 30;

      // Calculate ratios
      const widthRatio = maxWidth / imgWidth;
      const heightRatio = maxHeight / imgHeight;
      const ratio = Math.min(widthRatio, heightRatio);

      // Scale image
      const finalWidth = imgWidth * ratio;
      const finalHeight = imgHeight * ratio;

      // Center horizontally
      const centeredX = (pageWidth - finalWidth) / 2;

      doc.addImage(
        imgData,
        (imgProps.fileType || "PNG").toUpperCase(),
        centeredX,
        40,
        finalWidth,
        finalHeight,
        undefined,
        "NONE"
      );
    };

    try {
      if (
        businessLogo &&
        typeof businessLogo === "string" &&
        businessLogo.startsWith("data:image/") &&
        businessLogo.includes("base64")
      ) {
        addLogo(businessLogo, 20);
      } else {
        throw new Error("Invalid logo format");
      }
    } catch (err) {
      console.warn(err.message);
      addLogo(logo1, 20);
    }

    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(43, 43, 46);

    // business name
    // const maxWidth = 123;
    // const startX = 50;
    // let startY = 55;

    // const textLines = doc.splitTextToSize(businessOfficialName, maxWidth);

    // doc.text(textLines, startX, startY);

    // startY += textLines.length * 6;

    // doc.setFontSize(11);

    // doc.setFont("Tajawal", "bold");
    // doc.setFontSize(10);
    // doc.text(businessOfficialNameArabic, 395, 55, { align: "right" });
    // Dynamic Patient Information
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");


    doc.text(
      formData.patientName || "",
      170,
      153,
      { maxWidth: 150 }
    );
    doc.text(formData.cprNumber || "", 170, 165);
    doc.text(formData.medicalRecordNumber?.toString() || "", 170, 180);

    // if (formData.accompanyingPatient) {
    //   doc.text(formData.accompanyingPersonName || "", 155, 202);
    //   doc.text(formData.accompanyingPersonId || "", 155, 224);
    // }

    doc.setDrawColor(0, 0,0);
    doc.setLineWidth(1);
    // base tick coordinates for checkboxes
    const checkX = 142;
    const checkStartY = 196;
    const checkGapY = 20;
    doc.setFontSize(10);
    const checkboxValues = [
      formData.reportedSick,
      formData.accompanyingPatient,
    ];

    for (let index = 0; index < checkboxValues.length; index++) {
      if (checkboxValues[index]) {
        const currentY = checkStartY + index * checkGapY;

        doc.line(checkX - 3, currentY, checkX, currentY + 3);
        doc.line(checkX, currentY + 3, checkX + 5, currentY - 3);
      }
    }

    // Draw checkboxes for Fit/Unfit/Light Duty/Employee Care (right side)
    function drawVerticalTicks() {
      const checkboxStates = [
        formData.patientFitForDuty,
        formData.patientUnfitForDuty,
        formData.advisedLightDuty,
        formData.patientNeedsEmployeeCare,
      ];

      const tickX = 324; // checkbox X position
      const startY = 196; // first checkbox Y position
      const rowGaps = [14, 14, 18]; // vertical gap between checkboxes

      doc.setFontSize(10);

      let currentY = startY;

      for (let index = 0; index < checkboxStates.length; index++) {
        if (checkboxStates[index]) {
          // ✔ tick
          doc.line(tickX - 3, currentY, tickX, currentY + 3);
          doc.line(tickX, currentY + 3, tickX + 5, currentY - 3);
        }

        // move Y for next checkbox
        if (rowGaps[index]) {
          currentY += rowGaps[index];
        }
      }
    }

    drawVerticalTicks();

    // Add consultation details (time of attend, time of consult, consult date)
    if (formData.timeOfAttend) {
      doc.setFontSize(10);
      doc.text(formData.timeOfAttend, 138, 230);
    }
    if (formData.timeOfConsult) {
      doc.setFontSize(10);
      doc.text(formData.timeOfConsult, 138, 247);
    }
    if (formData.consultDate) {
      doc.setFontSize(10);
      doc.text(formData.consultDate, 130, 263);
    }

    // Days off section (dynamic)
    const daysOffTexts = [
      formData.noOfDaysOffFigures || "",
      formData.noOfDaysOffWords || "",
      formData.commencingOn || "",
    ];
    const baseX = 185;
    let baseY = 292;
    const yGap = 18;
    doc.setFontSize(10);
    daysOffTexts.forEach((text, i) => {
      doc.text(text, baseX, baseY + i * yGap);
    });

    // Add diagnosis text if available
    if (formData.diagnosis) {
      doc.setFontSize(10);
      const diagnosisLines = doc.splitTextToSize(formData.diagnosis, 250);
      let diagY = 355;
      diagnosisLines.slice(0, 2).forEach((line) => {
        doc.text(line, 105, diagY);
        diagY += 10;
      });
    }
    // Admission dates (dynamic)
    const admissionTexts = [
      formData.admittedOn || "",
      formData.dischargedOn || "",
    ];
    const baseX1 = 220;
    let baseY11 = 395;
    const yGap1 = 13;
    doc.setFontSize(10);
    admissionTexts.forEach((text, i) => {
      doc.text(text, baseX1, baseY11 + i * yGap1);
    });

    // Doctor information and diagnosis (dynamic)
    const doctorTexts = [
      formData.doctorName || "",
      formData.licenseNo || "",
      formData.specialty || "",
      formData.issueDate || "",
    ];
    const baseX2 = 183;
    let baseY12 = 438;
    const yGap2 = 14;
    doc.setFontSize(10);
    doctorTexts.forEach((text, i) => {
      doc.text(text, baseX2, baseY12 + i * yGap2);
    });

    doc.text("", 108, 564);

    doc.text("", 370, 564);

    if (formData.certificateRegistrationNo) {
      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      doc.text(formData.certificateRegistrationNo, 183, 550);
    }

    // Signature & Stamp – bottom right
    const resolveImg = (val) => {
      if (!val) return null;
      if (val.startsWith("data:")) return val;
      return `${baseurImage}${val}`;
    };
    const sigSrc = resolveImg(formData.doctorSignature || currentDoctorSigStamp.signature);
    const stampSrc = resolveImg(formData.doctorStamp || currentDoctorSigStamp.stamp);

    const sigStampY = 490;
    const rightMargin = 60;

    let sigW = 0, sigH = 0, stampW = 0, stampH = 0;
    if (sigSrc) {
      try {
        const props = doc.getImageProperties(sigSrc);
        const ratio = Math.min(40 / props.height, 120 / props.width);
        sigW = props.width * ratio;
        sigH = props.height * ratio;
      } catch (_) {}
    }
    if (stampSrc) {
      try {
        const props = doc.getImageProperties(stampSrc);
        const ratio = Math.min(50 / props.height, 100 / props.width);
        stampW = props.width * ratio;
        stampH = props.height * ratio;
      } catch (_) {}
    }

    const gap = sigW && stampW ? 10 : 0;
    const totalW = sigW + gap + stampW;
    let drawX = pageWidth - rightMargin - totalW;

    if (sigSrc && sigW) {
      try {
        const props = doc.getImageProperties(sigSrc);
        doc.addImage(sigSrc, (props.fileType || "PNG").toUpperCase(), drawX, sigStampY, sigW, sigH);
        drawX += sigW + gap;
      } catch (_) {}
    }
    if (stampSrc && stampW) {
      try {
        const props = doc.getImageProperties(stampSrc);
        doc.addImage(stampSrc, (props.fileType || "PNG").toUpperCase(), drawX, sigStampY, stampW, stampH);
      } catch (_) {}
    }

    const footerY = 600;

    // Parts for the first line
    const p1 = `Hospital Name: ${businessOfficialName} | Email: `;
    const p2 = businessEmail || "admin@gmail.com";
    const p3 = ` | Phone: ${businessPhone || "123434"} | `;
    const p4 = website;

    doc.setFillColor(255, 255, 255);
    doc.rect(41, 582, 40, 14, "F");

    doc.setFont("helvetica", "bold"); // set font and weight
    doc.setFontSize(12);
    doc.text(p4, 42, 582);

    doc.setFillColor(255, 255, 255);
    doc.rect(163, 584, 40, 10, "F");

    doc.text(businessPhone, 163, 591);
    doc.setFillColor(255, 255, 255);
    doc.rect(219, 580, 57, 20, "F");

    doc.text(businessEmail, 221, 591);
    doc.setFillColor(255, 255, 255);

    doc.rect(142, 595, 135, 15, "F");
    doc.text(businessAddress, 143, 604);

    const pdfBlob = doc.output("bloburl");
    window.open(pdfBlob, "_blank");
  };

  // ── Medical Certificate Print (separate copy — edit field positions here) ──
  // LINE MARKER: generateMedicalCertificatePrint starts here
  const generateMedicalCertificatePrint = (originalFormData) => {
    let formData = { ...originalFormData };
    const doctorInfo = getLoggedInDoctorInfo();
    if (doctorInfo.name && !formData.doctorName)    formData.doctorName = doctorInfo.name;
    if (doctorInfo.license && !formData.licenseNo)  formData.licenseNo  = doctorInfo.license;
    if (doctorInfo.specialty && !formData.specialty) formData.specialty  = doctorInfo.specialty;

    const doc = new jsPDF({ orientation: "portrait", unit: "px", format: "a4" });
    doc.addFileToVFS("Tajawal-Bold.ttf", tajawalFontBase64);
    doc.addFont("Tajawal-Bold.ttf", "Tajawal", "bold");

    const pageWidth  = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    doc.addImage(originalMedical, "png", 0, 0, pageWidth, pageHeight);

    const addLogo = (imgData) => {
      const imgProps  = doc.getImageProperties(imgData);
      const maxWidth  = pageWidth - 40;
      const maxHeight = 30;
      const ratio     = Math.min(maxWidth / imgProps.width, maxHeight / imgProps.height);
      const finalW    = imgProps.width  * ratio;
      const finalH    = imgProps.height * ratio;
      const centeredX = (pageWidth - finalW) / 2;
      doc.addImage(imgData, (imgProps.fileType || "PNG").toUpperCase(), centeredX, 40, finalW, finalH, undefined, "NONE");
    };

    try {
      if (businessLogo && typeof businessLogo === "string" && businessLogo.startsWith("data:image/") && businessLogo.includes("base64")) {
        addLogo(businessLogo);
      } else { throw new Error("Invalid logo format"); }
    } catch (err) { console.warn(err.message); addLogo(logo1); }

    doc.setFontSize(12); doc.setFont("helvetica", "bold"); doc.setTextColor(43, 43, 46);
    doc.setFontSize(10); doc.setFont("helvetica", "normal");

    // ── PATIENT INFO ── (Medical Certificate positions)
    drawBidiText(doc, formData.patientName || "", 155, 156, { fontSize: 10, maxWidth: 150 });
    doc.setFont("helvetica", "normal"); doc.setFontSize(10);
    doc.text(formData.cprNumber || "", 155, 182);
    doc.text(formData.medicalRecordNumber?.toString() || "", 155, 197);

    doc.setDrawColor(0, 0, 0); doc.setLineWidth(1);
    const checkX = 147.5; const checkStartY = 220; const checkGapY = 20;
    doc.setFontSize(10);
    const checkboxValues = [formData.reportedSick, formData.accompanyingPatient];
    for (let i = 0; i < checkboxValues.length; i++) {
      if (checkboxValues[i]) {
        const cy = checkStartY + i * checkGapY;
        doc.line(checkX - 3, cy, checkX, cy + 3);
        doc.line(checkX, cy + 3, checkX + 5, cy - 3);
      }
    }

    function drawVerticalTicks() {
      const states = [formData.patientFitForDuty, formData.patientUnfitForDuty, formData.advisedLightDuty, formData.patientNeedsEmployeeCare];
      const tickX = 310; const startY = 224; const rowGaps = [21, 23, 25];
      let currentY = startY;
      for (let i = 0; i < states.length; i++) {
        if (states[i]) {
          doc.line(tickX - 3, currentY, tickX, currentY + 3);
          doc.line(tickX, currentY + 3, tickX + 5, currentY - 3);
        }
        if (rowGaps[i]) currentY += rowGaps[i];
      }
    }
    drawVerticalTicks();

    // ── CONSULTATION TIMES ──
    if (formData.timeOfAttend) doc.text(formData.timeOfAttend, 142, 263);
    if (formData.timeOfConsult) doc.text(formData.timeOfConsult, 142, 286);
    if (formData.consultDate)  doc.text(formData.consultDate,   142, 309);

    // ── DAYS OFF ──
    const daysOffTexts = [formData.noOfDaysOffFigures || "", formData.noOfDaysOffWords || "", formData.commencingOn || ""];
    const baseX = 170; let baseY = 339; const yGap = 15;
    daysOffTexts.forEach((text, i) => drawBidiText(doc, text, baseX, baseY + i * yGap, { fontSize: 10 }));

    // ── DIAGNOSIS ──
    if (formData.diagnosis) {
      registerArabicFont(doc);
      const isDiagArabic = containsArabic(formData.diagnosis);
      doc.setFontSize(10);
      doc.setFont(isDiagArabic ? ARABIC_FONT_NAME : "helvetica", "normal");
      const diagnosisLines = doc.splitTextToSize(formData.diagnosis, 250);
      let diagY = 399;
      diagnosisLines.slice(0, 2).forEach((line) => { doc.text(line, 105, diagY); diagY += 10; });
    }

    // ── ADMISSION DATES ──
    const admissionTexts = [formData.admittedOn || "", formData.dischargedOn || ""];
    const baseX1 = 183; let baseY11 = 426; const yGap1 = 12;
    doc.setFont("helvetica", "normal"); doc.setFontSize(10);
    admissionTexts.forEach((text, i) => doc.text(text, baseX1, baseY11 + i * yGap1));

    // ── DOCTOR INFO ──
    const doctorTexts = [formData.doctorName || "", formData.licenseNo || "", formData.specialty || "", formData.issueDate || ""];
    const baseX2 = 183; let baseY12 = 463; const yGap2 = 12;
    doctorTexts.forEach((text, i) => drawBidiText(doc, text, baseX2, baseY12 + i * yGap2, { fontSize: 10 }));

    if (formData.certificateRegistrationNo) {
      doc.setFontSize(10); doc.setFont("helvetica", "normal");
      doc.text(formData.certificateRegistrationNo, 183, 550);
    }

    // ── SIGNATURE & STAMP ──
    const resolveImg = (val) => { if (!val) return null; if (val.startsWith("data:")) return val; return `${baseurImage}${val}`; };
    const sigSrc   = resolveImg(formData.doctorSignature || currentDoctorSigStamp.signature);
    const stampSrc = resolveImg(formData.doctorStamp     || currentDoctorSigStamp.stamp);
    const sigStampY = 490; const rightMargin = 60;
    let sigW = 0, sigH = 0, stampW = 0, stampH = 0;
    if (sigSrc)   { try { const p = doc.getImageProperties(sigSrc);   const r = Math.min(40/p.height,120/p.width);  sigW   = p.width*r; sigH   = p.height*r; } catch(_){} }
    if (stampSrc) { try { const p = doc.getImageProperties(stampSrc); const r = Math.min(50/p.height,100/p.width); stampW = p.width*r; stampH = p.height*r; } catch(_){} }
    const gap = sigW && stampW ? 10 : 0;
    let drawX = pageWidth - rightMargin - (sigW + gap + stampW);
    if (sigSrc   && sigW)   { try { const p = doc.getImageProperties(sigSrc);   doc.addImage(sigSrc,   (p.fileType||"PNG").toUpperCase(), drawX, sigStampY, sigW,   sigH);   drawX += sigW + gap;   } catch(_){} }
    if (stampSrc && stampW) { try { const p = doc.getImageProperties(stampSrc); doc.addImage(stampSrc, (p.fileType||"PNG").toUpperCase(), drawX, sigStampY, stampW, stampH); } catch(_){} }

    // ── FOOTER ──
    doc.setFillColor(255, 255, 255); doc.rect(41, 582, 40, 14, "F");
    drawBidiText(doc, website, 42, 582, { fontSize: 12, bold: true });
    doc.setFillColor(230, 247, 254); doc.rect(163, 584, 40, 10, "F");
    drawBidiText(doc, businessPhone, 163, 591, { fontSize: 12, bold: true });
    doc.setFillColor(220, 247, 254); doc.rect(219, 580, 57, 20, "F");
    drawBidiText(doc, businessEmail, 221, 591, { fontSize: 12, bold: true });
    doc.setFillColor(220, 247, 254); doc.rect(142, 595, 135, 15, "F");
    drawBidiText(doc, businessAddress, 143, 604, { fontSize: 12, bold: true });

    const pdfBlob = doc.output("bloburl");
    window.open(pdfBlob, "_blank");
  };
  // LINE MARKER: generateMedicalCertificatePrint ends here

  // ── Sick Leave Print (separate copy — edit field positions here) ──
  // Shortens a patient name for the Sick Leave certificate so long names don't
  // overlap the pre-printed form: keeps the first 2 words of the first name
  // plus the last name.
  const shortenNameForSickLeave = (fullName) => {
    const parts = (fullName || "").trim().split(/\s+/).filter(Boolean);
    if (parts.length <= 3) return parts.join(" ");
    return [parts[0], parts[1], parts[parts.length - 1]].join(" ");
  };

  // LINE MARKER: generateSickLeavePrint starts here
  const generateSickLeavePrint = (originalFormData) => {
    let formData = { ...originalFormData };
    const doctorInfo = getLoggedInDoctorInfo();
    if (doctorInfo.name && !formData.doctorName)    formData.doctorName = doctorInfo.name;
    if (doctorInfo.license && !formData.licenseNo)  formData.licenseNo  = doctorInfo.license;
    if (doctorInfo.specialty && !formData.specialty) formData.specialty  = doctorInfo.specialty;

    const doc = new jsPDF({ orientation: "portrait", unit: "px", format: "a4" });
    doc.addFileToVFS("Tajawal-Bold.ttf", tajawalFontBase64);
    doc.addFont("Tajawal-Bold.ttf", "Tajawal", "bold");

    const pageWidth  = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    doc.addImage(sleave, "png", 0, 0, pageWidth, pageHeight);

    const addLogo = (imgData) => {
      const imgProps  = doc.getImageProperties(imgData);
      const maxWidth  = pageWidth - 40;
      const maxHeight = 30;
      const ratio     = Math.min(maxWidth / imgProps.width, maxHeight / imgProps.height);
      const finalW    = imgProps.width  * ratio;
      const finalH    = imgProps.height * ratio;
      const centeredX = (pageWidth - finalW) / 2;
      doc.addImage(imgData, (imgProps.fileType || "PNG").toUpperCase(), centeredX, 40, finalW, finalH, undefined, "NONE");
    };

    try {
      if (businessLogo && typeof businessLogo === "string" && businessLogo.startsWith("data:image/") && businessLogo.includes("base64")) {
        addLogo(businessLogo);
      } else { throw new Error("Invalid logo format"); }
    } catch (err) { console.warn(err.message); addLogo(logo1); }

    doc.setFontSize(12); doc.setFont("helvetica", "bold"); doc.setTextColor(43, 43, 46);
    doc.setFontSize(10); doc.setFont("helvetica", "normal");

    // ── PATIENT INFO ── (Sick Leave positions)
    drawBidiText(doc, shortenNameForSickLeave(formData.patientName), 170, 153, { fontSize: 10, maxWidth: 150 });
    doc.setFont("helvetica", "normal"); doc.setFontSize(10);
    doc.text(formData.cprNumber || "", 170, 165);
    doc.text(formData.medicalRecordNumber?.toString() || "", 170, 180);

    doc.setDrawColor(0, 0, 0); doc.setLineWidth(1);
    const checkX = 142; const checkStartY = 196; const checkGapY = 20;
    doc.setFontSize(10);
    const checkboxValues = [formData.reportedSick, formData.accompanyingPatient];
    for (let i = 0; i < checkboxValues.length; i++) {
      if (checkboxValues[i]) {
        const cy = checkStartY + i * checkGapY;
        doc.line(checkX - 3, cy, checkX, cy + 3);
        doc.line(checkX, cy + 3, checkX + 5, cy - 3);
      }
    }

    function drawVerticalTicks() {
      const states = [formData.patientFitForDuty, formData.patientUnfitForDuty, formData.advisedLightDuty, formData.patientNeedsEmployeeCare];
      const tickX = 324; const startY = 196; const rowGaps = [14, 14, 18];
      let currentY = startY;
      for (let i = 0; i < states.length; i++) {
        if (states[i]) {
          doc.line(tickX - 3, currentY, tickX, currentY + 3);
          doc.line(tickX, currentY + 3, tickX + 5, currentY - 3);
        }
        if (rowGaps[i]) currentY += rowGaps[i];
      }
    }
    drawVerticalTicks();

    // ── CONSULTATION TIMES ──
    if (formData.timeOfAttend) doc.text(formData.timeOfAttend, 138, 230);
    if (formData.timeOfConsult) doc.text(formData.timeOfConsult, 138, 247);
    if (formData.consultDate)  doc.text(formData.consultDate,   130, 263);

    // ── DAYS OFF ──
    const daysOffTexts = [formData.noOfDaysOffFigures || "", formData.noOfDaysOffWords || "", formData.commencingOn || ""];
    const baseX = 185; let baseY = 292; const yGap = 18;
    daysOffTexts.forEach((text, i) => drawBidiText(doc, text, baseX, baseY + i * yGap, { fontSize: 10 }));

    // ── DIAGNOSIS ──
    if (formData.diagnosis) {
      registerArabicFont(doc);
      const isDiagArabic = containsArabic(formData.diagnosis);
      doc.setFontSize(10);
      doc.setFont(isDiagArabic ? ARABIC_FONT_NAME : "helvetica", "normal");
      const diagnosisLines = doc.splitTextToSize(formData.diagnosis, 250);
      let diagY = 360;
      diagnosisLines.slice(0, 2).forEach((line) => { doc.text(line, 130, diagY); diagY += 10; });
    }

    // ── ADMISSION DATES ──
    const admissionTexts = [formData.admittedOn || "", formData.dischargedOn || ""];
    const baseX1 = 220; let baseY11 = 395; const yGap1 = 13;
    doc.setFont("helvetica", "normal"); doc.setFontSize(10);
    admissionTexts.forEach((text, i) => doc.text(text, baseX1, baseY11 + i * yGap1));

    // ── DOCTOR INFO ──
    const doctorTexts = [formData.doctorName || "", formData.licenseNo || "", formData.specialty || "", formData.issueDate || ""];
    const baseX2 = 183; let baseY12 = 438; const yGap2 = 14;
    doctorTexts.forEach((text, i) => drawBidiText(doc, text, baseX2, baseY12 + i * yGap2, { fontSize: 10 }));

    if (formData.certificateRegistrationNo) {
      doc.setFontSize(10); doc.setFont("helvetica", "normal");
      doc.text(formData.certificateRegistrationNo, 183, 550);
    }

    // ── SIGNATURE & STAMP ──
    const resolveImg = (val) => { if (!val) return null; if (val.startsWith("data:")) return val; return `${baseurImage}${val}`; };
    const sigSrc   = resolveImg(formData.doctorSignature || currentDoctorSigStamp.signature);
    const stampSrc = resolveImg(formData.doctorStamp     || currentDoctorSigStamp.stamp);
    const sigStampY = 490; const rightMargin = 60;
    let sigW = 0, sigH = 0, stampW = 0, stampH = 0;
    if (sigSrc)   { try { const p = doc.getImageProperties(sigSrc);   const r = Math.min(40/p.height,120/p.width);  sigW   = p.width*r; sigH   = p.height*r; } catch(_){} }
    if (stampSrc) { try { const p = doc.getImageProperties(stampSrc); const r = Math.min(50/p.height,100/p.width); stampW = p.width*r; stampH = p.height*r; } catch(_){} }
    const gap = sigW && stampW ? 10 : 0;
    let drawX = pageWidth - rightMargin - (sigW + gap + stampW);
    if (sigSrc   && sigW)   { try { const p = doc.getImageProperties(sigSrc);   doc.addImage(sigSrc,   (p.fileType||"PNG").toUpperCase(), drawX, sigStampY, sigW,   sigH);   drawX += sigW + gap;   } catch(_){} }
    if (stampSrc && stampW) { try { const p = doc.getImageProperties(stampSrc); doc.addImage(stampSrc, (p.fileType||"PNG").toUpperCase(), drawX, sigStampY, stampW, stampH); } catch(_){} }

    // ── FOOTER ──
    doc.setFillColor(255, 255, 255); doc.rect(41, 582, 40, 14, "F");
    drawBidiText(doc, website, 42, 582, { fontSize: 12, bold: true });
    doc.setFillColor(255, 255, 255); doc.rect(163, 584, 40, 10, "F");
    drawBidiText(doc, businessPhone, 163, 591, { fontSize: 12, bold: true });
    doc.setFillColor(255, 255, 255); doc.rect(219, 580, 57, 20, "F");
    drawBidiText(doc, businessEmail, 221, 591, { fontSize: 12, bold: true });
    doc.setFillColor(255, 255, 255); doc.rect(142, 595, 135, 15, "F");
    drawBidiText(doc, businessAddress, 143, 604, { fontSize: 12, bold: true });

    const pdfBlob = doc.output("bloburl");
    window.open(pdfBlob, "_blank");
  };
  // LINE MARKER: generateSickLeavePrint ends here

  // ── Consent Form PDF (printer-friendly, A4) ──
  const generateConsentPDF = (data) => {
    const cf = data || consentForm;
    const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
    const pw = doc.internal.pageSize.getWidth();   // 210 mm
    const ph = doc.internal.pageSize.getHeight();  // 297 mm
    const ml = 20;
    const mr = 20;
    const cw = pw - ml - mr; // 170 mm
    let y = ml;

    // helpers
    const black  = [0, 0, 0];
    const grey60 = [100, 100, 100];
    const grey40 = [150, 150, 150];
    const setBlack  = () => doc.setTextColor(...black);
    const setGrey60 = () => doc.setTextColor(...grey60);
    const setGrey40 = () => doc.setTextColor(...grey40);
    const hrule = (yPos, lw = 0.25) => {
      doc.setDrawColor(...black);
      doc.setLineWidth(lw);
      doc.line(ml, yPos, pw - mr, yPos);
    };
    const stripHtml = (html) => {
      if (!html) return "";
      return html
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<\/p>/gi, "\n\n")
        .replace(/<\/li>/gi, "\n")
        .replace(/<li[^>]*>/gi, "  \u2022 ")
        .replace(/<\/h[1-6]>/gi, "\n")
        .replace(/<[^>]+>/g, "")
        .replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">")
        .replace(/&nbsp;/g, " ").replace(/&quot;/g, '"').replace(/&#39;/g, "'")
        .replace(/\n{3,}/g, "\n\n").trim();
    };

    // continuation-page mini header
    const miniHeader = () => {
      setGrey60();
      drawBidiText(doc, businessOfficialName || "Medical Center", ml, 12, { fontSize: 8, bold: true });
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text("PATIENT CONSENT FORM", pw - mr, 12, { align: "right" });
      hrule(14, 0.2);
    };

    // ── LETTERHEAD ───────────────────────────────────────────
    // Logo with correct proportions
    const maxLogoH = 22;
    const maxLogoW = 40;
    let logoSrc = null;
    try {
      logoSrc = (businessLogo && businessLogo.startsWith("data:image/")) ? businessLogo : logo1;
      const props = doc.getImageProperties(logoSrc);
      const ratio = props.width / props.height;
      let lw = maxLogoW;
      let lh = lw / ratio;
      if (lh > maxLogoH) { lh = maxLogoH; lw = lh * ratio; }
      doc.addImage(logoSrc, "PNG", ml, y, lw, lh);
      // business name vertically centred against logo height
      const textX = ml + lw + 7;
      setBlack();
      drawBidiText(doc, businessOfficialName || "Medical Center", textX, y + lh / 2 + 2, { fontSize: 13, bold: true });
      y += lh + 6;
    } catch (_) {
      // fallback: no logo
      setBlack();
      drawBidiText(doc, businessOfficialName || "Medical Center", ml, y + 8, { fontSize: 13, bold: true });
      y += 16;
    }

    // single rule under letterhead
    hrule(y, 0.4);
    y += 7;

    // ── DOCUMENT TITLE ───────────────────────────────────────
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    setBlack();
    doc.text("PATIENT CONSENT FORM", pw / 2, y, { align: "center" });
    y += 5;
    hrule(y, 0.25);
    y += 5;

    // ── PATIENT DETAILS (plain inline, no table) ─────────────
    doc.setFontSize(9);
    // row 1
    doc.setFont("helvetica", "bold"); setGrey60();
    doc.text("Patient Name:", ml, y);
    setBlack();
    drawBidiText(doc, cf.patientName || "\u2014", ml + 30, y, { fontSize: 9 });
    doc.setFont("helvetica", "bold"); setGrey60();
    doc.text("File No.:", ml + cw / 2, y);
    doc.setFont("helvetica", "normal"); setBlack();
    doc.text(cf.fileNo || "\u2014", ml + cw / 2 + 20, y);
    y += 6;
    // row 2
    doc.setFont("helvetica", "bold"); setGrey60();
    doc.text("CPR / ID No.:", ml, y);
    doc.setFont("helvetica", "normal"); setBlack();
    doc.text(cf.cprNo || "\u2014", ml + 30, y);
    doc.setFont("helvetica", "bold"); setGrey60();
    doc.text("Age / Sex:", ml + cw / 2, y);
    doc.setFont("helvetica", "normal"); setBlack();
    doc.text(cf.ageSex || "\u2014", ml + cw / 2 + 20, y);
    y += 9;
    hrule(y, 0.2);
    y += 10; // top margin before paragraph

    // consent title above paragraph
    if (cf.title || cf.templateName) {
      setBlack();
      drawBidiText(doc, cf.title || cf.templateName, ml, y, { fontSize: 11, bold: true });
      y += 7;
    }

    // ── CONSENT BODY TEXT ────────────────────────────────────
    const contentText = stripHtml(cf.content);
    const lh = 5.5;
    setBlack();
    y = drawBidiParagraphs(doc, contentText, {
      x: ml,
      maxWidth: cw,
      lineHeight: lh,
      fontSize: 10,
      startY: y,
      onBeforeLine: (d, yPos) => {
        if (yPos + lh > ph - 52) {
          d.addPage();
          miniHeader();
          return 20;
        }
        return yPos;
      },
    });
    y += 10; // bottom margin after paragraph

    // ── SIGNATURES ───────────────────────────────────────────
    if (y + 55 > ph - 18) {
      doc.addPage();
      miniHeader();
      y = 20;
    }

    doc.setFont("helvetica", "bold");
    doc.setFontSize(8.5);
    setBlack();
    doc.text("SIGNATURES", ml, y);
    hrule(y + 1.5, 0.2);
    y += 6;

    const sigW = (cw - 12) / 2;
    const s1x  = ml;
    const s2x  = ml + sigW + 12;
    const sigH = 26;

    doc.setDrawColor(...black);
    doc.setLineWidth(0.25);
    doc.rect(s1x, y, sigW, sigH);
    if (cf.patientSignature && cf.patientSignature.startsWith("data:")) {
      try { doc.addImage(cf.patientSignature, "PNG", s1x + 3, y + 2, sigW - 6, sigH - 4); } catch (_) {}
    }
    doc.rect(s2x, y, sigW, sigH);
    if (cf.userSignature && cf.userSignature.startsWith("data:")) {
      try { doc.addImage(cf.userSignature, "PNG", s2x + 3, y + 2, sigW - 6, sigH - 4); } catch (_) {}
    }

    y += sigH;

    // underline + label below each box
    doc.setLineWidth(0.2);
    doc.line(s1x + 4, y + 5, s1x + sigW - 4, y + 5);
    doc.line(s2x + 4, y + 5, s2x + sigW - 4, y + 5);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(7.5);
    setGrey60();
    doc.text("Patient / Guardian Signature", s1x + sigW / 2, y + 9, { align: "center" });
    doc.text("Authorised Staff Signature",   s2x + sigW / 2, y + 9, { align: "center" });
    y += 16;

    // ── PREPARED BY (below signatures) ───────────────────────
    hrule(y, 0.2);
    y += 4;
    setGrey60();
    const createdParts = [
      cf.createdBy ? `Prepared by: ${cf.createdBy}` : "",
      cf.createdAt ? `Date: ${new Date(cf.createdAt).toLocaleString()}` : "",
    ].filter(Boolean);
    if (createdParts.length) {
      const createdLine = createdParts.join("     |     ");
      if (containsArabic(createdLine)) {
        drawBidiText(doc, createdLine, ml, y, { fontSize: 8 });
      } else {
        doc.setFont("helvetica", "italic");
        doc.setFontSize(8);
        doc.text(createdLine, ml, y);
      }
    }

    // ── FOOTER on every page ─────────────────────────────────
    const totalPages = doc.internal.getNumberOfPages();
    for (let p = 1; p <= totalPages; p++) {
      doc.setPage(p);
      hrule(ph - 13, 0.2);
      setGrey60();
      const fl = [businessOfficialName, businessAddress].filter(Boolean).join("  \u2022  ");
      const fr = [businessPhone, businessEmail].filter(Boolean).join("  \u2022  ");
      drawBidiText(doc, fl, ml, ph - 8, { fontSize: 7 });
      drawBidiText(doc, fr, pw - mr, ph - 8, { fontSize: 7, align: "right" });
      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      setGrey40();
      doc.text(`Page ${p} of ${totalPages}`, pw / 2, ph - 8, { align: "center" });
    }

    window.open(doc.output("bloburl"), "_blank");
  };

  const generateCustomFormPDF = (data) => {
    const cf = data || customForm;
    const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
    const pw = doc.internal.pageSize.getWidth();   // 210 mm
    const ph = doc.internal.pageSize.getHeight();  // 297 mm
    const ml = 20;
    const mr = 20;
    const cw = pw - ml - mr; // 170 mm
    let y = ml;

    // helpers
    const black  = [0, 0, 0];
    const grey60 = [100, 100, 100];
    const grey40 = [150, 150, 150];
    const setBlack  = () => doc.setTextColor(...black);
    const setGrey60 = () => doc.setTextColor(...grey60);
    const setGrey40 = () => doc.setTextColor(...grey40);
    const hrule = (yPos, lw = 0.25) => {
      doc.setDrawColor(...black);
      doc.setLineWidth(lw);
      doc.line(ml, yPos, pw - mr, yPos);
    };
    const stripHtml = (html) => {
      if (!html) return "";
      return html
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<\/p>/gi, "\n\n")
        .replace(/<\/li>/gi, "\n")
        .replace(/<li[^>]*>/gi, "  • ")
        .replace(/<\/h[1-6]>/gi, "\n")
        .replace(/<[^>]+>/g, "")
        .replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">")
        .replace(/&nbsp;/g, " ").replace(/&quot;/g, '"').replace(/&#39;/g, "'")
        .replace(/\n{3,}/g, "\n\n").trim();
    };

    // continuation-page mini header
    const miniHeader = () => {
      setGrey60();
      drawBidiText(doc, businessOfficialName || "Medical Center", ml, 12, { fontSize: 8, bold: true });
      drawBidiText(doc, cf.title || cf.templateName || "CUSTOM FORM", pw - mr, 12, { fontSize: 8, bold: true, align: "right" });
      hrule(14, 0.2);
    };

    // ── LETTERHEAD ───────────────────────────────────────────
    // Logo with correct proportions
    const maxLogoH = 22;
    const maxLogoW = 40;
    let logoSrc = null;
    try {
      logoSrc = (businessLogo && businessLogo.startsWith("data:image/")) ? businessLogo : logo1;
      const props = doc.getImageProperties(logoSrc);
      const ratio = props.width / props.height;
      let lw = maxLogoW;
      let lh = lw / ratio;
      if (lh > maxLogoH) { lh = maxLogoH; lw = lh * ratio; }
      doc.addImage(logoSrc, "PNG", ml, y, lw, lh);
      // business name vertically centred against logo height
      const textX = ml + lw + 7;
      setBlack();
      drawBidiText(doc, businessOfficialName || "Medical Center", textX, y + lh / 2 + 2, { fontSize: 13, bold: true });
      y += lh + 6;
    } catch (_) {
      // fallback: no logo
      setBlack();
      drawBidiText(doc, businessOfficialName || "Medical Center", ml, y + 8, { fontSize: 13, bold: true });
      y += 16;
    }

    // single rule under letterhead
    hrule(y, 0.4);
    y += 7;

    // ── DOCUMENT TITLE ───────────────────────────────────────
    setBlack();
    drawBidiText(doc, cf.title || cf.templateName || "CUSTOM FORM", pw / 2, y, { fontSize: 14, bold: true, align: "center" });
    y += 5;
    hrule(y, 0.25);
    y += 5;

    // ── PATIENT DETAILS (plain inline, no table) ─────────────
    doc.setFontSize(9);
    // row 1
    doc.setFont("helvetica", "bold"); setGrey60();
    doc.text("Patient Name:", ml, y);
    setBlack();
    drawBidiText(doc, cf.patientName || "—", ml + 30, y, { fontSize: 9 });
    doc.setFont("helvetica", "bold"); setGrey60();
    doc.text("File No.:", ml + cw / 2, y);
    doc.setFont("helvetica", "normal"); setBlack();
    doc.text(cf.fileNo || "—", ml + cw / 2 + 20, y);
    y += 6;
    // row 2
    doc.setFont("helvetica", "bold"); setGrey60();
    doc.text("CPR / ID No.:", ml, y);
    doc.setFont("helvetica", "normal"); setBlack();
    doc.text(cf.cprNo || "—", ml + 30, y);
    doc.setFont("helvetica", "bold"); setGrey60();
    doc.text("Age / Sex:", ml + cw / 2, y);
    doc.setFont("helvetica", "normal"); setBlack();
    doc.text(cf.ageSex || "—", ml + cw / 2 + 20, y);
    y += 9;
    hrule(y, 0.2);
    y += 10; // top margin before paragraph

    // ── FORM BODY TEXT ────────────────────────────────────────
    const contentText = stripHtml(cf.content);
    const lh = 5.5;
    setBlack();
    y = drawBidiParagraphs(doc, contentText, {
      x: ml,
      maxWidth: cw,
      lineHeight: lh,
      fontSize: 10,
      startY: y,
      onBeforeLine: (d, yPos) => {
        if (yPos + lh > ph - 28) {
          d.addPage();
          miniHeader();
          return 20;
        }
        return yPos;
      },
    });
    y += 10; // bottom margin after paragraph

    // ── PREPARED BY ────────────────────────────────────────────
    if (y + 12 > ph - 18) {
      doc.addPage();
      miniHeader();
      y = 20;
    }
    hrule(y, 0.2);
    y += 4;
    setGrey60();
    const createdParts = [
      cf.createdBy ? `Prepared by: ${cf.createdBy}` : "",
      cf.createdAt ? `Date: ${new Date(cf.createdAt).toLocaleString()}` : "",
    ].filter(Boolean);
    if (createdParts.length) {
      const createdLine = createdParts.join("     |     ");
      if (containsArabic(createdLine)) {
        drawBidiText(doc, createdLine, ml, y, { fontSize: 8 });
      } else {
        doc.setFont("helvetica", "italic");
        doc.setFontSize(8);
        doc.text(createdLine, ml, y);
      }
    }

    // ── FOOTER on every page ─────────────────────────────────
    const totalPages = doc.internal.getNumberOfPages();
    for (let p = 1; p <= totalPages; p++) {
      doc.setPage(p);
      hrule(ph - 13, 0.2);
      setGrey60();
      const fl = [businessOfficialName, businessAddress].filter(Boolean).join("  •  ");
      const fr = [businessPhone, businessEmail].filter(Boolean).join("  •  ");
      drawBidiText(doc, fl, ml, ph - 8, { fontSize: 7 });
      drawBidiText(doc, fr, pw - mr, ph - 8, { fontSize: 7, align: "right" });
      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      setGrey40();
      doc.text(`Page ${p} of ${totalPages}`, pw / 2, ph - 8, { align: "center" });
    }

    window.open(doc.output("bloburl"), "_blank");
  };

  // generate form
  const generateForm = (form) => {
    if (!form || !form.data) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No form data available to generate PDF.",
      });
      return;
    }

    // Handle Medical Certificate with pdfImg2 template
    if (form.type === "medicalCertificate") {
      generateMedicalCertificatePrint(form.data);
      return;
    }

    if (form.type === "sickLeave") {
      generateSickLeavePrint(form.data);
      return;
    }

    if (form.type === "accompanyingCertificate") {
      generateMedicalCertificatePDF(form.data);
      return;
    }

    // Handle Health Fitness Certificate
    if (form.type === "healthFitnessCertificate") {
      generateHealthFitnessPDF(form.data);
      return;
    }

    if (form.type === "houseMaidHealthCheckup") {
      houseGenerate(form.data);
      return;
    }

    // Handle Consent Form
    if (form.type === "consent") {
      generateConsentPDF(form.data);
      return;
    }

    // Handle Custom Form
    if (form.type === "customform") {
      generateCustomFormPDF(form.data);
      return;
    }

    // Handle Referral Form
    if (form.type === "referral") {
      generateReferralPDF(form.data);
      return;
    }

    const formData = form.data;

    const doc = new jsPDF({
      orientation: "portrait",
      unit: "px",
      format: "a4",
    });

    // Add background image (full page)
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    doc.addImage(pdfImg, "JPEG", 0, 0, pageWidth, pageHeight);

    //  logo sec
    doc.setFillColor(255, 255, 255);
    doc.rect(10, 10, 50, 30, "F");
    const addLogo = (imgData, y) => {
      const imgProps = doc.getImageProperties(imgData);
      const pageWidth = doc.internal.pageSize.getWidth();
      let imgWidth = imgProps.width;
      let imgHeight = imgProps.height;

      // Maximum dimensions
      const maxWidth = pageWidth - 100; // 20px margin each side
      const maxHeight = 30; // fixed max height

      // Calculate ratios
      const widthRatio = maxWidth / imgWidth;
      const heightRatio = maxHeight / imgHeight;
      const ratio = Math.min(widthRatio, heightRatio);

      // Scale image
      const finalWidth = imgWidth * ratio;
      const finalHeight = imgHeight * ratio;

      // Center horizontally
      const centeredX = 20;

      doc.addImage(
        imgData,
        (imgProps.fileType || "PNG").toUpperCase(),
        centeredX,
        10,
        finalWidth,
        finalHeight,
        undefined,
        "NONE"
      );
    };

    try {
      if (
        businessLogo &&
        typeof businessLogo === "string" &&
        businessLogo.startsWith("data:image/") &&
        businessLogo.includes("base64")
      ) {
        addLogo(businessLogo, 20);
      } else {
        throw new Error("Invalid logo format");
      }
    } catch (err) {
      console.warn(err.message);
      addLogo(logo1, 20);
    }
    doc.setFillColor(255, 255, 255);
    doc.rect(86, 63.5, 122, 12, "F");

    doc.setTextColor(0, 0, 0);
    doc.setFontSize(11);
    // Dynamic Patient Name
    doc.setFillColor(255, 255, 255);
    doc.rect(83, 59.5, 150, 20, "F");
    doc.text(formData.patientName || "", 87, 78);

    // Dynamic File Number
    doc.setFillColor(255, 255, 255);
    doc.rect(pageWidth - 120, 59.5, 115, 20, "F");
    doc.text(formData.fileNo?.toString() || "", pageWidth - 115, 78);

    // Dynamic Date
    doc.setFillColor(255, 255, 255);
    doc.rect(55, 81, 130, 20, "F");
    doc.text(formData.date || "", 55, 98);

    // Dynamic CPR Number
    doc.setFillColor(255, 255, 255);
    doc.rect(pageWidth - 120, 81, 130, 20, "F");
    doc.text(formData.cprNo || "", pageWidth - 120, 98);

    // Dynamic Physician
    doc.setFillColor(255, 255, 255);
    doc.rect(68, 102, 130, 18, "F");
    doc.text(formData.physician || "", 73, 118);

    // Dynamic Age/Sex
    doc.setFillColor(255, 255, 255);
    doc.rect(pageWidth - 125, 102, 130, 20, "F");
    doc.text(formData.ageSex || "", pageWidth - 120, 118);
    // bottom - Physician's Recommendation (Dynamic)

    const recommendationText =
      formData.recommendation || "No recommendation provided.";

    const leftMargin = 27;
    const rightMargin = 20;
    const textWidth = pageWidth - leftMargin - rightMargin;

    const lines = doc.splitTextToSize(recommendationText, textWidth);

    const fontSize = 11;
    const lineHeight = 1.9;
    let y = 246;

    doc.setFontSize(fontSize);

    // draw wrapped text with spacing between lines
    lines.forEach((line) => {
      doc.text(line, leftMargin, y);
      y += fontSize * lineHeight;
    });

    // Patient Signature Section
    doc.setFillColor(255, 255, 255);
    doc.rect(25, 512, 130, 17, "F");
    doc.text(formData.patientSignature || "", 28, 527);

    doc.setFillColor(255, 255, 255);
    doc.rect(235, 512, 130, 17, "F");
    doc.text(formData.patientSignatureDate || "", 238, 527);

    // Witness Section
    doc.setFillColor(255, 255, 255);
    doc.rect(30, 554, 150, 12, "F");
    doc.text(formData.witnessSignature || "", 28, 567);

    doc.setFillColor(255, 255, 255);
    doc.rect(239, 551, 130, 20, "F");
    doc.text(formData.witnessSignatureDate || "", 238, 567);
    const pdfBlob = doc.output("bloburl");
    window.open(pdfBlob, "_blank");
  };

  const houseGenerate = (originalFormData) => {
    // Override doctor info with logged in user
    let formData = { ...originalFormData };
    const doctorInfo = getLoggedInDoctorInfo();
    if (doctorInfo.name && !formData.doctorName) {
      formData.doctorName = doctorInfo.name;
    }
    if (doctorInfo.license && !formData.examinerLicense) {
      formData.examinerLicense = doctorInfo.license;
    }
    if (doctorInfo.name && !formData.examinerName) {
      formData.examinerName = doctorInfo.name;
    }

    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });
    // Add background image (full page)
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    doc.addImage(pdfHouse, "JPEG", 0, 0, pageWidth, pageHeight);
    doc.setFillColor(255, 255, 255);
    // Rectangle
    doc.rect(80, 15, 60, 10, "F");

    // Logo section
    // logo part
    const PX_TO_MM = 0.264583;

    const addLogo = (imgData, yMm) => {
      const imgProps = doc.getImageProperties(imgData);

      // Page width in mm
      const pageWidth = doc.internal.pageSize.getWidth();

      // Convert image size from px → mm
      let imgWidthMm = imgProps.width * PX_TO_MM;
      let imgHeightMm = imgProps.height * PX_TO_MM;

      // Max dimensions in mm
      const maxWidth = pageWidth - 40;
      const maxHeight = 15;

      // Scale ratio
      const widthRatio = maxWidth / imgWidthMm;
      const heightRatio = maxHeight / imgHeightMm;
      const ratio = Math.min(widthRatio, heightRatio, 1);

      // Final scaled size (mm)
      const finalWidth = imgWidthMm * ratio;
      const finalHeight = imgHeightMm * ratio;

      // Center horizontally (mm)
      const centeredX = (pageWidth - finalWidth) / 2;

      doc.addImage(
        imgData,
        (imgProps.fileType || "PNG").toUpperCase(),
        centeredX,
        5,
        finalWidth,
        finalHeight
      );
    };
    try {
      if (
        businessLogo &&
        typeof businessLogo === "string" &&
        businessLogo.startsWith("data:image/") &&
        businessLogo.includes("base64")
      ) {
        addLogo(businessLogo, 20);
      } else {
        throw new Error("Invalid logo format");
      }
    } catch (err) {
      console.warn(err.message);
      addLogo(logo1, 10);
    }

    // logo part end
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(10);

    // Patient Information
    doc.text(String(formData.patientName || ""), 37, 31.2);
    doc.text(String(formData.civilId || ""), 30, 36.7);
    doc.text(String(formData.mobileNumber || ""), 67, 36.7);

    doc.setFillColor(255, 255, 255);
    doc.rect(148, 33, 10, 5, "F");
    doc.text("CPR#:", 148, 36.5);
    doc.text(String(formData.height || ""), 109, 36.7);
    doc.text(String(formData.doctorName || ""), 118, 42);
    doc.text(String(formData.examinerLicense || ""), 160, 31.2);
    doc.text(String(formData.civilId || ""), 160, 36.7);

    // Vital Signs
    doc.text(String(formData.bloodPressure || ""), 15, 73);
    doc.text(String(formData.pulse || ""), 60, 73);
    doc.text(String(formData.heightCm || ""), 89, 73);
    doc.text(String(formData.weight || ""), 129, 73);
    doc.text(String(formData.bmi || ""), 180, 73);

    // Urine Examination
    doc.text(String(formData.albumin || ""), 60, 95.8);
    doc.text(String(formData.blood || ""), 60, 102);
    doc.text(String(formData.urineComments || ""), 58, 107.9);

    // Eye Examination - Vision Test
    // Right Eye - Readings column around x=120, Status around x=155
    doc.text(String(formData.rightEyeReadings || ""), 60, 95.7);
    doc.text(String(formData.rightEyeStatus || ""), 111, 95.7);

    // Left Eye
    doc.text(String(formData.leftEyeReadings || ""), 60, 102);
    doc.text(String(formData.leftEyeStatus || ""), 111, 101.5);

    // // Color Vision
    doc.text(String(formData.colorVisionReadings || ""), 60, 107.9);
    doc.text(String(formData.colorVisionStatus || ""), 111, 106.9);

    // Eye Comments
    doc.text(String(formData.eyeComment || ""), 60, 114);

    doc.setFillColor(255, 255, 255);
    doc.rect(90, 126, 80, 36, "F");
    doc.setFont("helvetica", "bold");
    doc.text("Normal / Abnormal", 70, 131.5);
    doc.text("Remark", 120, 131.5);

    doc.setFont("helvetica", "normal");
    const gap = 2;
    const row1Y = 135;
    const rowH = 5;

    doc.setDrawColor(0, 0, 0);
    doc.rect(70, row1Y, 40, rowH, "S");

    // Center label inside - General Appearance
    const normalLabelY = row1Y + rowH / 2 + 1;
    doc.text(
      String(formData.generalAppearanceStatus || "Normal"),
      72,
      normalLabelY
    );
    doc.setDrawColor(0, 0, 0);
    const rectY1 = 135;
    const rectH = 5;

    doc.rect(120, rectY1, 70, rectH, "S");

    // vertically center text inside first rectangle
    const textY1 = rectY1 + rectH / 2 + 1;
    doc.text(String(formData.generalAppearanceRemarks || ""), 122, textY1);

    const nextY = rectY1 + rectH + gap;
    const row2Y = row1Y + rowH + gap - 1;
    doc.rect(70, row2Y, 40, rowH, "S");
    doc.text(
      String(formData.generalAppearanceStatus || "Normal"),
      72,
      row2Y + rowH / 2 + 1
    );

    // Rectangle
    doc.rect(120, nextY, 70, 6, "S");
    const textY2 = nextY + rectH / 2 + 1;
    doc.text(String(formData.generalAppearanceRemarks || ""), 122, textY2 + 1);

    const row3Y = row2Y + rowH + gap + 3.5;
    doc.rect(70, row3Y, 40, rowH, "S");
    doc.text(
      String(formData.cardioAuscultationStatus || "Normal"),
      72,
      row3Y + rowH / 2 + 1
    );
    doc.rect(120, row3Y, 70, rowH, "S");

    const row4Y = row3Y + rowH + gap - 1;

    doc.rect(70, row4Y, 40, rowH, "S");
    doc.text(
      String(formData.respAuscultationStatus || "Normal"),
      72,
      row4Y + rowH / 2 + 1
    );

    doc.rect(120, row4Y, 70, rowH, "S");
    doc.text(
      String(formData.respAuscultationRemarks || ""),
      122,
      row4Y + rowH / 2 + 1
    );
    doc.text(
      String(formData.cardioAuscultationRemarks || ""),
      122,
      row3Y + rowH / 2 + 1
    );

    // Base positions
    const yesX = 60;
    const commentX = 139;

    const line1Y = 187; // Line 1
    const rowGap = 5.2; // renamed variable

    // Line 2, 3, 4 Y positions
    const line2Y = line1Y + rowGap;
    const line3Y = line1Y + rowGap * 2;
    const line4Y = line1Y + rowGap * 3;

    // -----------------
    // LINE 1 - Chest X-ray
    // -----------------
    doc.text(
      formData.chestXrayStatus === "normal" ? "Yes" : "No",
      yesX,
      line1Y
    );
    doc.text(String(formData.chestXrayRemarks || ""), commentX, line1Y);

    // -----------------
    // LINE 2 - Serology
    // -----------------
    doc.text(
      (formData.hivResult || "").toLowerCase().includes("positive") ||
        (formData.hbsagResult || "").toLowerCase().includes("positive") ||
        (formData.hcvResult || "").toLowerCase().includes("positive") ||
        (formData.vdrlResult || "").toLowerCase().includes("positive")
        ? "Yes"
        : "No",
      yesX,
      line2Y
    );
    doc.text(
      String((formData.hivResult || "") + " " + (formData.hivComments || "")),
      commentX,
      line2Y + 0.4
    );

    // -----------------
    // LINE 3 - Stool
    // -----------------
    doc.text(
      (formData.ovaParasitesStatus || "").toLowerCase().includes("present")
        ? "Yes"
        : "No",
      yesX,
      line3Y
    );
    doc.text(
      String(formData.ovaParasitesComments || ""),
      commentX,
      line3Y - 0.5
    );

    // -----------------
    // LINE 4 - Urine
    // -----------------
    // Sugar
    doc.text(
      (formData.urineSugarStatus || "").toLowerCase().includes("present")
        ? "Present"
        : "Absent",
      yesX,
      line4Y + 1
    );
    doc.text(String(formData.urineSugarComments || ""), commentX, line4Y + 2);

    // Albumin
    // We will not print Urine details here as per user request to move them down

    // Stool Present/Absent text below
    doc.text(
      (formData.ovaParasitesStatus || "").toLowerCase().includes("present")
        ? "Present"
        : "Absent",
      58,
      line4Y + 14.5
    ); //stool

    // white box for Treatment (Stool)
    doc.setFillColor(255, 255, 255);
    doc.rect(130, line4Y + 7, 80, 13, "F");

    // Show treatment details if parasites present
    if ((formData.ovaParasitesStatus || "").toLowerCase().includes("present")) {
      doc.setFont("helvetica", "bold");
      doc.text("Treatment Name", 93, line4Y + 8.5);
      doc.setFillColor(255, 255, 255);
      doc.setFont("helvetica", "normal");
      doc.rect(93, line4Y + 10, 40, 7, "FD");
      doc.text(
        String(formData.ovaParasitesTreatments || ""),
        95,
        line4Y + 14.5
      );
      doc.setFillColor(255, 255, 255);
      doc.setFont("helvetica", "bold");
      doc.text("Comment", 135, line4Y + 8.5);
      doc.setFont("helvetica", "normal");
      doc.setFillColor(255, 255, 255);
      doc.rect(135, line4Y + 10, 65, 7, "FD");
      doc.text(String(formData.ovaParasitesComments || ""), 137, line4Y + 14.5);
    }

    const newA = line4Y + 18;

    // Urine Examination Data (Dynamic)
    // Sugar
    doc.text(
      (formData.urineSugarStatus || "").toLowerCase().includes("present")
        ? "Present"
        : "Absent",
      58,
      newA + 11.5
    );
    doc.text(String(formData.urineSugarComments || ""), 140, newA + 11.5);

    // Albumin
    doc.text(
      (formData.urineAlbuminStatus || "").toLowerCase().includes("present")
        ? "Present"
        : "Absent",
      59,
      newA + 17
    );
    doc.text(String(formData.urineAlbuminComments || ""), 140, newA + 17);

    // Blood
    doc.text(
      (formData.urineBloodStatus || "").toLowerCase().includes("present")
        ? "Present"
        : "Absent",
      59,
      newA + 22.4
    );
    doc.text(String(formData.urineBloodComments || ""), 141, newA + 22.4);

    const lasty = newA + 35;
    doc.rect(45, lasty + 3, 130, 5);
    doc.text(String(formData.notes || ""), 48, lasty + 6.8);
    // fit/unfit
    doc.setFillColor(255, 255, 255);
    doc.rect(24, lasty + 11.5, 100, 5, "FD");
    doc.text(String(formData.result || ""), 26, lasty + 15.5);

    doc.text(String(formData.examinerName || ""), 26, lasty + 21.2);

    // Format date and time for display
    let dateTimeText = "";
    if (formData.examinerDateTime) {
      const dt = new Date(formData.examinerDateTime);
      const dateStr = dt.toLocaleDateString();
      const timeStr = dt.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
      dateTimeText = `${dateStr} ${timeStr}`;
    }

    doc.text(dateTimeText, 159, lasty + 21.2);

    const pdfBlob = doc.output("bloburl");
    window.open(pdfBlob, "_blank");
  };
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center p-3">
        <h5 className="mb-0">Patient Forms</h5>
        <button
          className="bgBtn btn-sm d-flex align-items-center gap-1"
          style={{ fontSize: 13, padding: "5px 12px" }}
          onClick={() => setShowAddFormModal(true)}
        >
          <FaPlus className="me-2" />
          Add Forms
        </button>
      </div>
      <div>
        {forms.length === 0 ? (
          <div className="text-center py-5">
            <p className="text-muted">No forms added yet</p>
          </div>
        ) : (
          <>
            <div className="table-responsive">
              <table className="table m-0">
                <thead>
                  <tr>
                    <th>Form Type</th>
                    <th>Created By</th>
                    <th>Created Date</th>
                    <th className="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {(() => {
                    const sortedForms = [...forms].sort(
                      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
                    );
                    const totalPages =
                      Math.ceil(sortedForms.length / formsPerPage) || 1;
                    const paginatedForms = sortedForms.slice(
                      (currentPage - 1) * formsPerPage,
                      currentPage * formsPerPage
                    );
                    return paginatedForms.map((form) => {
                      const isLocked = recordLockHours && form.createdAt
                        ? (Date.now() - new Date(form.createdAt).getTime()) > recordLockHours * 60 * 60 * 1000
                        : false
                      return (
                      <tr key={form.id}>
                        <td>
                          {form.type === "ama"
                            ? "Against Medical Advice"
                            : form.type === "medicalCertificate"
                              ? "Medical Certificate"
                              : form.type === "accompanyingCertificate"
                                ? "Accompanying Certificate"
                                : form.type === "referral"
                                  ? "Referral Form"
                                  : form.type === "healthFitnessCertificate"
                                    ? "Health Fitness Certificate"
                                    : form.type === "houseMaidHealthCheckup"
                                      ? "House Maid Health Checkup"
                                      : form.type === "sickLeave"
                                        ? "Sick Leave"
                                        : form.type === "consent"
                                          ? `Consent: ${form.data?.templateName || form.data?.title || "Consent Form"}`
                                          : form.type === "customform"
                                            ? `Custom Form: ${form.data?.templateName || form.data?.title || "Custom Form"}`
                                            : "Unknown Form"}
                        </td>
                        <td>{form.createdBy || "-"}</td>
                        <td>
                          {new Date(form.createdAt).toLocaleDateString()}
                        </td>
                        <td className="text-center">
                          <button
                            className="avtar avtar-xs btn-link-secondary viewIcon"
                            onClick={() => handleViewForm(form)}
                            title="View"
                          >
                            <i className="ti ti-eye f-20" />
                            <span>View</span>
                          </button>
                          <button
                            className="avtar avtar-xs btn-link-secondary editIcon"
                            onClick={isLocked ? undefined : () => handleEditForm(form)}
                            title={isLocked ? "Record is locked and cannot be edited" : "Edit"}
                            disabled={isLocked}
                            style={{ opacity: isLocked ? 0.4 : 1, cursor: isLocked ? 'not-allowed' : 'pointer' }}
                          >
                            <i className="ti ti-edit f-20" />
                            <span>Edit</span>
                          </button>
                          {isAdmin() && (
                            <button
                              className="avtar avtar-xs btn-link-secondary deleteIcon"
                              onClick={isLocked ? undefined : () => handleDeleteForm(form.id)}
                              title={isLocked ? "Record is locked and cannot be deleted" : "Delete"}
                              disabled={isLocked}
                              style={{ opacity: isLocked ? 0.4 : 1, cursor: isLocked ? 'not-allowed' : 'pointer' }}
                            >
                              <i className="ti ti-trash f-20" />
                              <span>Delete</span>
                            </button>
                          )}
                          <button
                            className="btn btn-sm deleteIcon"
                            onClick={() => generateForm(form)}
                            title="Download PDF"
                          >
                            <i className="ti ti-printer f-20" />
                            <span>Print</span>
                          </button>
                        </td>
                      </tr>
                    )})
                  })()}
                </tbody>
              </table>
            </div>
            {Math.ceil(forms.length / formsPerPage) > 1 && (
              <nav className="tablepagination d-flex justify-content-end mt-3 mb-2">
                <ul className="pagination mb-0">
                  <li
                    className={`page-item ${currentPage === 1 ? "disabled" : ""
                      }`}
                  >
                    <button
                      className="page-link"
                      onClick={() =>
                        currentPage > 1 && setCurrentPage(currentPage - 1)
                      }
                    >
                      &laquo;
                    </button>
                  </li>
                  <li className="pageNmbr">{`${currentPage} of ${Math.ceil(
                    forms.length / formsPerPage
                  )}`}</li>
                  <li
                    className={`page-item ${currentPage ===
                      Math.ceil(forms.length / formsPerPage)
                      ? "disabled"
                      : ""
                      }`}
                  >
                    <button
                      className="page-link"
                      onClick={() =>
                        currentPage <
                        Math.ceil(forms.length / formsPerPage) &&
                        setCurrentPage(currentPage + 1)
                      }
                    >
                      &raquo;
                    </button>
                  </li>
                </ul>
              </nav>
            )}
          </>
        )}
      </div>

      {showAddFormModal && (
        <div
          className="modal fade show"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)", display: "block" }}
          aria-modal="true"
        >
          <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 500 }}>
            <div className="modal-content">
              <div className="modal-header" style={{ background: "linear-gradient(135deg,#1a7e5a 0%,#2ca87f 100%)" }}>
                <h5 className="modal-title text-white d-flex align-items-center gap-2">
                  <i className="ti ti-file-plus f-18" />
                  Select Form Type
                </h5>
              </div>
              <div className="modal-body py-3 px-3">
                <div className="mb-0">
                  <label className="form-label mb-0" style={{ fontSize: 11 }}>
                    Choose Form Type <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select form-select-sm"
                    value={selectedFormType}
                    onChange={(e) => {
                      const formType = e.target.value;
                      if (formType) {
                        handleFormTypeSelect(formType);
                      }
                    }}
                  >
                    <option value="">Select Form Type</option>
                    {(() => {
                      const enabledForms = businessSetting?.enabled_forms;
                      const list = (enabledForms && Array.isArray(enabledForms))
                        ? formRegistry.filter((f) => enabledForms.includes(f.value))
                        : formRegistry;
                      return (
                        <>
                          {list.map((f) => (
                            <option key={f.value} value={f.value}>{f.label}</option>
                          ))}
                          {consentTemplates.length > 0 && (
                            <optgroup label="— Consents —">
                              {consentTemplates.map((t) => (
                                <option key={`consent_${t.id}`} value={`consent_${t.id}`}>{t.name}</option>
                              ))}
                            </optgroup>
                          )}
                          {customFormTemplates.length > 0 && (
                            <optgroup label="— Custom Forms —">
                              {customFormTemplates.map((t) => (
                                <option key={`customform_${t.id}`} value={`customform_${t.id}`}>{t.name}</option>
                              ))}
                            </optgroup>
                          )}
                        </>
                      );
                    })()}
                  </select>
                  <div className="form-text" style={{ fontSize: 11 }}>
                    Please select the type of form you want to create
                  </div>
                </div>
              </div>
              <div className="modal-footer d-flex justify-content-end">
                <button
                  type="button"
                  className="cancelText"
                  onClick={() => setShowAddFormModal(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── Consent Form Modal ── */}
      {showFormView && selectedFormType === "consent" && (
        <div
          className="modal fade show"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)", display: "block" }}
          aria-modal="true"
        >
          <div className="modal-dialog modal-dialog-scrollable" style={{ maxWidth: "860px" }}>
            <div className="modal-content">
              <div className="modal-header" style={{ background: "linear-gradient(135deg,#1a7e5a 0%,#2ca87f 100%)" }}>
                <h5 className="modal-title text-white d-flex align-items-center gap-2">
                  <i className="ti ti-file-description f-18" />
                  {isViewOnly ? "View" : editingFormId ? "Edit" : "Add"} Consent
                  {consentForm.templateName ? ` — ${consentForm.templateName}` : ""}
                </h5>
              </div>
              <div style={{ background: "#f0faf6", borderBottom: "1px solid #d1f0e5", padding: "8px 20px" }}>
                <div className="d-flex flex-wrap gap-3" style={{ fontSize: 13 }}>
                  <span><i className="ti ti-user text-success me-1" /><strong>Patient:</strong> {consentForm.patientName || "—"}</span>
                  <span><i className="ti ti-id text-success me-1" /><strong>File No.:</strong> {consentForm.fileNo || "—"}</span>
                  <span><i className="ti ti-address-book text-success me-1" /><strong>CPR No.:</strong> {consentForm.cprNo || "—"}</span>
                  <span><i className="ti ti-cake text-success me-1" /><strong>Age / Gender:</strong> {consentForm.ageSex || "—"}</span>
                  <span><i className="ti ti-stethoscope text-success me-1" /><strong>Prepared By:</strong> {consentForm.createdBy || "—"}</span>
                  <span><i className="ti ti-calendar text-success me-1" /><strong>Date:</strong> {consentForm.createdAt || "—"}</span>
                </div>
              </div>
              <div className="modal-body py-2 px-3">
                <fieldset disabled={isViewOnly}>
                  {/* Consent title */}
                  <div className="mb-2">
                    <label className="form-label mb-0" style={{ fontSize: 11 }}><i className="ti ti-heading me-1 text-muted" />Consent Title</label>
                    <input
                      type="text"
                      dir="auto"
                      className="form-control form-control-sm"
                      value={consentForm.title}
                      onChange={(e) => setConsentForm(prev => ({ ...prev, title: e.target.value }))}
                    />
                  </div>

                  {/* Consent content */}
                  <div className="mb-2">
                    <label className="form-label mb-0" style={{ fontSize: 11 }}><i className="ti ti-notes me-1 text-muted" />Content</label>
                    {isViewOnly ? (
                      <div
                        className="border rounded p-3 rtl-auto-content"
                        style={{ minHeight: 200, background: "#fafbfc", lineHeight: 1.7 }}
                        dangerouslySetInnerHTML={{ __html: consentForm.content }}
                      />
                    ) : (
                      <>
                        <div className="direction-toggle-bar">
                          <span style={{ fontSize: 11, color: "#5B6B79", marginRight: 4 }}>Direction:</span>
                          <button
                            type="button"
                            className={consentEditorDir === "ltr" ? "active" : ""}
                            onClick={() => { setBlockDirection(consentEditorInstanceRef.current, "ltr"); setConsentEditorDir("ltr"); }}
                          >
                            <i className="ti ti-align-left" /> LTR
                          </button>
                          <button
                            type="button"
                            className={consentEditorDir === "rtl" ? "active" : ""}
                            onClick={() => { setBlockDirection(consentEditorInstanceRef.current, "rtl"); setConsentEditorDir("rtl"); }}
                          >
                            <i className="ti ti-align-right" /> RTL
                          </button>
                          <button
                            type="button"
                            className={!consentEditorDir ? "active" : ""}
                            title="Auto-detect direction from text"
                            onClick={() => { setBlockDirection(consentEditorInstanceRef.current, null); setConsentEditorDir(null); }}
                          >
                            <i className="ti ti-wand" /> Auto
                          </button>
                        </div>
                        <textarea ref={consentEditorRef} />
                      </>
                    )}
                  </div>

                  {/* Signatures */}
                  <div className="row g-2">
                    <div className="col-md-6">
                      <label className="form-label mb-0" style={{ fontSize: 11 }}><i className="ti ti-signature me-1 text-muted" />Patient Signature</label>
                      {isViewOnly ? (
                        consentForm.patientSignature && consentForm.patientSignature.startsWith("data:") ? (
                          <img src={consentForm.patientSignature} alt="Patient Signature"
                            style={{ border: "1px solid #dee2e6", borderRadius: 6, width: "100%", background: "#fff", maxHeight: 120, objectFit: "contain" }} />
                        ) : (
                          <div className="border rounded p-2 text-muted" style={{ minHeight: 60, fontSize: 13 }}>No signature</div>
                        )
                      ) : (
                        <div style={{ border: "1px solid #dee2e6", borderRadius: 6, background: "#fff", position: "relative" }}>
                          <SignatureCanvas
                            ref={patientSigRef}
                            penColor="#1a237e"
                            canvasProps={{ width: 380, height: 120, style: { borderRadius: 6, width: "100%", height: 120 } }}
                          />
                          <button type="button"
                            onClick={() => patientSigRef.current?.clear()}
                            style={{ position: "absolute", top: 4, right: 6, fontSize: 11, padding: "1px 8px", background: "#f5f5f5", border: "1px solid #ccc", borderRadius: 4, cursor: "pointer" }}>
                            Clear
                          </button>
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="form-label mb-0" style={{ fontSize: 11 }}><i className="ti ti-signature me-1 text-muted" />Staff Signature</label>
                      {isViewOnly ? (
                        consentForm.userSignature && consentForm.userSignature.startsWith("data:") ? (
                          <img src={consentForm.userSignature} alt="Staff Signature"
                            style={{ border: "1px solid #dee2e6", borderRadius: 6, width: "100%", background: "#fff", maxHeight: 120, objectFit: "contain" }} />
                        ) : (
                          <div className="border rounded p-2 text-muted" style={{ minHeight: 60, fontSize: 13 }}>No signature</div>
                        )
                      ) : (
                        <div style={{ border: "1px solid #dee2e6", borderRadius: 6, background: "#fff", position: "relative" }}>
                          <SignatureCanvas
                            ref={userSigRef}
                            penColor="#1a237e"
                            canvasProps={{ width: 380, height: 120, style: { borderRadius: 6, width: "100%", height: 120 } }}
                          />
                          <button type="button"
                            onClick={() => userSigRef.current?.clear()}
                            style={{ position: "absolute", top: 4, right: 6, fontSize: 11, padding: "1px 8px", background: "#f5f5f5", border: "1px solid #ccc", borderRadius: 4, cursor: "pointer" }}>
                            Clear
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </fieldset>
              </div>
              <div className="modal-footer d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-sm d-flex align-items-center gap-1"
                  style={{ fontSize: 13, padding: "5px 16px", background: "#f1f3f5", color: "#495057", border: "1px solid #dee2e6", borderRadius: 6 }}
                  onClick={handleCloseFormView}
                >
                  <i className="ti ti-x" /> Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-sm d-flex align-items-center gap-1"
                  style={{ fontSize: 13, padding: "5px 16px", background: "#e8f0fe", color: "#1a3a70", border: "1px solid #bdd0f8", borderRadius: 6 }}
                  onClick={() => generateConsentPDF(consentForm)}
                >
                  <i className="fas fa-print" /> Print PDF
                </button>
                {!isViewOnly && (
                  <button
                    type="button"
                    className="btn btn-sm d-flex align-items-center gap-1"
                    style={{ fontSize: 13, padding: "5px 16px", background: "#2ca87f", color: "#fff", border: "1px solid #2ca87f", borderRadius: 6 }}
                    onClick={handleSaveForm}
                  >
                    <i className="ti ti-device-floppy" /> {editingFormId ? "Update Form" : "Save Form"}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── Custom Form Modal ── */}
      {showFormView && selectedFormType === "customform" && (
        <div
          className="modal fade show"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)", display: "block" }}
          aria-modal="true"
        >
          <div className="modal-dialog modal-dialog-scrollable" style={{ maxWidth: "860px" }}>
            <div className="modal-content">
              <div className="modal-header" style={{ background: "linear-gradient(135deg,#1a7e5a 0%,#2ca87f 100%)" }}>
                <h5 className="modal-title text-white d-flex align-items-center gap-2">
                  <i className="ti ti-file-text f-18" />
                  {isViewOnly ? "View" : editingFormId ? "Edit" : "Add"} Custom Form
                  {customForm.templateName ? ` — ${customForm.templateName}` : ""}
                </h5>
              </div>
              <div style={{ background: "#f0faf6", borderBottom: "1px solid #d1f0e5", padding: "8px 20px" }}>
                <div className="d-flex flex-wrap gap-3" style={{ fontSize: 13 }}>
                  <span><i className="ti ti-user text-success me-1" /><strong>Patient:</strong> {customForm.patientName || "—"}</span>
                  <span><i className="ti ti-id text-success me-1" /><strong>File No.:</strong> {customForm.fileNo || "—"}</span>
                  <span><i className="ti ti-address-book text-success me-1" /><strong>CPR No.:</strong> {customForm.cprNo || "—"}</span>
                  <span><i className="ti ti-cake text-success me-1" /><strong>Age / Gender:</strong> {customForm.ageSex || "—"}</span>
                  <span><i className="ti ti-stethoscope text-success me-1" /><strong>Prepared By:</strong> {customForm.createdBy || "—"}</span>
                  <span><i className="ti ti-calendar text-success me-1" /><strong>Date:</strong> {customForm.createdAt || "—"}</span>
                </div>
              </div>
              <div className="modal-body py-2 px-3">
                <fieldset disabled={isViewOnly}>
                  {/* Custom form title */}
                  <div className="mb-2">
                    <label className="form-label mb-0" style={{ fontSize: 11 }}><i className="ti ti-heading me-1 text-muted" />Form Title</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={customForm.title}
                      onChange={(e) => setCustomForm(prev => ({ ...prev, title: e.target.value }))}
                    />
                  </div>

                  {/* Custom form content */}
                  <div className="mb-2">
                    <label className="form-label mb-0" style={{ fontSize: 11 }}><i className="ti ti-notes me-1 text-muted" />Content</label>
                    {isViewOnly ? (
                      <div
                        className="border rounded p-3"
                        style={{ minHeight: 200, background: "#fafbfc", lineHeight: 1.7 }}
                        dangerouslySetInnerHTML={{ __html: customForm.content }}
                      />
                    ) : (
                      <textarea ref={customFormEditorRef} />
                    )}
                  </div>
                </fieldset>
              </div>
              <div className="modal-footer d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-sm d-flex align-items-center gap-1"
                  style={{ fontSize: 13, padding: "5px 16px", background: "#f1f3f5", color: "#495057", border: "1px solid #dee2e6", borderRadius: 6 }}
                  onClick={handleCloseFormView}
                >
                  <i className="ti ti-x" /> Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-sm d-flex align-items-center gap-1"
                  style={{ fontSize: 13, padding: "5px 16px", background: "#e8f0fe", color: "#1a3a70", border: "1px solid #bdd0f8", borderRadius: 6 }}
                  onClick={() => generateCustomFormPDF(customForm)}
                >
                  <i className="fas fa-print" /> Print PDF
                </button>
                {!isViewOnly && (
                  <button
                    type="button"
                    className="btn btn-sm d-flex align-items-center gap-1"
                    style={{ fontSize: 13, padding: "5px 16px", background: "#2ca87f", color: "#fff", border: "1px solid #2ca87f", borderRadius: 6 }}
                    onClick={handleSaveForm}
                  >
                    <i className="ti ti-device-floppy" /> {editingFormId ? "Update Form" : "Save Form"}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {showFormView && selectedFormType === "ama" && (
        <div
          className="modal fade show"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)", display: "block" }}
          aria-modal="true"
        >
          <div className="modal-dialog modal-dialog-scrollable" style={{ maxWidth: "1032px" }}>
            <div className="modal-content">
              <div className="modal-header" style={{ background: "#FFF8E1" }}>
                <h5 className="modal-title d-flex align-items-center gap-2" style={{ color: "#7A5C00" }}>
                  <i className="ti ti-file-alert f-18" />
                  {isViewOnly ? "View" : editingFormId ? "Edit" : "Add"} Against
                  Medical Advice - Acknowledgment and Waiver
                </h5>
              </div>
              <div className="modal-body">
                <fieldset disabled={isViewOnly}>
                  <AMAForm
                    formData={amaForm}
                    onChange={handleAmaFormChange}
                    isViewOnly={isViewOnly}
                    editingFormId={editingFormId}
                    shouldDisableField={shouldDisableField}
                    getFieldStyle={getFieldStyle}
                  />
                </fieldset>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="cancelText"
                  onClick={handleCloseFormView}
                >
                  Cancel
                </button>
                {!isViewOnly && (
                  <button
                    type="button"
                    className="bgBtn btn-sm"
                    style={{ fontSize: 13, padding: "5px 12px" }}
                    onClick={handleSaveForm}
                  >
                    {editingFormId ? "Update Form" : "Save Form"}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {showFormView && selectedFormType === "referral" && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          onClick={handleCloseFormView}
        >
          <div
            className="modal-dialog modal-xl modal-dialog-scrollable"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {isViewOnly ? "View" : editingFormId ? "Edit" : "Add"}{" "}
                  Referral Form
                </h5>
              </div>
              <div className="modal-body">
                <fieldset disabled={isViewOnly}>
                  <div className="row">
                    <div className="col-12">
                      <div className="separaterLine">
                        <h6>Patient Information</h6>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Name of the Patient</label>
                      <input
                        type="text"
                        className="form-control"
                        value={referralForm.patientName}
                        onChange={(e) =>
                          handleReferralFormChange(
                            "patientName",
                            e.target.value
                          )
                        }
                        disabled={shouldDisableField("referral", "patientName", referralForm.patientName)}
                        style={getFieldStyle("referral", "patientName", referralForm.patientName)}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">CPR</label>
                      <input
                        type="text"
                        className="form-control"
                        value={referralForm.cpr}
                        onChange={(e) =>
                          handleReferralFormChange("cpr", e.target.value)
                        }
                        disabled={shouldDisableField("referral", "cpr", referralForm.cpr)}
                        style={getFieldStyle("referral", "cpr", referralForm.cpr)}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Age</label>
                      <input
                        type="text"
                        className="form-control"
                        value={referralForm.age}
                        onChange={(e) =>
                          handleReferralFormChange("age", e.target.value)
                        }
                        disabled={shouldDisableField("referral", "age", referralForm.age)}
                        style={getFieldStyle("referral", "age", referralForm.age)}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Sex</label>
                      <select
                        className="form-select"
                        value={referralForm.sex}
                        onChange={(e) =>
                          handleReferralFormChange("sex", e.target.value)
                        }
                        disabled={shouldDisableField("referral", "sex", referralForm.sex)}
                        style={getFieldStyle("referral", "sex", referralForm.sex)}
                      >
                        <option value="">Select</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Nationality</label>
                      <input
                        type="text"
                        className="form-control"
                        value={referralForm.nationality}
                        onChange={(e) =>
                          handleReferralFormChange(
                            "nationality",
                            e.target.value
                          )
                        }
                        disabled={shouldDisableField("referral", "nationality", referralForm.nationality)}
                        style={getFieldStyle("referral", "nationality", referralForm.nationality)}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Phone No</label>
                      <input
                        type="text"
                        className="form-control"
                        value={referralForm.mobileNumber}
                        onChange={(e) =>
                          handleReferralFormChange("phoneNo", e.target.value)
                        }
                        disabled={shouldDisableField("referral", "mobileNumber", referralForm.mobileNumber)}
                        style={getFieldStyle("referral", "mobileNumber", referralForm.mobileNumber)}
                      />
                    </div>

                    <div className="col-12 mt-5">
                      <div className="separaterLine">
                        <h6>Referral Details</h6>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Referral Type</label>
                      <div className="d-flex gap-4">
                        <div className="me-2">
                          <input
                            type="radio"
                            name="referralType"
                            value="internal"
                            checked={referralForm.referralType === "internal"}
                            onChange={(e) =>
                              handleReferralFormChange(
                                "referralType",
                                e.target.value
                              )
                            }
                          />
                          <label className="form-check-label ms-2">
                            Internal
                          </label>
                        </div>
                        <div>
                          <input
                            type="radio"
                            name="referralType"
                            value="external"
                            checked={referralForm.referralType === "external"}
                            onChange={(e) =>
                              handleReferralFormChange(
                                "referralType",
                                e.target.value
                              )
                            }
                          />
                          <label className="form-check-label ms-2">
                            External
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Referral Category</label>
                      <div className="d-flex gap-4">
                        <div>
                          <input
                            type="radio"
                            name="referralCategory"
                            value="urgent"
                            checked={referralForm.referralCategory === "urgent"}
                            onChange={(e) =>
                              handleReferralFormChange(
                                "referralCategory",
                                e.target.value
                              )
                            }
                          />
                          <label className="form-check-label ms-2">
                            Urgent
                          </label>
                        </div>
                        <div>
                          <input
                            type="radio"
                            name="referralCategory"
                            value="routine"
                            checked={
                              referralForm.referralCategory === "routine"
                            }
                            onChange={(e) =>
                              handleReferralFormChange(
                                "referralCategory",
                                e.target.value
                              )
                            }
                          />
                          <label className="form-check-label ms-2">
                            Routine
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <label className="form-label">Reason of Referral</label>
                      <textarea
                        className="form-control"
                        rows="2"
                        value={referralForm.reasonOfReferral}
                        onChange={(e) =>
                          handleReferralFormChange(
                            "reasonOfReferral",
                            e.target.value
                          )
                        }
                      ></textarea>
                    </div>

                    <div className="col-12 mt-5">
                      <div className="separaterLine">
                        <h6>Medical History Data</h6>
                      </div>
                    </div>
                    {allMedicalRecords.length > 0 && (
                      <div className="col-12">
                        <div className="alert alert-info mb-0">
                          <label className="form-label fw-bold">
                            Select Date to Auto-Fill Medical Data:
                          </label>
                          <select
                            className="form-control mt-2"
                            value={selectedDate}
                            onChange={(e) => handleDateChange(e.target.value)}
                          >
                            <option value="">-- Select Date --</option>
                            {allMedicalRecords.map((record, index) => {
                              const recordDate = record.created_at
                                ? record.created_at.split("T")[0]
                                : "";
                              const displayDate = recordDate
                                ? new Date(recordDate).toLocaleDateString(
                                  "en-GB"
                                )
                                : "Unknown Date";
                              const vitals = record.vitals || {};
                              const chiefComplaint =
                                record.chief_complaint || "";
                              return (
                                <option key={index} value={recordDate}>
                                  {displayDate} - Chief Complaint:{" "}
                                  {chiefComplaint.substring(0, 30)}
                                  {chiefComplaint.length > 30 ? "..." : ""} |
                                  BP: {vitals.blood_pressure || ""}, Temp:{" "}
                                  {vitals.temperature || ""}°C
                                </option>
                              );
                            })}
                          </select>
                          <small className="text-muted mt-1 d-block">
                            Select a date to populate medical data including
                            vitals, diagnosis, prescriptions, and examination
                            details. All fields remain editable.
                          </small>
                        </div>
                      </div>
                    )}

                    <div className="col-12 mt-5">
                      <div className="separaterLine">
                        <h6>History</h6>
                      </div>
                    </div>
                    <div className="col-12">
                      <label className="form-label">Chief Complaint</label>
                      <textarea
                        className="form-control"
                        rows="2"
                        value={referralForm.chiefComplain}
                        onChange={(e) =>
                          handleReferralFormChange(
                            "chiefComplain",
                            e.target.value
                          )
                        }
                        disabled={shouldDisableField("referral", "chiefComplain", referralForm.chiefComplain)}
                        style={getFieldStyle("referral", "chiefComplain", referralForm.chiefComplain)}
                      ></textarea>
                    </div>
                    <div className="col-12">
                      <label className="form-label">
                        Summary of Presentation
                      </label>
                      <textarea
                        className="form-control"
                        rows="3"
                        value={referralForm.summaryOfPresentation}
                        onChange={(e) =>
                          handleReferralFormChange(
                            "summaryOfPresentation",
                            e.target.value
                          )
                        }
                      ></textarea>
                    </div>

                    <div className="col-12 mt-5">
                      <div className="separaterLine">
                        <h6>Physical Examination</h6>
                      </div>
                    </div>
                    <div className="col-12">
                      <label className="form-label">Vital Signs</label>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">BP</label>
                      <input
                        type="text"
                        className="form-control"
                        value={referralForm.vitalSigns.bp}
                        onChange={(e) =>
                          handleReferralFormChange(
                            "vitalSigns.bp",
                            e.target.value
                          )
                        }
                        disabled={shouldDisableField("referral", "vitalSigns.bp", referralForm.vitalSigns.bp)}
                        style={getFieldStyle("referral", "vitalSigns.bp", referralForm.vitalSigns.bp)}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Temperature</label>
                      <input
                        type="text"
                        className="form-control"
                        value={referralForm.vitalSigns.temperature}
                        onChange={(e) =>
                          handleReferralFormChange(
                            "vitalSigns.temperature",
                            e.target.value
                          )
                        }
                        disabled={shouldDisableField("referral", "vitalSigns.temperature", referralForm.vitalSigns.temperature)}
                        style={getFieldStyle("referral", "vitalSigns.temperature", referralForm.vitalSigns.temperature)}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Pulse</label>
                      <input
                        type="text"
                        className="form-control"
                        value={referralForm.vitalSigns.pulse}
                        onChange={(e) =>
                          handleReferralFormChange(
                            "vitalSigns.pulse",
                            e.target.value
                          )
                        }
                        disabled={shouldDisableField("referral", "vitalSigns.pulse", referralForm.vitalSigns.pulse)}
                        style={getFieldStyle("referral", "vitalSigns.pulse", referralForm.vitalSigns.pulse)}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Weight</label>
                      <input
                        type="text"
                        className="form-control"
                        value={referralForm.vitalSigns.weight}
                        onChange={(e) =>
                          handleReferralFormChange(
                            "vitalSigns.weight",
                            e.target.value
                          )
                        }
                        disabled={shouldDisableField("referral", "vitalSigns.weight", referralForm.vitalSigns.weight)}
                        style={getFieldStyle("referral", "vitalSigns.weight", referralForm.vitalSigns.weight)}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">RBS</label>
                      <input
                        type="text"
                        className="form-control"
                        value={referralForm.vitalSigns.rbs}
                        onChange={(e) =>
                          handleReferralFormChange(
                            "vitalSigns.rbs",
                            e.target.value
                          )
                        }
                        disabled={shouldDisableField("referral", "vitalSigns.rbs", referralForm.vitalSigns.rbs)}
                        style={getFieldStyle("referral", "vitalSigns.rbs", referralForm.vitalSigns.rbs)}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Respiratory Rate</label>
                      <input
                        type="text"
                        className="form-control"
                        value={referralForm.vitalSigns.respiratoryRate}
                        onChange={(e) =>
                          handleReferralFormChange(
                            "vitalSigns.respiratoryRate",
                            e.target.value
                          )
                        }
                        disabled={shouldDisableField("referral", "vitalSigns.respiratoryRate", referralForm.vitalSigns.respiratoryRate)}
                        style={getFieldStyle("referral", "vitalSigns.respiratoryRate", referralForm.vitalSigns.respiratoryRate)}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">SpO2</label>
                      <input
                        type="text"
                        className="form-control"
                        value={referralForm.vitalSigns.spo2}
                        onChange={(e) =>
                          handleReferralFormChange(
                            "vitalSigns.spo2",
                            e.target.value
                          )
                        }
                        disabled={shouldDisableField("referral", "vitalSigns.spo2", referralForm.vitalSigns.spo2)}
                        style={getFieldStyle("referral", "vitalSigns.spo2", referralForm.vitalSigns.spo2)}
                      />
                    </div>

                    <div className="col-12 mt-3">
                      <label className="form-label">Glasgow Coma Scale</label>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Eye</label>
                      <input
                        type="text"
                        className="form-control"
                        value={referralForm.glasgowComaScale.eye}
                        onChange={(e) =>
                          handleReferralFormChange(
                            "glasgowComaScale.eye",
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Motor Response</label>
                      <input
                        type="text"
                        className="form-control"
                        value={referralForm.glasgowComaScale.motorResponse}
                        onChange={(e) =>
                          handleReferralFormChange(
                            "glasgowComaScale.motorResponse",
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Verbal Response</label>
                      <input
                        type="text"
                        className="form-control"
                        value={referralForm.glasgowComaScale.verbalResponse}
                        onChange={(e) =>
                          handleReferralFormChange(
                            "glasgowComaScale.verbalResponse",
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">
                        Total Score (out of 15)
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={referralForm.glasgowComaScale.totalScore}
                        onChange={(e) =>
                          handleReferralFormChange(
                            "glasgowComaScale.totalScore",
                            e.target.value
                          )
                        }
                      />
                    </div>

                    <div className="col-12">
                      <label className="form-label">General Examination</label>
                      <textarea
                        className="form-control"
                        rows="2"
                        value={referralForm.generalExamination}
                        onChange={(e) =>
                          handleReferralFormChange(
                            "generalExamination",
                            e.target.value
                          )
                        }
                        disabled={shouldDisableField("referral", "generalExamination", referralForm.generalExamination)}
                        style={getFieldStyle("referral", "generalExamination", referralForm.generalExamination)}
                      ></textarea>
                    </div>
                    <div className="col-12">
                      <label className="form-label">Local Examination</label>
                      <textarea
                        className="form-control"
                        rows="2"
                        value={referralForm.localExamination}
                        onChange={(e) =>
                          handleReferralFormChange(
                            "localExamination",
                            e.target.value
                          )
                        }
                        disabled={shouldDisableField("referral", "localExamination", referralForm.localExamination)}
                        style={getFieldStyle("referral", "localExamination", referralForm.localExamination)}
                      ></textarea>
                    </div>

                    <div className="col-12 mt-5">
                      <div className="separaterLine">
                        <h6>Investigations & Treatment</h6>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <label className="form-label">Investigations Done</label>
                      <textarea
                        className="form-control"
                        rows="2"
                        value={referralForm.investigationsDone}
                        onChange={(e) =>
                          handleReferralFormChange(
                            "investigationsDone",
                            e.target.value
                          )
                        }
                      ></textarea>
                    </div>
                    <div className="col-lg-6">
                      <label className="form-label">
                        Procedure & Interventions Provided
                      </label>
                      <textarea
                        className="form-control"
                        rows="2"
                        value={referralForm.procedureInterventions}
                        onChange={(e) =>
                          handleReferralFormChange(
                            "procedureInterventions",
                            e.target.value
                          )
                        }
                        disabled={shouldDisableField("referral", "procedureInterventions", referralForm.procedureInterventions)}
                        style={getFieldStyle("referral", "procedureInterventions", referralForm.procedureInterventions)}
                      ></textarea>
                    </div>
                    <div className="col-lg-6">
                      <label className="form-label">
                        Injections & Medications Given
                      </label>
                      <textarea
                        className="form-control"
                        rows="2"
                        value={referralForm.injectionsMedications}
                        onChange={(e) =>
                          handleReferralFormChange(
                            "injectionsMedications",
                            e.target.value
                          )
                        }
                      ></textarea>
                    </div>
                    <div className="col-lg-6">
                      <label className="form-label">
                        Prescription Given to the Patient
                      </label>
                      <textarea
                        className="form-control"
                        rows="2"
                        value={referralForm.prescriptionGiven}
                        onChange={(e) =>
                          handleReferralFormChange(
                            "prescriptionGiven",
                            e.target.value
                          )
                        }
                        disabled={shouldDisableField("referral", "prescriptionGiven", referralForm.prescriptionGiven)}
                        style={getFieldStyle("referral", "prescriptionGiven", referralForm.prescriptionGiven)}
                      ></textarea>
                    </div>
                    <div className="col-12">
                      <label className="form-label">Notes</label>
                      <textarea
                        className="form-control"
                        rows="2"
                        value={referralForm.notes}
                        onChange={(e) =>
                          handleReferralFormChange("notes", e.target.value)
                        }
                        disabled={shouldDisableField("referral", "notes", referralForm.notes)}
                        style={getFieldStyle("referral", "notes", referralForm.notes)}
                      ></textarea>
                    </div>
                    <div className="col-12">
                      <label className="form-label">Advices</label>
                      <textarea
                        className="form-control"
                        rows="2"
                        value={referralForm.advices}
                        onChange={(e) =>
                          handleReferralFormChange("advices", e.target.value)
                        }
                        disabled={shouldDisableField("referral", "advices", referralForm.advices)}
                        style={getFieldStyle("referral", "advices", referralForm.advices)}
                      ></textarea>
                    </div>

                    <div className="col-12 mt-5">
                      <div className="separaterLine">
                        <h6>Referring Doctor</h6>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={referralForm.referringDoctor.name}
                        onChange={(e) =>
                          handleReferralFormChange(
                            "referringDoctor.name",
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={referralForm.referringDoctor.date}
                        onChange={(e) =>
                          handleReferralFormChange(
                            "referringDoctor.date",
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Time</label>
                      <input
                        type="time"
                        className="form-control"
                        value={referralForm.referringDoctor.time}
                        onChange={(e) =>
                          handleReferralFormChange(
                            "referringDoctor.time",
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Phone Number</label>
                      <input
                        type="text"
                        className="form-control"
                        value={referralForm.referringDoctor.phoneNumber}
                        onChange={(e) =>
                          handleReferralFormChange(
                            "referringDoctor.phoneNumber",
                            e.target.value.replace(/\D/g, "")
                          )
                        }
                      />
                    </div>

                    <div className="col-12 mt-5">
                      <div className="separaterLine">
                        <h6>Receiving Doctor</h6>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={referralForm.receivingDoctor.name}
                        onChange={(e) =>
                          handleReferralFormChange(
                            "receivingDoctor.name",
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={referralForm.receivingDoctor.date}
                        onChange={(e) =>
                          handleReferralFormChange(
                            "receivingDoctor.date",
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Time</label>
                      <input
                        type="time"
                        className="form-control"
                        value={referralForm.receivingDoctor.time}
                        onChange={(e) =>
                          handleReferralFormChange(
                            "receivingDoctor.time",
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Phone Number</label>
                      <input
                        type="text"
                        className="form-control"
                        value={referralForm.receivingDoctor.phoneNumber}
                        onChange={(e) =>
                          handleReferralFormChange(
                            "receivingDoctor.phoneNumber",
                            e.target.value.replace(/\D/g, "")
                          )
                        }
                      />
                    </div>
                  </div>
                </fieldset>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="cancelText"
                  onClick={handleCloseFormView}
                >
                  Cancel
                </button>
                {!isViewOnly && (
                  <button
                    type="button"
                    className="bgBtn btn-sm"
                    style={{ fontSize: 13, padding: "5px 12px" }}
                    onClick={handleSaveForm}
                  >
                    Save Form
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {showFormView && (selectedFormType === "medicalCertificate" || selectedFormType === "accompanyingCertificate") && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          onClick={handleCloseFormView}
        >
          <div
            className="modal-dialog modal-xl modal-dialog-scrollable"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {isViewOnly ? "View" : editingFormId ? "Edit" : "Add"} {selectedFormType === "accompanyingCertificate" ? "Accompanying Certificate" : "Medical Certificate"}
                </h5>
              </div>
              <div className="modal-body py-3">
                <fieldset disabled={isViewOnly}>
                  <div className="row g-2">
                    {!isViewOnly && (
                      <div className="col-12 mb-1">
                        <div className="d-flex flex-column align-items-center justify-content-center border rounded py-2 px-2" style={{ background: "#f8f9fa" }}>
                          <span className="small text-muted mb-1">Quick Fill</span>
                          <div className="btn-group" role="group">
                            {[1, 2, 3].map((days) => (
                              <button
                                key={days}
                                type="button"
                                className="btn btn-outline-primary btn-sm"
                                onClick={() => applyMedicalCertificateQuickDays(days)}
                              >
                                {days} Day{days > 1 ? "s" : ""}
                              </button>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="col-12 mt-1">
                      <h6 className="border-bottom pb-1 mb-1 small text-uppercase text-muted fw-bold">
                        Patient Information
                      </h6>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label small mb-1">Patient Name</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={medicalCertificateForm.patientName}
                        onChange={(e) =>
                          handleMedicalCertificateFormChange(
                            "patientName",
                            e.target.value
                          )
                        }
                        disabled={shouldDisableField(selectedFormType, "patientName", medicalCertificateForm.patientName)}
                        style={getFieldStyle(selectedFormType, "patientName", medicalCertificateForm.patientName)}
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label small mb-1">CPR Number</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={medicalCertificateForm.cprNumber}
                        onChange={(e) =>
                          handleMedicalCertificateFormChange(
                            "cprNumber",
                            e.target.value
                          )
                        }
                        disabled={shouldDisableField(selectedFormType, "cprNumber", medicalCertificateForm.cprNumber)}
                        style={getFieldStyle(selectedFormType, "cprNumber", medicalCertificateForm.cprNumber)}
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label small mb-1">
                        Medical Record Number
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={medicalCertificateForm.medicalRecordNumber}
                        onChange={(e) =>
                          handleMedicalCertificateFormChange(
                            "medicalRecordNumber",
                            e.target.value
                          )
                        }
                        disabled={shouldDisableField(selectedFormType, "medicalRecordNumber", medicalCertificateForm.medicalRecordNumber)}
                        style={getFieldStyle(selectedFormType, "medicalRecordNumber", medicalCertificateForm.medicalRecordNumber)}
                      />
                    </div>

                    <div className="col-12 mt-2">
                      <h6 className="border-bottom pb-1 mb-1 small text-uppercase text-muted fw-bold">Patient Status</h6>
                    </div>
                    <div className="col-md-6">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={medicalCertificateForm.reportedSick}
                          onChange={(e) =>
                            handleMedicalCertificateFormChange(
                              "reportedSick",
                              e.target.checked
                            )
                          }
                        />
                        <label className="form-check-label small">
                          Reported Sick
                        </label>
                      </div>
                    </div>

                    {/* Conditional fields for accompanying person details */}
                    {selectedFormType === "accompanyingCertificate" && (
                      <>
                        <div className="col-12 mt-2">
                          <h6 className="border-bottom pb-1 mb-1 small text-uppercase text-muted fw-bold">Accompanying Person Details</h6>
                        </div>
                        <div className="col-md-6">
                          <label className="form-label small mb-1">
                            Accompanying Person Name
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            value={
                              medicalCertificateForm.accompanyingPersonName
                            }
                            onChange={(e) =>
                              handleMedicalCertificateFormChange(
                                "accompanyingPersonName",
                                e.target.value
                              )
                            }
                            placeholder="Enter name"
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label small mb-1">
                            Accompanying Person Civil ID
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            value={medicalCertificateForm.accompanyingPersonId}
                            onChange={(e) =>
                              handleMedicalCertificateFormChange(
                                "accompanyingPersonId",
                                e.target.value
                              )
                            }
                            placeholder="Enter civil ID"
                          />
                        </div>
                      </>
                    )}

                    <div className="col-12 mt-2">
                      <h6 className="border-bottom pb-1 mb-1 small text-uppercase text-muted fw-bold">
                        Consultation Details
                      </h6>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label small mb-1">Time of Attend</label>
                      <input
                        type="time"
                        className="form-control form-control-sm"
                        value={medicalCertificateForm.timeOfAttend}
                        onChange={(e) =>
                          handleMedicalCertificateFormChange(
                            "timeOfAttend",
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label small mb-1">Time of Consult</label>
                      <input
                        type="time"
                        className="form-control form-control-sm"
                        value={medicalCertificateForm.timeOfConsult}
                        onChange={(e) =>
                          handleMedicalCertificateFormChange(
                            "timeOfConsult",
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label small mb-1">Consult Date</label>
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        value={medicalCertificateForm.consultDate}
                        onChange={(e) =>
                          handleMedicalCertificateFormChange(
                            "consultDate",
                            e.target.value
                          )
                        }
                      />
                    </div>

                    <div className="col-12 mt-2">
                      <h6 className="border-bottom pb-1 mb-1 small text-uppercase text-muted fw-bold">Fitness Assessment</h6>
                    </div>
                    <div className="col-md-4">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={medicalCertificateForm.patientFitForDuty}
                          onChange={(e) =>
                            handleMedicalCertificateFormChange(
                              "patientFitForDuty",
                              e.target.checked
                            )
                          }
                        />
                        <label className="form-check-label small">
                          Patient Fit for Duty
                        </label>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={medicalCertificateForm.patientUnfitForDuty}
                          onChange={(e) =>
                            handleMedicalCertificateFormChange(
                              "patientUnfitForDuty",
                              e.target.checked
                            )
                          }
                        />
                        <label className="form-check-label small">
                          Patient Unfit for Duty
                        </label>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={medicalCertificateForm.advisedLightDuty}
                          onChange={(e) =>
                            handleMedicalCertificateFormChange(
                              "advisedLightDuty",
                              e.target.checked
                            )
                          }
                        />
                        <label className="form-check-label small">
                          Advised Light Duty
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={
                            medicalCertificateForm.patientNeedsEmployeeCare
                          }
                          onChange={(e) =>
                            handleMedicalCertificateFormChange(
                              "patientNeedsEmployeeCare",
                              e.target.checked
                            )
                          }
                        />
                        <label className="form-check-label small">
                          Patient Needs Employee Care
                        </label>
                      </div>
                    </div>

                    <div className="col-12 mt-2">
                      <h6 className="border-bottom pb-1 mb-1 small text-uppercase text-muted fw-bold">Leave Details</h6>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label small mb-1">
                        No. of Days Off (Figures)
                      </label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        value={medicalCertificateForm.noOfDaysOffFigures}
                        onChange={(e) =>
                          handleMedicalCertificateFormChange(
                            "noOfDaysOffFigures",
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label small mb-1">
                        No. of Days Off (Words)
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={medicalCertificateForm.noOfDaysOffWords}
                        readOnly
                        placeholder="Auto-filled from figures"
                        style={{ background: "#f8f9fa" }}
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label small mb-1">Commencing On</label>
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        value={medicalCertificateForm.commencingOn}
                        onChange={(e) =>
                          handleMedicalCertificateFormChange(
                            "commencingOn",
                            e.target.value
                          )
                        }
                      />
                    </div>

                    <div className="col-12 mt-2">
                      <h6 className="border-bottom pb-1 mb-1 small text-uppercase text-muted fw-bold">Hospital Admission</h6>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label small mb-1">Admitted On</label>
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        value={medicalCertificateForm.admittedOn}
                        onChange={(e) =>
                          handleMedicalCertificateFormChange(
                            "admittedOn",
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label small mb-1">Discharged On</label>
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        value={medicalCertificateForm.dischargedOn}
                        onChange={(e) =>
                          handleMedicalCertificateFormChange(
                            "dischargedOn",
                            e.target.value
                          )
                        }
                      />
                    </div>

                    <div className="col-12 mt-2">
                      <h6 className="border-bottom pb-1 mb-1 small text-uppercase text-muted fw-bold">Diagnosis</h6>
                    </div>
                    <div className="col-12">
                      <label className="form-label small mb-1">Diagnosis</label>
                      <div className="position-relative">
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          value={diagnosisSearch}
                          onChange={(e) => {
                            setDiagnosisSearch(e.target.value);
                            setShowDiagnosisDropdown(true);
                          }}
                          onFocus={() => setShowDiagnosisDropdown(true)}
                          placeholder="Search diagnosis or type manually..."
                        />
                        {/* Dropdown same as before */}
                        {showDiagnosisDropdown && filteredDiagnosisOptions.length > 0 && (
                          <div
                            className="position-absolute w-100 bg-white border rounded shadow-sm"
                            style={{
                              maxHeight: "200px",
                              overflowY: "auto",
                              zIndex: 1000,
                              top: "100%",
                            }}
                          >
                            {filteredDiagnosisOptions.map((option, index) => (
                              <div
                                key={index}
                                className="p-2 cursor-pointer hover-bg-light small"
                                style={{ cursor: "pointer" }}
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => {
                                  const selectedText = option.diagnosis_text || option.name || option.diagnosis || "";
                                  const selectedId = String(option.id || option.diagnosis_id || "");
                                  setMedicalCertificateForm(prev => {
                                    const existing = prev.diagnosis ? prev.diagnosis.trim() : "";
                                    const existingIds = prev.diagnosisId ? prev.diagnosisId.trim() : "";
                                    return {
                                      ...prev,
                                      diagnosis: existing ? `${existing}, ${selectedText}` : selectedText,
                                      diagnosisId: existingIds ? `${existingIds}, ${selectedId}` : selectedId,
                                    };
                                  });
                                  setDiagnosisSearch("");
                                  setShowDiagnosisDropdown(false);
                                }}
                              >
                                {option.diagnosis_text || option.name || option.diagnosis || "Unknown"}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                      {/* Selected diagnoses */}
                      <textarea
                        className="form-control form-control-sm mt-1"
                        rows="2"
                        value={medicalCertificateForm.diagnosis || ""}
                        onChange={(e) =>
                          setMedicalCertificateForm(prev => ({ ...prev, diagnosis: e.target.value }))
                        }
                        placeholder="Selected diagnoses will appear here (comma-separated)..."
                      />

                    </div>

                    <div className="col-12 mt-2">
                      <h6 className="border-bottom pb-1 mb-1 small text-uppercase text-muted fw-bold">Doctor Information</h6>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label small mb-1">Doctor's Name</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={medicalCertificateForm.doctorName}
                        onChange={(e) =>
                          handleMedicalCertificateFormChange(
                            "doctorName",
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label small mb-1">License No.</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={medicalCertificateForm.licenseNo}
                        onChange={(e) =>
                          handleMedicalCertificateFormChange(
                            "licenseNo",
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label small mb-1">Specialty</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={medicalCertificateForm.specialty}
                        onChange={(e) =>
                          handleMedicalCertificateFormChange(
                            "specialty",
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label small mb-1">Issue Date</label>
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        value={medicalCertificateForm.issueDate}
                        onChange={(e) =>
                          handleMedicalCertificateFormChange(
                            "issueDate",
                            e.target.value
                          )
                        }
                      />
                    </div>
                  </div>
                </fieldset>
              </div>
              <div className="modal-footer py-2">
                <button
                  type="button"
                  className="cancelText"
                  onClick={handleCloseFormView}
                >
                  Cancel
                </button>
                {!isViewOnly && (
                  <button
                    type="button"
                    className="bgBtn btn-sm d-flex align-items-center gap-1"
                    style={{ fontSize: 13, padding: "5px 12px" }}
                    onClick={handleSaveForm}
                  >
                    Save Certificate
                  </button>
                )}
              </div>
            </div>
          </div >
        </div >
      )
      }

      {/* Sick Leave Form Modal */}
      {showFormView && selectedFormType === "sickLeave" && (
        <div
          className="modal fade show"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)", display: "block" }}
          aria-modal="true"
        >
          <div className="modal-dialog modal-dialog-scrollable" style={{ maxWidth: "1032px" }}>
            <div className="modal-content">
              <div className="modal-header" style={{ background: "#FFF8E1" }}>
                <h5 className="modal-title d-flex align-items-center gap-2" style={{ color: "#7A5C00" }}>
                  <i className="ti ti-medical-cross f-18" />
                  {isViewOnly ? "View" : editingFormId ? "Edit" : "Add"} Sick Leave
                </h5>
              </div>
              <div className="modal-body py-2 px-3">
                <fieldset disabled={isViewOnly}>
                  <SickLeaveForm
                    formData={sickLeaveForm}
                    onChange={handleSickLeaveFormChange}
                    onQuickFillDays={applySickLeaveQuickDays}
                    isViewOnly={isViewOnly}
                    diagnosisSearch={diagnosisSearch}
                    onDiagnosisSearchChange={(val) => { setDiagnosisSearch(val); setShowDiagnosisDropdown(true); }}
                    showDiagnosisDropdown={showDiagnosisDropdown}
                    filteredDiagnosisOptions={filteredDiagnosisOptions}
                    onDiagnosisSelect={(option) => {
                      const selectedText = option.diagnosis_text || option.name || option.diagnosis || "";
                      const selectedId = String(option.id || option.diagnosis_id || "");
                      setSickLeaveForm(prev => {
                        const existing = prev.diagnosis ? prev.diagnosis.trim() : "";
                        const existingIds = prev.diagnosisId ? prev.diagnosisId.trim() : "";
                        return {
                          ...prev,
                          diagnosis: existing ? `${existing}, ${selectedText}` : selectedText,
                          diagnosisId: existingIds ? `${existingIds}, ${selectedId}` : selectedId,
                        };
                      });
                      setDiagnosisSearch("");
                      setShowDiagnosisDropdown(false);
                    }}
                    onDiagnosisDropdownToggle={setShowDiagnosisDropdown}
                    onDiagnosisTextChange={(val) => setSickLeaveForm(prev => ({ ...prev, diagnosis: val }))}
                    shouldDisableField={shouldDisableField}
                    getFieldStyle={getFieldStyle}
                  />
                </fieldset>
            </div>

            {/* Modal Footer */}
            <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", padding: "14px 24px", borderTop: "1px solid #e8ecf0" }}>
              <button
                type="button"
                onClick={handleCloseFormView}
                style={{
                  padding: "7px 16px", fontSize: 13, borderRadius: 8,
                  border: "1px solid #dde3eb", background: "#f8f9fb", color: "#5B6B79", cursor: "pointer",
                }}
              >
                Cancel
              </button>
              {!isViewOnly && (
                <button
                  type="button"
                  className="bgBtn btn-sm d-flex align-items-center gap-1"
                  style={{ fontSize: 13, padding: "7px 18px" }}
                  onClick={handleSaveForm}
                >
                  Save Sick Leave
                </button>
              )}
            </div>
            </div>
          </div>
        </div>
      )}

      {/* House Maid Health Checkup Form Modal */}
      {
        showFormView && selectedFormType === "houseMaidHealthCheckup" && (
          <div
            className="modal fade show"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
            onClick={handleCloseFormView}
          >
            <div
              className="modal-dialog modal-xl modal-dialog-scrollable"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    {isViewOnly ? "View" : editingFormId ? "Edit" : "Add"} House
                    Maid Health Checkup Certificate
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleCloseFormView}
                  ></button>
                </div>
                <div className="modal-body">
                  <fieldset disabled={isViewOnly}>
                    {allMedicalRecords.length > 0 && (
                      <div className="alert alert-info mb-3">
                        <label className="form-label fw-bold">
                          Select Date to Auto-Fill Vitals Data:
                        </label>
                        <select
                          className="form-control mt-2"
                          value={selectedDate}
                          onChange={(e) =>
                            handleHouseMaidDateChange(e.target.value)
                          }
                        >
                          <option value="">-- Select Date --</option>
                          {allMedicalRecords.map((record, index) => {
                            const recordDate = record.created_at
                              ? record.created_at.split("T")[0]
                              : "";
                            const displayDate = recordDate
                              ? new Date(recordDate).toLocaleDateString("en-GB")
                              : "Unknown Date";
                            const vitals = record.vitals || {};
                            return (
                              <option key={index} value={recordDate}>
                                {displayDate} - BP: {vitals.blood_pressure || ""},
                                Pulse: {vitals.pulse || ""}, Weight:{" "}
                                {vitals.weight || ""} kg
                              </option>
                            );
                          })}
                        </select>
                        <small className="text-muted mt-1 d-block">
                          Select a date to populate vitals data (Blood Pressure,
                          Pulse, Height, Weight, BMI). All fields remain editable.
                        </small>
                      </div>
                    )}
                    <HouseMaidHealthCheckupForm
                      formData={houseMaidHealthCheckupForm}
                      onChange={handleHouseMaidHealthCheckupFormChange}
                      isViewOnly={isViewOnly}
                      editingFormId={editingFormId}
                      shouldDisableField={shouldDisableField}
                      getFieldStyle={getFieldStyle}
                    />
                  </fieldset>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="cancelText"
                    onClick={handleCloseFormView}
                  >
                    Cancel
                  </button>
                  {!isViewOnly && (
                    <button
                      type="button"
                      className="bgBtn btn-sm"
                      style={{ fontSize: 13, padding: "5px 12px" }}
                      onClick={handleSaveForm}
                    >
                      {editingFormId ? "Update Form" : "Save Form"}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        )
      }
      {/* Health Fitness Certificate Form Modal */}

      {
        showFormView && selectedFormType === "healthFitnessCertificate" && (
          <div
            className="modal fade show"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
            onClick={handleCloseFormView}
          >
            <div
              className="modal-dialog modal-xl modal-dialog-scrollable"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    {isViewOnly ? "View" : editingFormId ? "Edit" : "Add"} Health
                    Fitness Certificate
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleCloseFormView}
                  ></button>
                </div>
                <div className="modal-body">
                  <fieldset disabled={isViewOnly}>
                    <HealthFitnessCertificateForm
                      formData={healthFitnessCertificateForm}
                      onChange={handleHealthFitnessCertificateFormChange}
                      isViewOnly={isViewOnly}
                      editingFormId={editingFormId}
                      shouldDisableField={shouldDisableField}
                      getFieldStyle={getFieldStyle}
                    />
                  </fieldset>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="cancelText"
                    onClick={handleCloseFormView}
                  >
                    Cancel
                  </button>
                  {!isViewOnly && (
                    <button
                      type="button"
                      className="bgBtn btn-sm"
                      style={{ fontSize: 13, padding: "5px 12px" }}
                      onClick={handleSaveForm}
                    >
                      {editingFormId ? "Update Form" : "Save Form"}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        )
      }
    </div >
  );
}
